/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
window.paceOptions = {
  ajax: false, // disabled
  document: false, // disabled
  eventLag: false, // disabled
  restartOnRequestAfter: false
};

//Retorna reputação do player para usar no SVG
function getPlayerReputation(percent) {
    return percent + " " + (100 - percent);
}

//Retorna a cor da reputação do player para usar no SVG
function getReputationColor(percent) {
    percent = parseInt(percent);

    if (percent < 51) {
        return '#550404';
    }

    if (percent < 66) {
        return '#FF0300';
    }

    if (percent < 71) {
        return '#EFA000';
    }

    if (percent < 86) {
        return '#EBD200';
    }
    return '#92AA00';
}

/**
 * Verifica instabilidade registrada na plataforma
 * @param {Function} callback Callback para a modal quando o user aceita jogar
 */
function verifyForInstability(callback)
{
    // Se não houver aviso chama automaticamente o callback
    callback();
    return false;
}

/**
 * Redireciona para url
 */
function redirectTo(url)
{
    return window.location.href = url;
}
var NotificationUI = {
  /**
         * Controla exibicao dos badges de notificacao
         */
  setNotificationFor: function (selector, count) {
    if (parseInt(count) != 0) {
      $(selector).show().html(count);
    } else {
      $(selector).hide().html('');
      $('.tournament-notification .menu-dropdown').removeClass('show');
      $('.tournament-notification .icon-dropdown').removeClass('active');
    }
  },

  /*
         * Faz o parse das notificacoes
         */
  parseNotificationCounters: function (data) {
    var notifications = parseInt(data.notificacoes);
    var messages = parseInt(data.msgs);
    var friends = parseInt(data.friends);

    if (
      typeof window.headerAppTransporter === 'object'
    ) {
      headerAppTransporter.setMessages(messages);
      headerAppTransporter.setNotifications(notifications);
    }

    this.setNotificationFor('.icon[data-target=notifications] .number', notifications);
    this.setNotificationFor('.icon[data-target=messages] .number', messages);
    this.setNotificationFor('.icon[data-target=friends] .number', friends);

    var number = notifications + messages + friends;

    if (parseInt(number) != 0 && !isNaN(number)) {
      document.title = '(' + number + ') ' + pagetitle;
    } else if (parseInt(number) == 0) {
      document.title = pagetitle;
    }

    if (notifications != 0) {
      $('.tournament-notification').css('display', 'block');
      $('.no-notification').hide();
    } else {
      $('.tournament-notification').css('display', 'none');
      $('.tournament-notification .menu-dropdown').removeClass('show');
      $('.tournament-notification .icon-dropdown').removeClass('active');
      $('.no-notification').show();
    }
  },

  resetNotificationList: function () {
    $('.no-notification').hide();
    $('ul.lista-notificacoes').html('');
    $('.tournament-notification').css('display', 'none');
  },

  showNotificationSpinner: function () {
    $('[data-dropdown="notifications"]').find('.loader-spin').show();
  },

  hideNotificationSpinner: function () {
    $('[data-dropdown="notifications"]').find('.loader-spin').hide();
  },

  /*
         * Renderiza a lista de notificacoes
         */
  renderNotificationList: function (json) {
    this.resetNotificationList();
    this.showNotificationSpinner();

    if (json.success) {
      $('li.notification-item, li.sem-notificacoes').remove();
      $('.no-notification').hide();
      $('.notificacoes-clearall').remove();

      if (json.html.length == '0') {
        $('.tournament-notification').css('display', 'none');
        $('.tournament-notification .menu-dropdown').removeClass('show');
        $('.tournament-notification .icon-dropdown').removeClass('active');
        $('.no-notification').show();
        this.hideNotificationSpinner();
        return false;
      }

      $.each(json.html, function (key, val) {
        $('ul.lista-notificacoes').append(val);
      });

      $('.notificacoes-clearall').show();
      $('.tournament-notification').css('display', 'block');
    }
    this.hideNotificationSpinner();
  },

  /*
         * Renderiza aviso de notificações não lidas
         */
  renderUnreadNotificationsToaster: function (data) {
    var messages = parseInt(data.msgs);
    var abTest = typeof window.ab === 'object' && window.ab.forCurrentUser && window.ab.forCurrentUser.notifications_icon_and_toaster;
    var playerId = typeof window.currentUser === 'object' && window.currentUser.id ? window.currentUser.id : null;


    if (!abTest || !playerId) {
      return;
    }

    var notificationsLastAlertKey = 'gc:user_' + playerId + '_notifications_last_alert';
    var today = new Date();

    var notificationsLastAlertShownDate = moment(localStorage.getItem(notificationsLastAlertKey));
    var notificationsLastAlertShownToday = moment().isSame(notificationsLastAlertShownDate, 'day');
    // eslint-disable-next-line radix
    var shouldShowUnreadNotificationsToaster = messages > 0 && (!localStorage.getItem(notificationsLastAlertKey) || !notificationsLastAlertShownToday);

    if (shouldShowUnreadNotificationsToaster && typeof window.showToaster === 'function') {
      setTimeout(function () {
        showToaster({
          message: i18n.you_have_unread_notifications,
          type: 'dark',
          showPrimaryButton: true,
          showSecondaryButton: true,
          secondaryButtonContent: i18n.close,
          primaryButtonContent: i18n.read_now,
          onClickSecondaryButton: function (obj) {
            obj.closeToast()
          },
          onClickPrimaryButton: function (obj) {
            setTimeout(function () {
              window.ExposedGamersClubApp.toggleNotificationListDropdown();
              obj.closeToast()
            });
          }
        });

        localStorage.setItem(notificationsLastAlertKey, today);
      });
    }
  }
};


/*
     * Servicos ajax utilizados nas notificacoes
     */
var NotificationAjaxService = {
  /**
        * Servico de contagem de notificacoes
        */
  counters: function () {
    NotificationUI.parseNotificationCounters({
      notificacoes: '0', msgs: '0', friends: '0', total: '0'
    });
  },

  notifications: function () {
    $.getJSON('/notificacoes/detalhes', function (json, textStatus) {
      NotificationUI.renderNotificationList(json);
    });
  }
};

/*
     * Inicializa separadamente cada notificacao
     * (usuario online x badges de notificacoes)
     */
var NotificationPollings = {

  /*
         * Inicializa os pollings de verificacao de novas mensagens
         */
  initCounters: function () {
    NotificationAjaxService.counters();
  }
};


/*
     * Objeto que encapsula o funcionamento das notificacoes.
     */
var Notifications = {
  init: function () {
    pagetitle = document.title;
    NotificationPollings.initCounters();
    // NotificationAjaxService.notifications();

    $('.icon[data-target=notifications]').on('click', function () {
      NotificationAjaxService.notifications();
    });
  }
};

// inicia as notificacoes
$(document).ready(function () { Notifications.init(); });

// 0:  '#FF0300',
// 30: '#FB3400',
// 40: '#F66C00',
// 50: '#F1A000',
// 60: '#EBD200',
// 70: '#AAA200',
// 80: '#A1AA00',
// 100: '#92AA00'

    buildDonutChart = function(chart, animate) {
        var _percent    = $(chart).data('percent');
        var _borderSize = $(chart).data('border-size') ? $(chart).data('border-size') : 3;
        var _size       = $(chart).data('size');

        if (animate) {
          $(chart).radialIndicator({
              barColor: {
                0:  '#FF0300',
                30: '#FF0300',
                40: '#FF0300',
                50: '#F1A000',
                60: '#F1A000',
                70: '#F1A000',
                80: '#EBD200',
                100: '#92AA00'
              },
              barBgColor:"#141414",
              barWidth: _borderSize,
              initValue: 0,
              radius: _size,
              frameNum: 100,
              frameTime: 5,
              displayNumber: false,
          });

          var radialObj = $(chart).data('radialIndicator');
          if (radialObj != undefined) { radialObj.animate(_percent); }
          radialObj = null;
        } else {
          $(chart).radialIndicator({
              barColor: {
                0:  '#FF0300',
                30: '#FF0300',
                40: '#FF0300',
                50: '#F1A000',
                60: '#F1A000',
                70: '#F1A000',
                80: '#EBD200',
                100: '#92AA00'
              },
              barBgColor:"#141414",
              barWidth: _borderSize,
              initValue: _percent,
              radius: _size,
              frameNum: 100,
              frameTime: 5,
              displayNumber: false,
          });
        }
    }

    initCharts = function() {
      $('[donut-chart]').each(function(i, chart) {
        buildDonutChart(chart, $(chart).data('donut-static'));
      });
    }
    initCharts();

    var createLobbyCharts = function(elementId) {
      $(elementId).find('[donut-chart]').each(function(i, chart) {
        startLobbyChart(chart);
      });
    }


    var startLobbyChart = function(chart) {
      var _borderSize = $(chart).data('border-size') ? $(chart).data('border-size') : 3;

      $(chart).radialIndicator({
          barColor: {
            0:  '#FF0300',
            30: '#FF0300',
            40: '#FF0300',
            50: '#F1A000',
            60: '#F1A000',
            70: '#F1A000',
            80: '#EBD200',
            100: '#92AA00'
          },
          barBgColor:"#141414",
          barWidth: 3,
          initValue: $(chart).data('percent'),
          radius: $(chart).data('size'),
          frameNum: 100,
          frameTime: 5,
          displayNumber: false,
      });
    }

/*
 * Objeto que gerencia os eventos que criam ou nao as tooltips.
 */
var dynamicToolTipEvents = {
  spanTitle: false,
  mouseenter: function (e) {
    var title = this.getAttribute('title');
    if (title != null && $.trim(title) !== '' && dynamicToolTipEvents.spanTitle !== false) {
      title = title.split(",").join("\n");
      this.setAttribute('data-tip-text', title);
      this.setAttribute('title', '');
      dynamicToolTipEvents.spanTitle.innerText     = title;
      if (e.pageX > window.innerWidth - (window.innerWidth / 5)) {
        dynamicToolTipEvents.spanTitle.style.right = (window.innerWidth - e.pageX) + 'px';
        dynamicToolTipEvents.spanTitle.style.top = (e.pageY + 10) + 'px';
        dynamicToolTipEvents.spanTitle.style.left = 'auto';
      } else {
        dynamicToolTipEvents.spanTitle.style.top = (e.pageY + 10) + 'px';
        dynamicToolTipEvents.spanTitle.style.left = (e.pageX + 20) + 'px';
        dynamicToolTipEvents.spanTitle.style.right = 'auto';
      }

      if(e.pageY > window.innerHeight - 50) {
        dynamicToolTipEvents.spanTitle.style.top = 'auto';
        dynamicToolTipEvents.spanTitle.style.bottom = (window.innerHeight - e.pageY) + 'px';
      } else {
        dynamicToolTipEvents.spanTitle.style.bottom = 'auto';
        dynamicToolTipEvents.spanTitle.style.top = (e.pageY + 10) + 'px';
      }

      dynamicToolTipEvents.spanTitle.style.display = 'block';
    }
  },
  mousemove: function (e) {
    if (dynamicToolTipEvents.spanTitle !== false) {

      if(e.pageX > window.innerWidth - (window.innerWidth / 5)) {
        dynamicToolTipEvents.spanTitle.style.right = (window.innerWidth - e.pageX) + 'px';
        dynamicToolTipEvents.spanTitle.style.top  = (e.pageY + 10) + 'px';
        dynamicToolTipEvents.spanTitle.style.left = 'auto';
      } else {
        dynamicToolTipEvents.spanTitle.style.top  = (e.pageY + 10) + 'px';
        dynamicToolTipEvents.spanTitle.style.left = (e.pageX + 20) + 'px';
        dynamicToolTipEvents.spanTitle.style.right = 'auto';
      }

      if (e.pageY > window.innerHeight - 50) {
        dynamicToolTipEvents.spanTitle.style.top = 'auto';
        dynamicToolTipEvents.spanTitle.style.bottom = (window.innerHeight - e.pageY) + 'px';
      } else {
        dynamicToolTipEvents.spanTitle.style.bottom = 'auto';
        dynamicToolTipEvents.spanTitle.style.top = (e.pageY + 10) + 'px';
      }
      
    }
  },
  mouseleave: function () {
    var title = this.getAttribute('data-tip-text');

    if (title != null) {
      this.setAttribute('title', title);
    }

    dynamicToolTipEvents.spanTitle.style.display = 'none';
  },
  forceclean: function () {
    var allTips = document.querySelectorAll('.tooltip-title');
    allTips.forEach(function(el) {
      el.style.display = 'none';
    });
  }
};


/**
 * Tooltip personalizada do sistema que deve aparecer no hover as imagens.
 */
var bindToolTips = function () {
  $('body').on('mousemove', 'a[title], button[title], img[title], i[title], li:not(.select2-selection__choice)[title], abbr[title], span[title], th[title], td[title], video[title], div:not(.no-custom-tooltip)[title], label[title]', dynamicToolTipEvents.mousemove);
  $('body').on('mouseleave', 'a[title], button[title], img[title], i[title], li:not(.select2-selection__choice)[title], abbr[title], span[title], th[title], td[title], video[title], div:not(.no-custom-tooltip)[title], label[title]', dynamicToolTipEvents.mouseleave);
  $('body').on('click', 'a[title], button[title], img[title], i[title], li:not(.select2-selection__choice)[title], abbr[title], span[title], th[title], td[title], video[title], div:not(.no-custom-tooltip)[title], label[title]', dynamicToolTipEvents.mouseleave);
  $('body').on('mouseenter', 'a[title], button[title], img[title], i[title], li:not(.select2-selection__choice)[title], abbr[title], span[title], th[title], td[title], video[title], div:not(.no-custom-tooltip)[title], label[title]', dynamicToolTipEvents.mouseenter);
};

var bindToolTipsToContainer = function (context) {
  containers = [];

  if (!Array.isArray(context)) {
    containers.push(context);
  } else {
    containers = context;
  }

  containers.forEach(function(container) {
    $(container).find('[title]').on(dynamicToolTipEvents);
  });

};

var createToolTip = function() {
    var span = document.createElement("span");
    span.setAttribute('class', 'tooltip-title');
    span.setAttribute('id', 'tooltip-span');
    span.style.display = 'none';
    document.body.appendChild(span);
    dynamicToolTipEvents.spanTitle = span;
};

$(document).ready(function(){
  createToolTip();
  bindToolTips();
});
/**
 * Verifica se um objeto esta presente em um array.
 *
 * @return {bool}
 */
Array.prototype.contains = function(obj) {
    var i = this.length;
    while (i--) {
        if (this[i] === obj) {
            return true;
        }
    }
    return false;
};

/*
 * Transforma uma String em snake case.
 * Exemplo: "Por Exemplo".toSnakeCase() => por_exemplo
 *
 * @return {str} em snake case.
 */
String.prototype.toSnakeCase = function() {
  if (!this) return '';
  return this.toLowerCase().replace(/\s+/g, '_');
};
/**
 * Retorna a data corrigindo o timezone
 *
 * @param dateTime string da data e tempo em ptBR (dd/mm/yyyy hh:mm:ss)
 * @param format string para retornar no formato escolhido
 * @param parseformat string para escolher formato do parse (ts para timestamp)
 */
function tzDate(dateTime, format, parseFormat)
{
    var date, userTimezone;

    if (typeof format === 'undefined') {
        format = SYSTEM_DATE_PARSE;
    }

    if (typeof parseFormat === 'undefined') {
        parseFormat = SYSTEM_DATE_PARSE;
    }

    if (typeof moment === 'function') {
        if (parseFormat == 'ts') {
            date = moment.unix(dateTime);
        } else {
            date = moment(dateTime, parseFormat);
        }

        if (!date.isValid()) {
            console.error('invalid date format');
            return dateTime;
        }

        if (typeof DEFAULT_TIMEZONE === 'undefined') {
            console.error('system timezone not defined');
            return dateTime;
        }

        if (typeof MEMBER_TIMEZONE === 'undefined') {
            console.info('member timezone not defined, using timezone from browser');
            userTimezone = new Date().getTimezoneOffset()*60;
        } else {
            userTimezone = MEMBER_TIMEZONE;
        }

        if (userTimezone != DEFAULT_TIMEZONE) {
            if (DEFAULT_TIMEZONE == 0) {
                if (userTimezone > 0) {
                    date = date.add(userTimezone, 'seconds');
                } else if (userTimezone < 0) {
                    date = date.subtract(userTimezone*-1, 'seconds');
                }
            } else if (DEFAULT_TIMEZONE > userTimezone) {
                date = date.subtract((userTimezone-DEFAULT_TIMEZONE)*-1, 'seconds');
            } else if (DEFAULT_TIMEZONE < userTimezone) {
                date = date.add(userTimezone-DEFAULT_TIMEZONE, 'seconds');
            }
        }

        return date.format(format);
    } else {
        console.error('momentjs library not loaded');
        return dateTime;
    }
}

/**
 *  Retorna a data formatada corrigindo o timezone a partir de um timestamp
 *
 * @param timestamp
 * @param format
 */
function tzDateTimestamp(timestamp, format)
{
    return tzDate(timestamp, format, 'ts');
}

/**
 * Imprime na página a data formatada
 *
 * @param date
 * @param format
 */
function gcDate(date, format)
{
    document.write(tzDate(date,format));
}

/**
 * Imprime na página a data  em timestamp formatada
 *
 * @param date
 * @param format
 */
function gcDateTimestamp(date, format)
{
    document.write(tzDate(date,format));
}

/**
 * Processa datetime em strings, convertendo para timezone do usuário
 *
 * @param string
 * @format string https://momentjs.com/docs/#/displaying/format/ (nem todos)
 */
function applyTzDateInString(string, format)
{
    if (typeof format == 'undefined') {
        format = '%DD/%MM/%YYYY %HH:%mm:%ss';
    }

    var stringsToFormat = [
        ['DD',   '([0-9]{2})'], //Day of Month (01 02 ... 30 31)
        ['D',    '([0-9]{1,2})'], //Day of Month (1 2 ... 30 31)
        ['MM',   '([0-9]{2})'], //Month (01 02 ... 11 12)
        ['M',    '([0-9]{1,2})'], //Month (1 2 ... 11 12)
        ['YYYY', '([0-9]{4})'], //Year (1970 1971 ... 2029 2030)
        ['YY',   '([0-9]{2})'], //Year (70 71 ... 29 30)
        ['HH',   '([0-9]{2})'], //Hour (00 01 ... 22 23)
        ['H',    '([0-9]{1,2})'], //Hour (0 1 ... 22 23)
        ['mm',   '([0-9]{2})'], //Minute (00 01 ... 58 59)
        ['m',    '([0-9]{1,2})'], //Minute (0 1 ... 58 59)
        ['ss',   '([0-9]{2})'], //Second (00 01 ... 58 59)
        ['s',    '([0-9]{1,2})'] //Second (0 1 ... 58 59)
    ];

    var formatMatch = format;

    for (var sf=0; sf < stringsToFormat.length; sf++) {
        formatMatch = formatMatch.replace('%'+stringsToFormat[sf][0], stringsToFormat[sf][1]);
    }

    var match = string.match(new RegExp(formatMatch, 'g'));

    format = format.replace(/%/g, '');

    if (match) {
        for (var i=0; i<match.length; i++) {
            string = string.replace(match[i], tzDate(match[i], format, format));
        }
    }

    return string;
}

/**
 * Abre modal de confirmacao usando NOTY JS.
 *
 *    // chama a funcao
 *    notyConfirm({
 *      // envia o titulo
 *      text: '<h3>Abandonar partida</h3><p>O abandono de partida resultará em punições como banimento e perda de reputação.</p>',
 *      actions: [
 *        // descreve as acoes
 *        {
 *          label: 'Cancelar',
 *          class: 'btn',
 *          callback: function() { console.log('Called callback ov cancelar'); }
 *        }
 *      ]
 *    });
 *
 * @param Object - Objeto que descreve o dialogo, conforme exemplo acima.
 * @return Object - Instancia do Noty
 */
function notyConfirm ($options) {
  var actions = [];

  $options.actions.forEach(function (action) {
    actions.push(
      Noty.button(action.label, action.class, function () {
        action.callback();
        $notyConfirm.close();
      })
    );
  });

  var $notyConfirm = new Noty({
    theme: 'custom-js-confirmation',
    modal: true,
    layout: 'center',
    timeout: false,
    text: $options.text,
    closeWith: ['button'],
    buttons: actions,
    callbacks: {
      beforeShow: function () {
        window.insertOrRemoveOverlayNotyConfirm();
      },
      afterClose: function () {
        window.insertOrRemoveOverlayNotyConfirm();
      },
      onClose: $options.onClose,
    }
  }).show();

  return $notyConfirm;
}

function insertOrRemoveOverlayNotyConfirm() {
  var idOverlay = 'noty_theme__custom-js-confirmation-overlay';
  var overlayNotyConfirm = document.getElementById(idOverlay);

  if (overlayNotyConfirm === null) {
    overlayNotyConfirm = document.createElement('div');
    overlayNotyConfirm.id = idOverlay;
    document.body.appendChild(overlayNotyConfirm);
  } else if (overlayNotyConfirm.style.display === 'none') {
    overlayNotyConfirm.style.display = 'block';
  } else {
    overlayNotyConfirm.style.display = 'none';
  }
}


// Assinatura em todas as páginas

if (!amigosArray2) {
  var amigosArray2 = [];
}

// function to ebanx
function ebanx(planID) {
  event.preventDefault();
  $.ajax({
    method: 'POST',
    url: '/shop/ebanx',
    data: {
      planId: planID,
      friends: $('#ebanx_friend_id').val(),
      country: $('#country-latam').val()
    }
  })
    .done(function (msg) {
      if (msg.status == 200) {
        window.open(msg.message);
      } else {
        alert(msg);
      }
    })
    .fail(function (msg) {
      alert(msg.responseJSON.message);
    });
}

chosenScript = function (dataArray) {
  $('.chosen').select2({
    tags: true,
    placeholder: 'Digite aqui...',
    width: '100%',
    data: dataArray,
    createTag: function (tag) {
      var term = $.trim(tag.term);
      var isnum = /^\d+$/.test(term);

      if (term === '' || isnum === false) {
        return null;
      }

      return {
        id: tag.term,
        text: tag.term,
        isNew: true
      };
    },
    insertTag: function (data, tag) {
      data.push(tag);
    }
  }).on('select2:select', function (e) {
    var id = e.params.data.id;
    $('.select2-selection__choice[title=' + id + ']').addClass('user-searching');

    if (e.params.data.isNew) {
      $.ajax({
        type: 'post',
        url: '/players/find/' + id,
        success: function (msg) {
          // plAvatar = msg.player.avatar;
          amigosArray2.push({ id: parseInt(msg.player.id), text: msg.player.nick, selected: true });

          $('.chosen').select2('destroy');
          $('.chosen').off();
          $('.chosen').find('option').remove();
          chosenScript(amigosArray2);
        },
        error: function (erro) {
          alert('Usuário inválido');
          $('.chosen').select2('destroy');
          $('.chosen').off();
          $('.chosen').find('option').remove();
          chosenScript(amigosArray2);
        }
      });
    } else {
      for (var o in amigosArray2) {
        if (amigosArray2[o].id == id) {
          amigosArray2[o].selected = true;
        }
      }
    }
  }).on('select2:unselect', function (e) {
    var idSelected = e.params.data.id;
    for (var o in amigosArray2) {
      if (amigosArray2[o].id == idSelected) {
        amigosArray2[o].selected = false;
      }
    }
  });

  $('.chosen').on('change', function () {
    var planoChosen = $(this).data('plano');
    var playersChosen = $(this).val();
    var totalPlayers;

    if (playersChosen !== null) {
      totalPlayers = playersChosen.length;
    } else {
      totalPlayers = 0;
    }

    if (planoChosen == 'plus') {
      total = insertDecimal(15.90 * totalPlayers);
      $('.total-plus .valor-total').html(total);
    }

    if (planoChosen == 'premium') {
      total = insertDecimal(29.90 * totalPlayers);
      $('.total-premium .valor-total').html(total);
    }
  });
};

chosenScript(amigosArray2);

$(function () {
  /**
  * Slow scroll
  */
  $('[js-action="slowScrollDown"]').click(function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
  });
});

function insertDecimal(num) {
  return (num * 1).toFixed(2);
}

var pagarAmigosOk;
var pagarAmigosFail;

window.assinaturas = {
  pagar: {
    amigo: function (plano) {
      if ($('#termos-pagar-amigos-' + plano).is(':checked') === false) {
        alert('Você precisa concordar com os termos de uso.');
        return false;
      }

      var playersRecebendo = $('#presentear-' + plano).serialize();

      $.post('/assinatura/pagarAmigo', playersRecebendo, function (data, textStatus, xhr) {
        if (data.success) {
          payFriend(data.token, data.total, data.plano);
        } else {
          alert('Aconteceu um problema. Tente novamente.');
        }
      }, 'json')
        .fail(function (data) {
          if (typeof (data.responseJSON) === 'undefined') {
            alert('Aconteceu um problema. Tente novamente.');
            console.error(data);
          } else {
            alert(data.responseJSON.message);
          }
        });
    }
  }
};

function payFriend(tkn, total, plano) {
  $('.close-button').click();

  var checkout = new PagarMeCheckout.Checkout({
    encryption_key: 'ek_live_srfbBrRo8RPqRVNKDLy6haHdiR8KDh',
    success: function (data) {
      data.tkn = tkn;
      data.plano = plano;

      $.post('/assinatura/pagarAmigoAPI', data, function (data, textStatus, xhr) {
        if (data.success) {
          if (data.forma_pagamento == 'boleto') {
            $('#modal-feedback-pagamento .msg').hide();
            $('#modal-feedback-pagamento .msg.amigos-boleto').show();
            common.modal.abrirModal('modal-feedback-pagamento');

            $('.btn-boleto').html('<a href="' + data.boleto_url + '" target="_blank" class="btn btn-primary">Imprimir boleto</a>');

            $('.codigo-barras').html(data.boleto_codigo);
          } else {
            $('#modal-feedback-pagamento .msg').hide();
            $('#modal-feedback-pagamento .msg.amigos-cartao').show();
            common.modal.abrirModal('modal-feedback-pagamento');
          }

          var metadata = {
            metodo_de_pagamento: data.forma_pagamento,
            valor: data.total,
            status: data.message,
            ip: '<?php echo $_SERVER["REMOTE_ADDR"]; ?>'
          };

          // Registra a atividade no intercom
          Intercom('trackEvent', 'assinou-premium-amigos', metadata);
        } else {
          alert('Ocorreu um erro');
        }
      }, 'json');
    }
  });

  var params = {
    amount: total,
    createToken: 'true',
    paymentMethods: 'boleto, credit_card',
    interestRate: 1,
    postbackUrl: 'https://gamersclub.com.br/assinatura/pagarAmigoAPIpb'
  };

  checkout.open(params);

  $('#pagarme-checkout-container').find('iframe').css('z-index', '999');
}

function cardIINMatchsCardBrand(cardBrand, cardIIN) {
  var cardPattern = {
    elo: /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^504175|^627780|^63(6297|6368|6369)|(65003[5-9]|65004[0-9]|65005[01])|(65040[5-9]|6504[1-3][0-9])|(65048[5-9]|65049[0-9]|6505[0-2][0-9]|65053[0-8])|(65054[1-9]|6505[5-8][0-9]|65059[0-8])|(65070[0-9]|65071[0-8])|(65072[0-7])|(65090[1-9]|6509[1-6][0-9]|65097[0-8])|(65165[2-9]|6516[67][0-9])|(65500[0-9]|65501[0-9])|(65502[1-9]|6550[34][0-9]|65505[0-8])|^(506699|5067[0-6][0-9]|50677[0-8])|^(509[0-8][0-9]{2}|5099[0-8][0-9]|50999[0-9])|^65003[1-3]|^(65003[5-9]|65004\d|65005[0-1])|^(65040[5-9]|6504[1-3]\d)|^(65048[5-9]|65049\d|6505[0-2]\d|65053[0-8])|^(65054[1-9]|6505[5-8]\d|65059[0-8])|^(65070\d|65071[0-8])|^65072[0-7]|^(65090[1-9]|65091\d|650920)|^(65165[2-9]|6516[6-7]\d)|^(65500\d|65501\d)|^(65502[1-9]|6550[3-4]\d|65505[0-8])/,
    bb: /^3764(91|93)|^400(136|162|168|170|176|178|182|185|191|199|444)|^401(179|557|563)|^403(236|792|793|794|795)|^404001|^406467|^407(800|801|802|830)|^409869|^414(451|452)|^423(069|070|071|072)|^430543|^432(728|729)|^433873|^438935|^441(172|174)|^444(434|457|458|459)|^448(549|556)|^457(594|595|633|634)|^461205|^467(148|149|150|151|152|153|481)|^469(570|571)|^471(701|702|703|704)|^477(115|116)|^484(147|148|189|199)|^485(464|960)|^486323|^489(410|411)|^498(401|402|406|407|408|409|423|425|430|431|433|442|449|453)|^499904|^503337|^506(721|728|729|733|745|753|775|776)|^509(068|069|107)|^512(112|119)|^514(009|094|095|895)|^516(064|066)|^518(759|764|765)|^521501|^522978|^525439|^526811|^538818|^540(064|084|101|500|535)|^542(661|842)|^544(066|545|586|597|908)|^545053|^546(452|456|479|719|990|991)|^547(606|749|874)|^548(572|573|794|822|824|965)|^549833|^552(063|289|584|694|911)|^553(103|104)|^554(906|927)|^555724|^558779|^650(487|499|500|501|906|907|908|909|922|938|946|948)|^651(653|676)|^655(001|003)|^444456(02|03|04|05|06|07|08|09|10|11|12|13|14|15|16|17|18|20|21|23|24|25|26|28|30|50)|^54760401/
  };

  if (cardPattern[cardBrand]) {
    return cardPattern[cardBrand].test(cardIIN);
  }

  return false;
}

function isSpecificCardPlan(partner, planId) {
  var partnerPlans = {
    elo: 11,
    bb: 12
  };

  if (partnerPlans[partner]) {
    return partnerPlans[partner] === planId;
  }

  return false;
}

$(function() {
    var subscriptionModal = {
        encryptionKey: PAGARME_PUBLIC_KEY,
        language: 'pt-br',
        container: null,
        elementOrigin: null, // used to know where the modal was initiated
        currentStep: null, // subscriptionData.steps
        updateOnClose: false,
        modalType: '', // subscribe, isUpgrade, isDowngrade, forFriends...
        steps: {
            friendsList: 'subscriptionFriendsListTemplate',
            paymentMethod: 'subscriptionPaymentMethodTemplate',
            cardData: 'subscriptionCardDataTemplate',
            personalData: 'subscriptionPersonalDataTemplate',
            address: 'subscriptionAddressTemplate',

            reviewCardPayment: 'subscriptionReviewCardPaymentTemplate',
            successBillet: 'subscriptionSuccessBilletTemplate',
            success: 'subscriptionSuccessTemplate',

            changeConfirm: 'subscriptionChangeConfirmTemplate',
            changeSuccess: 'subscriptionChangeSuccessTemplate',

            fatalError: 'subscriptionFatalErrorTemplate',
            recoverableError: 'subscriptionRecoverableErrorTemplate'
        },
        templates: [
            'subscriptionModalBreadcrumbTemplate',

            'subscriptionFriendsListTemplate',
            'subscriptionPaymentMethodTemplate',
            'subscriptionCardDataTemplate',
            'subscriptionPersonalDataTemplate',
            'subscriptionAddressTemplate',

            'subscriptionReviewCardPaymentTemplate',
            'subscriptionSuccessBilletTemplate',
            'subscriptionSuccessTemplate',

            'subscriptionChangeConfirmTemplate',
            'subscriptionChangeSuccessTemplate',

            'subscriptionFatalErrorTemplate',
            'subscriptionRecoverableErrorTemplate'
        ],

        init: function() {
            if (window.location.hash.match(/melhor-com-premium?/)) {
                if (typeof dataLayer !== 'undefined') {
                    window.subscriptionPage = 'hash_melhor_com_premium_finalizado';
                    dataLayer.push({ event: 'hash_melhor_com_premium' });
                }

                var plan = 2;
                var modalType = 'subscribe';
                var language = 'pt-br';

                if (ISSUBSCRIBER && !ISPREMIUM) {
                    method = 'isUpgrade';
                }

                subscriptionModal.loadModal({
                    modalType: modalType,
                    plan: plan,
                    language: language,
                    elementOrigin: $(document.createElement('div'))
                });
            }

            subscriptionData.loadPlans();
            subscriptionPromo.blackfriday();

            // This check directly open using a specific payment method: card, billet
            if (window.location.hash.match(/plus-cartao?|plus-boleto?|premium-cartao?|premium-boleto?/)) {
                var promoEvent = window.location.hash.match(/plus-cartao?|plus-boleto?|premium-cartao?|premium-boleto?/)[0];

                switch (promoEvent) {
                    case 'plus-cartao':
                        var plan = 1;
                        var paymentMethod = 'card';
                        break;
                    case 'plus-boleto':
                        var plan = 1;
                        var paymentMethod = 'billet';
                        break;
                    case 'premium-cartao':
                        var plan = 2;
                        var paymentMethod = 'card';
                        break;
                    case 'premium-boleto':
                        var plan = 2;
                        var paymentMethod = 'billet';
                        break;
                }

                var modalType = 'subscribe';
                var language = 'pt-br';

                subscriptionModal.loadModal({
                    modalType: modalType,
                    plan: plan,
                    language: language,
                    elementOrigin: $(document.createElement('div')),
                    paymentMethod: paymentMethod
                });
            }

            $(document).on('click', '[data-jsaction=subscribePlanBtn]', function(e) {
                e.preventDefault();
                if ($(this).attr('disabled')) {
                    return false;
                }
                $(this).attr('disabled', true);

                var plan = $(this).data('plano');
                var modalType = $(this).data('modal-type');
                var language = $(this).data('language');
                var discount = $(this).data('discount');
                var planDiscount = $(this).data('plan-discount');

                subscriptionModal.loadModal({
                    modalType: modalType,
                    plan: plan,
                    discount: discount,
                    planDiscount: planDiscount,
                    language: language,
                    elementOrigin: $(this)
                });
            });
            window.document.addEventListener('openSubscriptionModal', subscriptionModal.openSubscriptionModalHandler, false);
        },

        isUpgrade: function() {
            return subscriptionModal.modalType === 'isUpgrade';
        },

        isForFriends: function() {
            return subscriptionModal.modalType === 'forFriends';
        },

        loadModal: function(opt) {
            if (!window.common.isLogged()) {
                window.common.showLoginNotification();

                setTimeout(function() {
                    opt.elementOrigin.attr('disabled', false);
                }, 2000);

                return;
            }

            // enable pay button
            subscriptionModal.switchPayButtonEvent(true);
            // Set modal data
            subscriptionModal.modalType = opt.modalType;
            subscriptionModal.elementOrigin = opt.elementOrigin;
            subscriptionModal.language = opt.language;
            subscriptionModal.discount = opt.discount;
            subscriptionModal.planDiscount = opt.planDiscount;
            subscriptionData.paymentMethod = opt.paymentMethod ? opt.paymentMethod : null;
            subscriptionData.canUsePromotion = typeof opt.canUsePromotion === 'boolean' ? opt.canUsePromotion : true;

            $.ajax({
                method: 'get',
                data: {},
                url: '/assinatura/modal',
                success: function(data) {
                    $('#modal-assinaturas').html(data);

                    // Assign and show modal
                    subscriptionModal.container = $('#subscriptionModal');
                    subscriptionModal.container.addClass('subscription-modal-active');

                    subscriptionHelpers.mustacheHelper.parseMultiple(subscriptionModal.templates);

                    subscriptionRenders.showProcessing();
                    subscriptionModal.registerEvents();

                    if (!subscriptionData.canUsePromotion) {
                        subscriptionRenders.showFatalError('Plano finalizado', 'Que pena, vendemos todos nosso planos, fique atento para novas promoções =)');
                        return false;
                    }

                    // Check and set plan to modal
                    if (!subscriptionData.isValidPlan(opt.plan)) {
                        subscriptionRenders.showFatalError('Plano inválido', 'Você selecionou um plano inválido');
                        return false;
                    }

                    subscriptionData.setPlan(opt.plan);
                    subscriptionData.setDiscount(opt.discount);
                    subscriptionData.setPlanDiscount(opt.planDiscount);

                    // Alter plan to discount
                    if (opt.discount > 0) {
                        if (opt.plan == opt.planDiscount) {
                            subscriptionData.setPlan(opt.discount);
                        }
                    }
                    // Pre-render static steps
                    subscriptionRenders.renderFriends();
                    subscriptionRenders.renderPaymentMethods();

                    // Load user data
                    subscriptionData.loadUserData()
                        .done(function(data) {
                            if (data.success === true) {
                                subscriptionRenders.showProcessing(false);
                                subscriptionData.buffer = Object.assign({}, subscriptionData.buffer, data);
                                // Check for pending payment
                                if (data.isPendingPayment && !subscriptionModal.isForFriends() && subscriptionModal.modalType !== 'isDowngrade') {
                                    subscriptionRenders.showPendingPayment();
                                    return false;
                                }

                                // If it's upgrade/downgrade proceed to the proper screen
                                if (subscriptionModal.modalType === 'isDowngrade' || subscriptionModal.modalType === 'isUpgrade') {
                                    subscriptionModal.openChangeSubscription();
                                } else {
                                    // Active Subscription Check
                                    if (data.isActiveSubscription && !subscriptionModal.isForFriends()) {
                                        subscriptionRenders.showActiveSubscriptionError();
                                        return false;
                                    }

                                    // Tag according to the plan
                                    if (subscriptionData.getPlan().plan_id === 5) {
                                        dataLayer.push({ event: 'premium_90_init' });
                                    } else if (subscriptionData.getPlan().plan_id === 6) {
                                        dataLayer.push({ event: 'premium_180_init' });
                                    }

                                    subscriptionModal.open();
                                }
                            }
                        }).fail(function(data) {
                            subscriptionRenders.showFatalError('Falha ao carregar tela de pagamento');
                        });
                },
                error: function() {
                    subscriptionRenders.showFatalError('Falha ao carregar tela de pagamento');
                },
                complete: function() {
                    subscriptionModal.elementOrigin.attr('disabled', false);
                }
            });
        },

        registerEvents: function() {
            $(document)
                .off('click', '#subscriptionModal [data-jsaction=gotoStep]')
                .on('click', '#subscriptionModal [data-jsaction=gotoStep]', function(e) {
                    subscriptionRenders.gotoStep($(this).data('target-step'), $(this).data('target-value'));
                });

            $(document)
                .off('keypress', '#subscriptionModal [data-jsaction=gotoStep]')
                .on('keypress', '#subscriptionModal [data-jsaction=gotoStep]', function(e) {
                    if (e.charCode === 0 || e.keyCode === 32) {
                        subscriptionRenders.gotoStep($(this).data('target-step'));
                    }
                });

            $(document)
                .off('click', '#subscriptionModal #changeSubscription')
                .on('click', '#subscriptionModal #changeSubscription', function(e) {
                    subscriptionModal.processChangeSubscription();
                });

            $(document)
                .off('click', '#subscriptionModal [data-jsaction=backStep]')
                .on('click', '#subscriptionModal [data-jsaction=backStep]', function(e) {
                    subscriptionRenders.showStep($(this).data('target-step'));
                });

            $(document)
                .off('click', '#subscriptionModal [data-jsaction=subscriptionModalClose]')
                .on('click', '#subscriptionModal [data-jsaction=subscriptionModalClose]', function() {
                    var plan = subscriptionData.getPlan();

                    if (subscriptionData.getDiscount() || plan.plan_id === 1 || plan.plan_id === 9) {
                        dataLayer.push({ event: 'left_checkout_plus' });
                    } else {
                        dataLayer.push({ event: 'left_checkout_premium' });
                    }

                    subscriptionModal.close();
                    if (subscriptionModal.updateOnClose === true) {
                        window.location.reload();
                    }
                });

            $(document)
                .off('keyup', '#subscriptionModal #zipcode')
                .on('keyup', '#subscriptionModal #zipcode', function() {
                    var postcode = $(this).val().replace(/\D/g, '');

                    if (postcode.length == 8) {
                        subscriptionData.postcodeSearch(postcode);
                    }
                    $('#subscriptionAddress [name=zipcode_isvalid]').val('false');
                });

            $(document)
                .off('focusin', '#subscriptionModal #subscriptionCardCvv')
                .on('focusin', '#subscriptionModal #subscriptionCardCvv', function() {
                    $('#subscriptionCardBack').addClass('subscription-card-back-active');
                });


            $(document)
                .off('focusout', '#subscriptionModal #subscriptionCardCvv')
                .on('focusout', '#subscriptionModal #subscriptionCardCvv', function() {
                    if ($(this).val().length > 0) {
                        return true;
                    }
                    $('#subscriptionCardBack').removeClass('subscription-card-back-active');
                });

            $(document)
                .off('keyup', '#subscriptionModal [data-jsaction=bindCardInput]')
                .on('keyup', '#subscriptionModal [data-jsaction=bindCardInput]', function() {
                    var field_value = $(this).val();
                    var card_image_input = $('#subscriptionCardData [data-card-image=' + $(this).attr('name') + ']');

                    if (field_value.length > 0) {
                        card_image_input.text(field_value);
                    } else {
                        card_image_input.text(card_image_input.data('card-placeholder'));
                    }
                });

            $(document)
                .off('change', '#subscriptionModal input')
                .on('change', '#subscriptionModal input', function() {
                    subscriptionData.saveLocalItem(
                        subscriptionModal.currentStep,
                        $(this).attr('name'),
                        $(this).val()
                    );
                });


            $(document)
                .off('focusout', '#subscriptionModal input')
                .on('focusout', '#subscriptionModal input', function() {
                    if ($(this).val().length > 0) {
                        $(this).addClass('has-changed');
                    }
                });

            $(document)
                .off('submit', '#subscriptionModal form')
                .on('submit', '#subscriptionModal form', function(e) {
                    e.preventDefault();
                    return false;
                });
        },

        open: function() {
            if (subscriptionData.hasPendingPayment && !subscriptionModal.isForFriends()) {
                subscriptionRenders.showFatalError(
                    'Assinatura com pagamento pendente',
                    'Identificamos que você possui uma assinatura com pagamento pendente, verifique em seu perfil ou e-mail as instruções para pagamento. Em caso de dúvidas, favor entrar em contato com nosso suporte pelo site.'
                );
                return false;
            }

            if (isSpecificCardPlan('elo', subscriptionData.plan.plan_id)) {
                subscriptionModal.currentStep = 'card';
                subscriptionData.paymentMethod = 'card';
                subscriptionRenders.gotoStep('cardData', 'cardElo');
                return;
            }

            if (isSpecificCardPlan('bb', subscriptionData.plan.plan_id)) {
                subscriptionModal.currentStep = 'card';
                subscriptionData.paymentMethod = 'card';
                subscriptionRenders.gotoStep('cardData', 'cardBB');
                return;
            }

            // Bypass payment method (just for new users, never put it before pendingPayment validation)
            if (subscriptionData.paymentMethod !== null) {
                subscriptionModal.currentStep = 'paymentMethod';
                if (subscriptionData.paymentMethod === 'billet') {
                    subscriptionRenders.renderPersonalData();
                    subscriptionRenders.gotoStep('billet', 'billet');
                } else {
                    subscriptionRenders.renderCardData();
                    subscriptionRenders.gotoStep('card', 'card');
                }
                return true;
            }

            if (subscriptionModal.isForFriends()) {
                subscriptionRenders.showStep('friendsList');
            } else {
                subscriptionRenders.showStep('paymentMethod');
            }

            $('body').css('overflow', 'hidden');
        },

        openSubscriptionModalHandler: function(e) {
            $(this).attr('disabled', true);
            var modalType = e.detail.plano;
            var plan = e.detail.plano;
            var language = $(this).data('language');

            subscriptionModal.loadModal({
                modalType: modalType,
                plan: plan,
                language: language,
                elementOrigin: $(this)
            });
        },

        openChangeSubscription: function() {
            subscriptionData.setPaymentConfig('changingPlan', true);
            var data = {};

            subscriptionRenders.renderChangeConfirm(data);
            subscriptionRenders.showStep('changeConfirm');
        },

        close: function() {
            $('body').css('overflow', 'auto');
            subscriptionModal.container.removeClass('subscription-modal-active');
            subscriptionData.friends = [];
        },

        switchPayButtonEvent: function(enable) {
            var enable = enable != 'undefined' ? enable : false;
            if (enable) {
                $(document)
                    .off('click', '#subscriptionModal #paySubscription')
                    .on('click', '#subscriptionModal #paySubscription', function(e) {
                        subscriptionModal.processPaySubscription();
                    });
            } else {
                $(document).off('click', '#subscriptionModal #paySubscription');
            }
        },

        processPaySubscription: function() {
            var plan = subscriptionData.getPlan();
            var customer = subscriptionData.buffer;
            var discount = subscriptionData.getDiscount();
            var planDiscount = subscriptionData.getPlanDiscount();

            subscriptionModal.switchPayButtonEvent(false);
            subscriptionRenders.showProcessing();

            // PAGAMENTO PARA AMIGOS
            if (subscriptionData.friends.length > 0) {
                this.paySubscriptionForFriends(customer);
                return true;
            }

            $.ajax({
                url: '/assinatura/generatePayment/card',
                method: 'post',
                dataType: 'json',
                data: {
                    plan: plan.plan_id,
                    discount: discount,
                    planDiscount: planDiscount,
                    customer: customer
                },
                success: function(data) {
                    subscriptionRenders.renderSuccessCard();
                    subscriptionRenders.showStep('success');
                    subscriptionRenders.showProcessing(false);
                    subscriptionRenders.stepTagger('finish');
                },
                error: function(e) {
                    var data = e.responseJSON;
                    subscriptionModal.switchPayButtonEvent(true);
                    subscriptionRenders.showProcessing(false);

                    if (data.step) {
                        subscriptionRenders.showRecoverableError('Não foi possível processar o pagamento', data.message, data.step);
                        return false;
                    }

                    subscriptionRenders.showFatalError('Não foi possível processar o pagamento', data.message);
                    return false;
                }
            });
        },

        processGenerateBillet: function() {
            var plan = subscriptionData.getPlan();
            var discount = subscriptionData.getDiscount();
            var planDiscount = subscriptionData.getPlanDiscount();
            subscriptionRenders.showProcessing();

            if (subscriptionData.friends.length > 0) {
                subscriptionModal.generateBilletForFriends(plan);
                return true;
            }

            $.ajax({
                url: '/assinatura/generatePayment/billet',
                method: 'post',
                data: {
                    plan: plan.plan_id,
                    discount: discount,
                    planDiscount: planDiscount
                },
                success: function(data) {
                    data.plan = plan;
                    var render = Mustache.render(
                        subscriptionRenders.getTemplate(subscriptionModal.steps.successBillet),
                        data
                    );
                    $('#subscriptionSuccessBillet').html(render);
                    subscriptionRenders.showStep('successBillet');

                    subscriptionRenders.stepTagger('finish');
                    subscriptionRenders.showProcessing(false);
                    subscriptionModal.updateOnClose = true;
                },
                error: function(e) {
                    var data = e.responseJSON;
                    subscriptionRenders.showFatalError('Não foi possível gerar o boleto', data.message);
                    return false;
                }
            });

            return true;
        },

        processChangeSubscription: function(plan) {
            subscriptionRenders.showProcessing();

            $.ajax({
                url: '/assinatura/changeSubscriptionPlan',
                method: 'post',
                data: {
                    plan: subscriptionData.plan.plan_id,
                    upgrade: subscriptionModal.isUpgrade()
                },
                success: function(data) {
                    if (data.billet) {
                        var render = Mustache.render(
                            subscriptionRenders.getTemplate(subscriptionModal.steps.successBillet),
                            data
                        );
                        $('#subscriptionSuccessBillet').html(render);
                        subscriptionRenders.showStep('successBillet');
                    } else {
                        subscriptionRenders.renderChangeSuccess();
                        subscriptionRenders.showStep('changeSuccess');
                    }

                    subscriptionRenders.showProcessing(false);
                },
                error: function(e) {
                    var data = e.responseJSON;
                    subscriptionRenders.showFatalError('Não foi possível atualizar sua assinatura', data.message);
                    return false;
                }
            });
        },

        generateBilletForFriends: function(plan) {
            var friends = subscriptionData.friends;

            $.ajax({
                url: '/assinatura/generatePayment/billet',
                method: 'post',
                data: {
                    plan: plan.plan_id,
                    friends: friends
                },
                success: function(data) {
                    data.plan = plan;
                    var render = Mustache.render(
                        subscriptionRenders.getTemplate(subscriptionModal.steps.successBillet),
                        data
                    );
                    $('#subscriptionSuccessBillet').html(render);
                    subscriptionRenders.showStep('successBillet');
                    subscriptionRenders.showProcessing(false);
                    subscriptionModal.updateOnClose = true;
                },
                error: function(e) {
                    var data = e.responseJSON;
                    subscriptionRenders.showFatalError('Não foi possível gerar o boleto', data.message);
                    return false;
                }
            });
        },

        paySubscriptionForFriends: function(customer_data) {
            var plan = subscriptionData.getPlan();
            var friends = subscriptionData.friends;

            $.ajax({
                url: '/assinatura/generatePayment/card',
                method: 'post',
                dataType: 'json',
                data: {
                    plan: plan.plan_id,
                    customer: customer_data,
                    friends: friends
                },
                success: function(data) {
                    subscriptionRenders.renderSuccessCard();
                    subscriptionRenders.showStep('success');
                    subscriptionRenders.showProcessing(false);
                    subscriptionRenders.stepTagger('finish');
                },
                error: function(e) {
                    var data = e.responseJSON;

                    if (data.step) {
                        subscriptionRenders.showRecoverableError('Não foi possível processar o pagamento', data.message, data.step);
                        return false;
                    }

                    subscriptionRenders.showFatalError('Não foi possível processar o pagamento', data.message);
                    return false;
                }
            });
        }
    };

    var subscriptionData = {
        plans: {},
        discount: 0,
        planDiscount: 0,
        plan: false,
        changingPlan: false,
        paymentMethod: false,
        hasPendingPayment: false,
        updateOnClose: true,
        canUsePromotion: true,
        buffer: {},
        friends: [],

        isPlus: function() {
            return subscriptionData.plan.plan_id === 1;
        },

        isValidPlan: function(plan) {
            if (Object.keys(subscriptionData.plans).indexOf(plan.toString()) !== -1) {
                return true;
            }
            return false;
        },

        loadStepData: function(step) {
            if (step !== 'reviewCardPayment' && subscriptionData.buffer[step]) {
                $.each(subscriptionData.buffer[step], function(name, value) {
                    $('#subscriptionModal [name="' + name + '"]').val(value);
                });
            }
        },

        loadUserData: function() {
            return $.getJSON('/assinatura/loadData/');
        },

        loadPlans: function() {
            if (!window.location.href.match(/shop/)) { return; }

            $.ajax({
                    method: 'POST',
                    url: '/shop/getPlans'
                })
                .done(function(msg) {
                    if (msg.status == 200) {
                        subscriptionData.setPlans(msg.data);
                    }
                });
        },

        getPlanById: function(planId) {
            return subscriptionData.plans[planId];
        },

        setPlan: function(planId) {
            subscriptionData.plan = subscriptionData.plans[planId];
            subscriptionData.buffer.plan = subscriptionData.plans[planId];
        },

        setPlans: function(plans) {
            subscriptionData.plans = plans;
        },

        setDiscount: function(discountId) {
            subscriptionData.discount = discountId;
        },

        setPlanDiscount: function(planDiscountId) {
            subscriptionData.planDiscount = planDiscountId;
        },

        setPaymentConfig: function(key, value) {
            if (key === 'plans') {
                key = 'plan';
            }
            this[key] = value;
            return true;
        },

        saveLocal: function(step, validateBypass) {
            if (validateBypass !== false) {
                return subscriptionData.validateForm(step);
            }

            return true;
        },

        saveLocalItem: function(step, key, value) {
            if (key === 'card_cvv') {
                return false;
            }

            if (!subscriptionData.buffer[step]) {
                subscriptionData.buffer[step] = {};
            }
            subscriptionData.buffer[step][key] = value;

            return true;
        },

        validateStep: function(step, value) {
            switch (step) {
                case 'paymentMethod':
                    return subscriptionData.setPaymentConfig(step, value);
                case 'cardData':
                    switch (subscriptionModal.language) {
                        case 'pt-br':
                        case 'english':
                            return subscriptionData.pagarMeValidateCardData(step, value);
                    }
                default:
                    var form_data = $('#form_' + step).serialize();
                    var bypassELo = step === 'card' && value === 'cardElo';
                    var bypassBB = step === 'card' && value === 'cardBB';
                    var form_valid = subscriptionData.saveLocal(step, !bypassELo && !bypassBB);

                    if (form_valid !== true) {
                        return { errors: form_valid };
                    }

                    return $.ajax({
                        type: 'POST',
                        dataType: 'json',
                        data: form_data,
                        url: '/assinatura/saveStep/' + encodeURIComponent(step)
                    });
            }
        },

        validateForm: function(step) {
            var form_el = document.getElementById('form_' + step);
            if (form_el && form_el.classList) {
                form_el.classList.add('has-submited');
                if (!subscriptionData.validateFormCustom(form_el, step)) {
                    var errors = subscriptionData.validateFormGetErrors(form_el);
                    return {
                        name: 'form',
                        message: errors
                    };
                }
            } else {
                return false;
            }
            return true;
        },

        validateFormCustom: function(form_el, step) {
            switch (step) {
                case 'personalData':
                case 'cardData':
                    var document_number_field = form_el.querySelector('input[name="document_number"]');
                    var document_number_field_value = subscriptionData.getOnlyNumbers(document_number_field.value);

                    if (!subscriptionData.validateDocumentNumber(document_number_field_value)) {
                        document_number_field.setCustomValidity('CPF inválido');
                        return false;
                    }

                    subscriptionData.validateHtml5Clear([document_number_field]);
                    return subscriptionData.validateHtml5(form_el);

                case 'address':
                    var zipcode_isvalid = form_el.querySelector('input[name="zipcode_isvalid"]');
                    var zipcode = form_el.querySelector('input[name="zipcode"]');

                    if (zipcode_isvalid.value === 'false') {
                        zipcode.setCustomValidity('CEP inválido');
                        return false;
                    }

                    subscriptionData.validateHtml5Clear([zipcode]);
                    return subscriptionData.validateHtml5(form_el);

                default:
                    return subscriptionData.validateHtml5(form_el);
            }
        },

        validateHtml5: function(form) {
            if (!form.checkValidity()) {
                return false;
            }
            return true;
        },

        validateHtml5Clear: function(fields) {
            fields.forEach(function(el, i) {
                el.setCustomValidity('');
            });
        },

        validateDocumentNumber: function(document_number) {
            if (document_number.length > 11) {
                return subscriptionData.validateCnpj(document_number);
            }
            return subscriptionData.validateCpf(document_number);
        },

        validateCpf: function(strCPF) {
            var Soma;
            var Resto;
            Soma = 0;
            if (strCPF == '00000000000') return false;

            for (i = 1; i <= 9; i++) Soma += parseInt(strCPF.substring(i - 1, i)) * (11 - i);
            Resto = (Soma * 10) % 11;

            if ((Resto == 10) || (Resto == 11)) Resto = 0;
            if (Resto != parseInt(strCPF.substring(9, 10))) return false;

            Soma = 0;
            for (i = 1; i <= 10; i++) Soma += parseInt(strCPF.substring(i - 1, i)) * (12 - i);
            Resto = (Soma * 10) % 11;

            if ((Resto == 10) || (Resto == 11)) Resto = 0;
            if (Resto != parseInt(strCPF.substring(10, 11))) return false;
            return true;
        },

        validateCnpj: function(strCnpj) {
            if (strCnpj == '00000000000000' ||
                strCnpj == '11111111111111' ||
                strCnpj == '22222222222222' ||
                strCnpj == '33333333333333' ||
                strCnpj == '44444444444444' ||
                strCnpj == '55555555555555' ||
                strCnpj == '66666666666666' ||
                strCnpj == '77777777777777' ||
                strCnpj == '88888888888888' ||
                strCnpj == '99999999999999') { return false; }

            tamanho = strCnpj.length - 2;
            numeros = strCnpj.substring(0, tamanho);
            digitos = strCnpj.substring(tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) { pos = 9; }
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(0)) { return false; }

            tamanho += 1;
            numeros = strCnpj.substring(0, tamanho);
            soma = 0;
            pos = tamanho - 7;
            for (i = tamanho; i >= 1; i--) {
                soma += numeros.charAt(tamanho - i) * pos--;
                if (pos < 2) { pos = 9; }
            }
            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
            if (resultado != digitos.charAt(1)) { return false; }

            return true;
        },

        validateFormGetErrors: function(form) {
            var invalidFields = [];

            // Find all invalid fields within the form.
            form.querySelectorAll(':invalid').forEach(function(node, index) {
                var messageEl = node.querySelector('.subscription-error-message');

                if (messageEl !== null) {
                    invalidFields.push({
                        error_element: messageEl,
                        element: messageEl.previousSibling.previousSibling,
                        message: messageEl.textContent
                    });
                }
            });

            return invalidFields;
        },

        getOnlyNumbers: function(str) {
            return str.replace(/[^0-9]/g, '');
        },

        saveCardDataToDB: function(validation, callback) {
            subscriptionRenders.showLoading();

            var errors = validation.errors;

            $.ajax({
                method: 'POST',
                data: {
                    card_holder_name: $('#subscriptionCardData [name=card_holder_name]').val(),
                    document_number: $('#subscriptionCardData [name=document_number]').val(),
                    email: $('#subscriptionCardData [name=email]').val(),
                    ddd: $('#subscriptionCardData [name=ddd]').val(),
                    number: $('#subscriptionCardData [name=number]').val()
                },
                url: '/assinatura/saveStep/cardData',
                fail: function(e) {
                    var data = e.responseJSON;
                    errors = errors.concat(data.errors);
                },
                complete: function() {
                    if (errors && errors.length > 0) {
                        subscriptionModal.showFormErrors(errors);
                        subscriptionRenders.showLoading(false);
                        return false;
                    }
                    callback.call(this);
                }
            });
        },

        pagarMeError: function(error) {
            return {
                errors: [{
                    name: 'card_number',
                    message: 'Cartão em formato incorreto.'
                }],
                card: {},
                promisse: null
            };
        },

        pagarMeErrorElo: function() {
            return {
                errors: [{
                    name: 'card_number',
                    message: 'O cartão deve ser da bandeira Elo.'
                }],
                card: {},
                promisse: null
            };
        },

        pagarMeErrorBb: function() {
            return {
                errors: [{
                    name: 'card_number',
                    message: 'O cartão deve ser do Banco do Brasil.'
                }],
                card: {},
                promisse: null
            };
        },

        pagarMeValidateCardData: function() {
            subscriptionRenders.showLoading();
            var card = {};
            card.card_holder_name = $('#subscriptionModal [name=card_holder_name]').val();
            card.card_expiration_date = $('#subscriptionModal [name=card_expiration_date]').val();
            card.card_number = $('#subscriptionModal [name=card_number]').val();
            card.card_cvv = $('#subscriptionModal [name=card_cvv]').val();
            var field_errors = [];
            var cardValidations = {};

            if (isSpecificCardPlan('bb', this.plan.plan_id) && !cardIINMatchsCardBrand('bb', card.card_number.replace(/\s/g, ''))) {
                return subscriptionData.pagarMeErrorBb();
            }

            if (isSpecificCardPlan('elo', this.plan.plan_id) && !cardIINMatchsCardBrand('elo', card.card_number.replace(/\s/g, ''))) {
                return subscriptionData.pagarMeErrorElo();
            }

            try {
                cardValidations = pagarme.validate({ card: card });
            } catch (err) {
                return subscriptionData.pagarMeError(err);
            }

            if (!cardValidations.card.card_holder_name || card.card_holder_name.length <= 2) {
                field_errors.push({
                    name: 'card_holder_name',
                    message: 'Nome obrigatório.'
                });
            }
            if (!cardValidations.card.card_expiration_date) {
                field_errors.push({
                    name: 'card_expiration_date',
                    message: 'Validade incorreta.'
                });
            }
            if (!cardValidations.card.card_number) {
                field_errors.push({
                    name: 'card_number',
                    message: 'Cartão em formato incorreto.'
                });
            }
            if (!cardValidations.card.card_cvv) {
                field_errors.push({
                    name: 'card_cvv',
                    message: 'CVV incorreto.'
                });
            }

            if (cardValidations.card.brand) {
                subscriptionData.saveLocalItem('cardData', 'card_brand', cardValidations.card.brand);
            }

            var form_valid = subscriptionData.validateForm('cardData');
            if (form_valid !== true) {
                field_errors.push(form_valid);
            }

            return {
                errors: field_errors,
                card: card,
                promisse: pagarme.client.connect({ encryption_key: subscriptionModal.encryptionKey })
            };
        },

        pagarMeFetchCreditCard: function(validation, goto) {
            subscriptionRenders.showLoading();

            subscriptionData.saveCardDataToDB(validation, function() {
                validation.promisse.then(function(client) {
                    if (!client.security) {
                        subscriptionRenders.showLoading(false);
                        return false;
                    }
                    client.security.encrypt(validation.card).then(function(card_hash) {
                        subscriptionRenders.showLoading(false);
                        if (card_hash) {
                            subscriptionData.saveLocalItem('cardData', 'card_hash', card_hash);

                            if (!subscriptionRenders.renderNextStep(goto)) {
                                subscriptionRenders.showFatalError('Não foi possível ir para a próxima etapa');
                            }

                            subscriptionRenders.showStep(goto);
                            return true;
                        }
                        subscriptionRenders.showFatalError('Ocorreu um erro ao validar seu cartão');
                        return false;
                    });
                });
            });
            return false;
        },

        postcodeSearch: function(postcode, fallback) {
            $('#subscriptionAddress [name=zipcode]').addClass('zipcode-searching');
            $('#subscriptionAddress [name=street]').attr('disabled', true);
            $('#subscriptionAddress [name=neighborhood]').attr('disabled', true);
            $('#subscriptionAddress [name=city]').attr('disabled', true);
            $('#subscriptionAddress [name=state]').attr('disabled', true);

            var postcode = postcode !== undefined ? postcode : subscriptionData.buffer.address.zipcode != null ? subscriptionData.buffer.address.zipcode.replace(/-/g, '') : '';
            var fallback = fallback !== undefined ? fallback : false;
            var gatewayChoice = subscriptionData.postcodeChooseGateway(postcode, fallback);

            $.ajax({
                    url: gatewayChoice.zipGatewayUrl,
                    method: 'GET',
                    dataType: 'json',
                    timeout: 1500
                })
                .done(function(address) {
                    if (address.erro) {
                        subscriptionData.postcodeSearch(postcode, true);
                        return false;
                    }

                    var data = {};
                    for (var key in gatewayChoice.zipGatewayFields) {
                        data[key] = address[gatewayChoice.zipGatewayFields[key]];
                    }

                    $('#subscriptionAddress [name=zipcode_isvalid]').val('true');
                    subscriptionData.postcodeComplete(data);
                })
                .fail(function(data, status) {
                    if (status === 'error' && gatewayChoice.zipGatewayName !== 'pagarme') {
                        subscriptionData.postcodeSearch(postcode, true);
                    }

                    if (status === 'timeout') {
                        subscriptionData.postcodeSearch(postcode);
                    }

                    subscriptionData.postcodeReset();
                    $('#subscriptionAddress [name=zipcode_isvalid]').val('false');
                });
        },

        postcodeChooseGateway: function(postcode, fallback) {
            var gatewayChoosen;
            var gatewayRand = (Math.floor((Math.random() * 2) + 1) - 1);
            var gatewayList = [{
                    zipGatewayName: 'viacep',
                    zipGatewayUrl: 'https://viacep.com.br/ws/' + postcode + '/json/',
                    zipGatewayFields: {
                        street: 'logradouro',
                        neighborhood: 'bairro',
                        city: 'localidade',
                        state: 'uf'
                    },
                    run: 0
                },
                {
                    zipGatewayName: 'postmon',
                    zipGatewayUrl: 'https://api.postmon.com.br/v1/cep/' + postcode,
                    zipGatewayFields: {
                        street: 'logradouro',
                        neighborhood: 'bairro',
                        city: 'cidade',
                        state: 'estado'
                    },
                    run: 0
                }
            ];

            var fallbackGateway = {
                zipGatewayName: 'pagarme',
                zipGatewayUrl: 'https://api.pagar.me/1/zipcodes/' + postcode,
                zipGatewayFields: {
                    street: 'street',
                    neighborhood: 'neighborhood',
                    city: 'city',
                    state: 'state'
                },
                run: 0
            };

            if (fallback === true) {
                gatewayChoosen = fallbackGateway;
                gatewayChoosen.run = fallbackGateway.run + 1;
            } else {
                gatewayChoosen = gatewayList[gatewayRand];
                gatewayChoosen.run = fallbackGateway.run + 1;
            }

            return gatewayChoosen;
        },

        postcodeComplete: function(data) {
            if (data.street) {
                $('#subscriptionAddress [name=street]').val(data.street);
                $('#subscriptionAddress [name=street_number]').focus();
            }
            if (data.neighborhood) {
                $('#subscriptionAddress [name=neighborhood]').val(data.neighborhood);
            }
            if (data.city) {
                $('#subscriptionAddress [name=city]').val(data.city);
            }
            if (data.state) {
                $('#subscriptionAddress [name=state]').val(data.state);
            }

            $('#subscriptionAddress [name=zipcode]').removeClass('zipcode-searching');

            // Habilita campos e da trigger de mudança para salvar na memória
            $('#subscriptionAddress [name=street]').attr('disabled', false).change();
            $('#subscriptionAddress [name=neighborhood]').attr('disabled', false).change();
            $('#subscriptionAddress [name=city]').attr('disabled', false).change();
            $('#subscriptionAddress [name=state]').attr('disabled', false).change();
        },

        postcodeReset: function() {
            $('#subscriptionAddress [name=street]').val('');
            $('#subscriptionAddress [name=neighborhood]').val('');
            $('#subscriptionAddress [name=city]').val('');
            $('#subscriptionAddress [name=state]').val('');
        },

        getPlan: function() {
            return subscriptionData.plan;
        },

        getDiscount: function() {
            return subscriptionData.discount;
        },

        getPlanDiscount: function() {
            return subscriptionData.planDiscount;
        }
    };

    var subscriptionRenders = {
        /**
         * Google Tag's tracking tags
         * @param {string} step
         * @param {value} value
         */
        stepTagger: function(step) {
            var plan = subscriptionData.getPlan();
            var paymentMethod = subscriptionData.paymentMethod + '_';

            if (typeof dataLayer === 'undefined') {
                return false;
            }

            // Label according to step
            switch (step) {
                case 'paymentMethod':
                    dataLayer.push({ event: paymentMethod + 'init' });
                    break;
                case 'personalData':
                case 'cardData':
                    dataLayer.push({ event: paymentMethod + 'info' });
                    break;
                case 'address':
                    dataLayer.push({ event: paymentMethod + 'address' });
                    break;
                case 'finish':
                    dataLayer.push({ event: paymentMethod + 'finish' });

                    // Label purchase according to plan
                    if (plan.plan_id === 1) {
                        dataLayer.push({ event: 'purchase_plus' });
                    } else if (plan.plan_id === 2) {
                        dataLayer.push({ event: 'purchase_premium' });
                    } else if (plan.plan_id === 5) {
                        dataLayer.push({ event: 'purchase_premium_90' });
                    } else if (plan.plan_id === 6) {
                        dataLayer.push({ event: 'purchase_premium_180' });
                    } else if (plan.plan_id === 9) {
                        dataLayer.push({ event: 'purchase_plus_90' });
                    } else if (plan.plan_id === 10) {
                        dataLayer.push({ event: 'purchase_premium_360' });
                    }
                    if (subscriptionData.getDiscount()) {
                        // Today we only have mensal plus with discount
                        dataLayer.push({ event: 'purchase_plus' });
                    }

                    if (typeof subscriptionPage === 'string') {
                        dataLayer.push({ event: subscriptionPage });
                    }
                    break;
                default:
                    return false;
            }
        },

        getTemplate: function(id) {
            return $('#' + id).html();
        },

        renderNextStep: function(goto) {
            var nextStepReady;

            switch (goto) {
                case 'friendsList':
                case 'paymentMethod':
                    nextStepReady = true;
                    break;
                case 'personalData':
                    nextStepReady = subscriptionRenders.renderPersonalData();
                    break;
                case 'cardData':
                    nextStepReady = subscriptionRenders.renderCardData();
                    break;
                case 'address':
                    nextStepReady = subscriptionRenders.renderAddress();
                    break;
                case 'reviewCardPayment':
                    nextStepReady = subscriptionRenders.renderReviewCardPayment();
                    break;
                case 'billet':
                    nextStepReady = subscriptionModal.processGenerateBillet();
                    break;
                case 'success':
                    nextStepReady = subscriptionRenders.renderSuccessCard();
                    break;
                case 'changeConfirm':
                    nextStepReady = subscriptionRenders.renderChangeConfirm();
                    break;
                case 'changeSuccess':
                    nextStepReady = subscriptionRenders.renderChangeSuccess();
                    break;
                case 'fatalError':
                    nextStepReady = subscriptionRenders.renderFatalError();
                    break;
                case 'recoverableError':
                    nextStepReady = subscriptionRenders.renderRecoverableError();
                    break;
                default:
                    nextStepReady = false;
            }
            this.hideStepError();

            if (!nextStepReady) {
                subscriptionRenders.showFatalError('Não foi possível ir para a próxima etapa');
                return false;
            }

            return true;
        },

        renderFriends: function(plan) {
            var data = {};
            var rendered = Mustache.render(
                subscriptionRenders.getTemplate(subscriptionModal.steps.friendsList),
                data
            );
            $('#subscriptionFriends').html(rendered);

            window.requestAnimationFrame(function() {
                subscriptionHelpers.selectFriends(friendsArray);
            });

            return true;
        },

        renderPaymentMethods: function() {
            var plan = subscriptionData.getPlan();
            var data = {
                canBillet: (subscriptionModal.language === 'pt-br') && (plan.plan_id != 8)
            };
            var rendered = Mustache.render(
                subscriptionRenders.getTemplate(subscriptionModal.steps.paymentMethod),
                data
            );
            $('#subscriptionPaymentMethod').html(rendered);
            return true;
        },

        renderPersonalData: function() {
            var data = {};

            var rendered = Mustache.render(
                subscriptionRenders.getTemplate(subscriptionModal.steps.personalData),
                data
            );
            $('#subscriptionPersonalData').html(rendered);

            subscriptionHelpers.maskInputs();

            return true;
        },

        renderCardData: function() {
            var data = {};
            var plan = subscriptionData.getPlan();

            // Check if has plan_id
            if (plan && plan.plan_id && subscriptionData.friends.length === 0) {
                // Add plan selected to show disclaimer in credit card view
                if (plan.plan_id === 1 || plan.plan_id === 2) {
                    data.isMonthly = true;
                } else if (plan.plan_id === 5) {
                    data.isQuarterly = true;
                } else if (plan.plan_id === 6) {
                    data.isBiannual = true;
                }

                if (isSpecificCardPlan('elo', plan.plan_id)) {
                    data.isElo = true;
                }

                if (isSpecificCardPlan('bb', plan.plan_id)) {
                    data.isBB = true;
                }
            }

            var render = Mustache.render(
                subscriptionRenders.getTemplate(subscriptionModal.steps.cardData),
                data
            );
            $('#subscriptionCardData').html(render);

            subscriptionHelpers.maskInputs();

            return true;
        },

        renderAddress: function() {
            var data = {};

            if (subscriptionData.paymentMethod) {
                data.isBillet = (subscriptionData.paymentMethod === 'billet');
            }

            var rendered = Mustache.render(
                subscriptionRenders.getTemplate(subscriptionModal.steps.address),
                data
            );
            $('#subscriptionAddress').html(rendered);

            subscriptionHelpers.maskInputs();
            subscriptionData.postcodeSearch();

            return true;
        },

        renderReviewCardPayment: function() {
            var plan = subscriptionData.getPlan();
            var data = {
                buffer: subscriptionData.buffer,
                friends: subscriptionData.friends
            };

            friends_count = subscriptionData.friends.length;
            if (friends_count == 0) {
                friends_count = 1;
            }
            var calculatedPrice = (friends_count * plan.price).toFixed(2);

            data.buffer.cardData.snippet = data.buffer.cardData.card_number.substr(0, 4);
            data.buffer.plan.formattedPrice = calculatedPrice;
            data.buffer.plan.currencySymbol = plan.currency_symbol;

            data.buffer.plan.recurrenceTime = 'mensal';
            if (plan && plan.plan_id) {
                switch (plan.plan_id) {
                    case 5:
                        data.buffer.plan.recurrenceTime = 'trimestral';
                        break;

                    case 6:
                        data.buffer.plan.recurrenceTime = 'semestral';
                        break;

                    case 8:
                        data.buffer.plan.recurrenceTime = 'anual';
                        break;

                    default:
                        break;
                }
            }

            var render = Mustache.render(
                subscriptionRenders.getTemplate(subscriptionModal.steps.reviewCardPayment),
                data
            );

            $('#subscriptionReviewCardPayment').html(render);
            $('#finalFriends').scrollbar();
            return true;
        },

        renderChangeConfirm: function(data) {
            var data = {
                isDowngrade: !subscriptionModal.isUpgrade()
            };

            var plan_id = subscriptionData.plan.plan_id;

            if (subscriptionModal.isUpgrade()) {
                data.proportionalPrice = subscriptionData.buffer.changeConfirm[plan_id].proportionalUpgradePrice;
                data.fullPrice = subscriptionData.buffer.changeConfirm[plan_id].fullUpgradePrice;

                var render = Mustache.render(
                    subscriptionRenders.getTemplate(subscriptionModal.steps.changeConfirm),
                    data
                );
                $('#subscriptionChangeConfirm').html(render);
            } else {
                var render = Mustache.render(
                    subscriptionRenders.getTemplate(subscriptionModal.steps.changeConfirm),
                    data
                );
                $('#subscriptionChangeConfirm').html(render);
            }
        },

        renderChangeSuccess: function() {
            var data = {};
            subscriptionModal.updateOnClose = true;

            var render = Mustache.render(
                subscriptionRenders.getTemplate(subscriptionModal.steps.changeSuccess),
                data
            );
            $('#subscriptionChangeSuccess').html(render);
            return true;
        },

        renderFatalError: function(data) {
            var render = Mustache.render(
                subscriptionRenders.getTemplate(subscriptionModal.steps.fatalError),
                data
            );
            $('#subscriptionFatalError').html(render);
            return true;
        },

        renderRecoverableError: function(data) {
            var render = Mustache.render(
                subscriptionRenders.getTemplate(subscriptionModal.steps.recoverableError),
                data
            );
            $('#subscriptionRecoverableError').html(render);
            return true;
        },

        renderSuccessCard: function() {
            var plan = subscriptionData.getPlan();
            var data = {
                plan_name: plan.title,
                isPlus: subscriptionData.isPlus(),
                friends: subscriptionData.friends
            };

            subscriptionModal.updateOnClose = true;

            var render = Mustache.render(
                subscriptionRenders.getTemplate(subscriptionModal.steps.success),
                data
            );

            $('#subscriptionSuccess').html(render);
            $('.subscription-play-now').click(function(e) {
                e.preventDefault();
                $('.play-now').click();
                subscriptionModal.close();
            });
            return true;
        },

        renderBreadcrumb: function(data, currentStep) {
            var stepList = {
                friendsList: {
                    index: 0,
                    step: 'friendsList',
                    name: i18n.sub_step_one_b,
                    isEnabled: false,
                    isActive: false
                },
                paymentMethod: {
                    index: 1,
                    step: 'paymentMethod',
                    name: i18n.sub_step_two,
                    isEnabled: false,
                    isActive: false
                },
                cardData: {
                    index: 2,
                    step: 'cardData',
                    name: i18n.sub_step_three,
                    isEnabled: false,
                    isActive: false
                },
                personalData: {
                    index: 2,
                    step: 'personalData',
                    name: i18n.sub_step_three_b,
                    isEnabled: false,
                    isActive: false
                },
                address: {
                    index: 3,
                    step: 'address',
                    name: i18n.sub_step_four,
                    isEnabled: false,
                    isActive: false
                },
                reviewCardPayment: {
                    index: 4,
                    step: 'reviewCardPayment',
                    name: i18n.sub_step_five,
                    isEnabled: false,
                    isActive: false
                }
            };

            if (!subscriptionModal.isForFriends()) {
                delete stepList.friendsList;
            }

            if (data.eloPlan) {
                delete stepList.paymentMethod;
            }

            if (data.isBillet) {
                delete stepList.cardData;
                delete stepList.reviewCardPayment;
            } else {
                delete stepList.personalData;
            }

            var activeStep = 0;
            if (stepList[currentStep]) {
                stepList[currentStep].isActive = true;
                activeStep = stepList[currentStep].index;
            }

            data.steps = [];
            $.each(stepList, function(index, stepData) {
                if (stepData.index < activeStep || (currentStep === 'friendsList' && stepData.index === 0)) {
                    stepList[index].isEnabled = true;
                }

                data.steps.push(stepList[index]);
            });

            var rendered = Mustache.render(subscriptionModalBreadcrumbTemplate, data);
            $('#subscriptionModalBreadcrumb').html(rendered);

            return true;
        },

        updateBreadcrumb: function(goto) {
            var data = {
                isBillet: (subscriptionData.paymentMethod === 'billet'),
                eloPlan: isSpecificCardPlan('elo', subscriptionData.plan.plan_id),
                bbPlan: isSpecificCardPlan('bb', subscriptionData.plan.plan_id)
            };

            subscriptionRenders.renderBreadcrumb(data, goto);
        },

        gotoStep: function(goto, value) {
            $('#subscriptionModal .subscription-error-active').removeClass('subscription-error-active');

            var stepValidation = subscriptionData.validateStep(subscriptionModal.currentStep, value);

            if (!goto && typeof(goto) !== 'undefined') {
                subscriptionRenders.showFatalError('Não foi possível ir para a próxima etapa');
                return false;
            }

            var errors = subscriptionHelpers.convertJSON(stepValidation.errors);
            if (errors && errors.length > 0) {
                subscriptionRenders.showFormErrors(errors);
                return false;
            }

            if (errors.name === 'form') {
                if (subscriptionModal.currentStep == 'friendsList') {
                    $('.select2').after('<div class="subscription-error-message subscription-error-active">Nenhum amigo selecionado</div>');
                }

                return false;
            }

            subscriptionRenders.stepTagger(subscriptionModal.currentStep);

            if (stepValidation.card) {
                subscriptionData.pagarMeFetchCreditCard(stepValidation, goto);
                return;
            }

            if (subscriptionModal.currentStep === 'friendsList') {
                subscriptionData.friends = [];
                $('.select2-selection__choice').each(function(i, el) {
                    friendData = $(el).find('.userName');
                    subscriptionData.friends.push({
                        nick: $(friendData).data('user-nick'),
                        avatar: $(friendData).data('user-avatar'),
                        id: $(friendData).data('user-id')
                    });
                });
            }

            if (typeof stepValidation === 'object' && stepValidation.done) {
                subscriptionRenders.showLoading();
                stepValidation.done(function(data) {
                    var errors = subscriptionHelpers.convertJSON(data.errors);

                    // Caso haja erros na validação backend
                    if (errors && errors.length > 0) {
                        subscriptionRenders.showFormErrors(errors);
                        return false;
                    }

                    subscriptionRenders.hideStepError();
                    subscriptionRenders.showLoading(false);

                    if (!subscriptionRenders.renderNextStep(goto)) {
                        subscriptionRenders.showFatalError('Não foi possível ir para a próxima etapa');
                    }
                    subscriptionRenders.showStep(goto);
                }).fail(function(e) {
                    var data = e.responseJSON;

                    if (data.success === false) {
                        subscriptionRenders.showStepError(data.message);
                        return false;
                    }
                });

                stepValidation.error(function() {
                    subscriptionRenders.showFatalError('Não foi possivel salvar os dados no servidor');
                });
            } else if (stepValidation === true) {
                if (goto === 'billet') {
                    goto = 'personalData';
                } else if (goto === 'card') {
                    goto = 'cardData';
                }

                if (!subscriptionRenders.renderNextStep(goto)) {
                    subscriptionRenders.showFatalError('Não foi possível ir para a próxima etapa');
                }

                subscriptionRenders.showStep(goto);
            } else {
                subscriptionRenders.showFatalError('Não foi possível ir para a próxima etapa');
            }
        },

        showStep: function(goto) {
            subscriptionModal.currentStep = goto;
            $('#subscriptionModal .subscription-modal-step-active').removeClass('subscription-modal-step-active');

            if (goto === 'personalData' || goto === 'cardData' || goto === 'address') {
                subscriptionData.loadStepData(goto);
            }

            subscriptionModal.container.attr('data-current-step', goto);
            subscriptionRenders.updateBreadcrumb(goto);

            // It prevents a bug that wrongly place the screen during the transition, but, create another bug that just flicker/repeat the breadcrumb animation
            setTimeout(function() {
                $('#subscriptionModal [subscription-step=' + goto + ']').addClass('subscription-modal-step-active');
            }, 200);

            subscriptionModal.container.scrollTop(0);
        },

        showPendingPayment: function() {
            var billetInfo = subscriptionData.buffer.billet;
            var buttonManagerSubscription = false;
            if (billetInfo) {
                var data = {
                    pending: true,
                    subscriptionType: subscriptionData.buffer.currentSubscription,
                    billet: {
                        url: billetInfo.url,
                        code: billetInfo.code,
                        barcode: billetInfo.barcode,
                        amount: billetInfo.amountView
                    }
                };
                var render = Mustache.render(
                    subscriptionRenders.getTemplate(subscriptionModal.steps.successBillet),
                    data
                );

                $('#subscriptionSuccessBillet').html(render);
                subscriptionRenders.showStep('successBillet');
                subscriptionRenders.showProcessing(false);
                return true;
            }

            if (subscriptionData.buffer.card) {
                buttonManagerSubscription = true;
            }

            subscriptionData.hasPendingPayment = true;

            subscriptionRenders.showFatalError(
                'Assinatura com pagamento pendente',
                'Identificamos que você possui uma assinatura com pagamento pendente, verifique em seu perfil ou e-mail as instruções para pagamento. Em caso de dúvidas, favor entrar em contato com nosso suporte pelo site.',
                buttonManagerSubscription
            );
        },

        showActiveSubscriptionError: function() {
            subscriptionRenders.showFatalError(
                'OPA! VOCÊ JÁ POSSUI UMA ASSINATURA ATIVA :)',
                'Identificamos que você já possui uma assinatura ativa na Gamers Club. Se você não está com a sua medalha de assinante ou precisar de alguma ajuda fale com a nossa equipe.<br><br><button onclick="$crisp.push([\'do\', \'chat:open\'])" class="button">Fale com o suporte</button>'
            );
            return false;
        },

        showStepError: function(message) {
            var message_el = document.getElementById('stepErrorMessage');
            if (typeof(message_el) === 'undefined' || !message_el.classList) {
                return false;
            }

            message_el.innerHTML = message;
            message_el.classList.remove('hidden');
            subscriptionRenders.showLoading(false);
        },

        showFormErrors: function(errors) {
            $.each(errors, function(key, error) {
                var field = $('#subscriptionModal [name="' + error.name + '"]');
                if (field.length > 0) {
                    field
                        .siblings('.subscription-error-message')
                        .text(error.message)
                        .addClass('subscription-error-active');
                }
            });
            subscriptionRenders.showLoading(false);
        },

        showFatalError: function(title, message, button) {
            var data = {
                title: title,
                message: message != 'undefined' ? message : false,
                button: button != 'undefined' ? button : false,
                simple: false
            };

            if (typeof message === 'string') {
                data.simple = true;
            }
            subscriptionRenders.renderFatalError(data);
            subscriptionRenders.showStep('fatalError');
            subscriptionRenders.showProcessing(false);
            return true;
        },

        showRecoverableError: function(title, message, step) {
            var data = {
                title: title,
                message: message,
                step: step != 'undefined' ? step : false
            };

            subscriptionRenders.renderRecoverableError(data);
            subscriptionRenders.showStep('recoverableError');
            subscriptionRenders.showProcessing(false);
        },

        showLoading: function(loaded) {
            if (loaded === false) {
                subscriptionModal.container.removeClass('subscription-modal-loading');
                return true;
            }
            subscriptionModal.container.addClass('subscription-modal-loading');
            return false;
        },

        showProcessing: function(finished) {
            if (finished === false) {
                subscriptionModal.container.removeClass('subscription-modal-process');
                return true;
            }
            subscriptionModal.container.addClass('subscription-modal-process');
            return true;
        },

        hideStepError: function() {
            document.getElementById('stepErrorMessage').classList.add('hidden');
        }
    };


    var subscriptionPromo = {

        blackfriday: function() {
            var hash = window.location.hash;

            if (hash === '') { return; }

            hash = hash.toLocaleLowerCase().substring(1);

            if (!hash.match(/blackfriday?/)) {
                return;
            }

            var plan = 0;
            var modalType = 'subscribe';
            var language = 'pt-br';
            var hash = window.location.hash.toLocaleLowerCase().substring(1);

            if (hash === 'blackfriday-year') {
                plan = 8;
                modalType = 'subscribe';

                $.ajax({
                        method: 'get',
                        url: '/api/plans/annualPlanRemaining'
                    })
                    .done(function(msg) {
                        subscriptionModal.loadModal({
                            modalType: modalType,
                            plan: plan,
                            canUsePromotion: msg.data.remaining > 0,
                            language: language,
                            elementOrigin: $(document.createElement('div'))
                        });
                    });
                return;
            }

            if (plan === 0) { return; }

            subscriptionModal.loadModal({
                modalType: modalType,
                plan: plan,
                language: language,
                elementOrigin: $(document.createElement('div'))
            });
        }
    };

    var subscriptionHelpers = {
        maskInputs: function() {
            $('[name=ddd]').mask('000');
            $('[name=number]').mask('000000000');
            $('[name=card_cvv]').mask('0000');
            $('[name=card_expiration_date]').mask('00/00');
            $('[name=card_number]').mask('0000 0000 0000 0000 000');

            var cpfOptions = {
                onKeyPress: function(cpf, ev, el, op) {
                    var masks = ['000.000.000-000', '00.000.000/0000-00'];
                    var mask = (cpf.length > 14) ? masks[1] : masks[0];
                    $('[name=document_number]').mask(mask, cpfOptions);
                }
            };
            // CPF Brasil
            $('[name=document_number]').mask('000.000.000-000', cpfOptions);
            $('[name=zipcode]').mask('00000-000');
        },

        mustacheHelper: {
            // Faz o parse do template e envia para o contexto global
            parse: function(parsed) {
                var parsed_item = false;
                if ((!window[parsed] || typeof window[parsed] === 'object') && (parsed_item = document.getElementById(parsed))) {
                    window[parsed] = parsed_item.innerHTML;
                    Mustache.parse(window[parsed]);
                } else if (!window[parsed]) {
                    console.error('Não foi possível renderizar', parsed);
                }
            },
            // Faz o parse de multiples templates e envia para o contexto global
            parseMultiple: function(parsed) {
                var template_quantity = parsed.length;
                var parsed_item;
                for (var i = 0; i < template_quantity; i++) {
                    if ((!window[parsed[i]] || typeof window[parsed[i]] === 'object') && (parsed_item = document.getElementById(parsed[i]))) {
                        window[parsed[i]] = parsed_item.innerHTML;
                        Mustache.parse(window[parsed[i]]);
                    } else if (!window[parsed[i]]) {
                        console.error('Não foi possível renderizar', parsed[i]);
                    }
                }
            }
        },

        selectFriends: function(dataArray) {
            jQuery('#friends-list').select2({
                    tags: true,
                    placeholder: i18n.sub_friends_click_to_see_your_friends,
                    width: '100%',
                    data: dataArray,
                    templateResult: subscriptionHelpers.selectFriendsAddUserPic,
                    templateSelection: subscriptionHelpers.selectFriendsAddUserPic,
                    // Quando alguém tentar criar uma tag que esteja fora da lista de amigos.
                    createTag: function(params) {
                        return undefined;
                    }
                })
                .on('select2:select', function(e) {
                    // Ação quando um elemento é selecionado
                    var friendId = e.params.data.id;
                    friendsArray = friendsArray.filter(function(friend) {
                        return friend.selected = (friend.id == friendId);
                    });
                })
                .on('select2:unselect', function(e) {
                    // Ação quando um elemento é deselecionado
                    var friendId = e.params.data.id;
                    friendsArray = friendsArray.filter(function(friend) {
                        return friend.selected = (friend.id == friendId);
                    });
                });

            $('#friends-list').on('change', function(e) {
                var plan = subscriptionData.getPlan();
                var playersChosen = Array.from(new Set($(this).val()));
                var totalPlayers;

                totalPlayers = 0;
                if (playersChosen !== null) {
                    totalPlayers = playersChosen.length;
                }

                currencySymbol = plan.currency_symbol;
                formattedPrice = ((plan.price * totalPlayers) * 1).toFixed(2);

                $('.amigos-total .valor-moeda').html(currencySymbol);
                $('.amigos-total .valor-total').html(formattedPrice);
            });
        },

        selectFriendsAddUserPic: function(data) {
            if (!data.id) {
                return data.text;
            }

            if (!data.avatar) {
                return data.text;
            }
            var $data = $(
                '<span class="userName" data-user-avatar="' + data.avatar + '" data-user-nick="' + data.text + '" data-user-id="' + data.id + '" ><img src="' + data.avatar + '" class="userPic" /> ' + data.text + '</span>'
            );
            return $data;
        },

        convertJSON: function(input) {
            if (typeof(input) === 'undefined') {
                return false;
            }

            if (typeof(input) === 'object') {
                return input;
            }

            var json_converted = {};

            try {
                json_converted = JSON.parse(input);
                return json_converted;
            } catch (e) {
                subscriptionRenders.showFatalError('Erro geral durante o processamento do pagamento');
                return false;
            }
        }
    };

    subscriptionModal.init();
});

// Nova implementação para pagamentos / Baseada em itens e não apenas medalhas
$(function() {

    var that = this;

    var mustache_helper = {
            // Parse template and set it to the 'window' object
            parse: function (parsed) {
                var parsed_item = false;
                if ( (!window[parsed] || typeof window[parsed] === 'object') && (parsed_item = document.getElementById(parsed)) ) {
                    window[parsed] = parsed_item.innerHTML;
                    Mustache.parse(window[parsed]);
                } else if (!window[parsed]) {
                    console.error('Não foi possível renderizar', parsed);
                }
            },
            // Parse multiple templates and set it to the 'window' object
            parseMultiple: function (parsed) {
                var template_quantity = parsed.length,
                    parsed_item;
                for (var i = 0; i < template_quantity; i++) {
                    if ( (!window[parsed[i]] || typeof window[parsed[i]] === 'object') && (parsed_item = document.getElementById(parsed[i])) ) {
                        window[parsed[i]] = parsed_item.innerHTML;
                        Mustache.parse(window[parsed[i]]);
                    } else if (!window[parsed[i]]) {
                        console.error('Não foi possível renderizar', parsed[i]);
                    }
                }
            }
    };

    /***
     *     __                  ___      ___     __       ___
     *    |__)  /\  \ /  |\/| |__  |\ |  |     |  \  /\   |   /\
     *    |    /~~\  |   |  | |___ | \|  |     |__/ /~~\  |  /~~\
     *
     */

    /**
     * Data, data helpers used by the modal during the payment process
     *
     * @var object
     */
    var gcPaymentData = {
        pagarMeToken: 'ek_live_srfbBrRo8RPqRVNKDLy6haHdiR8KDh',

        paymentMethod: null, // self, friends
        paymentType: null, // billet, card
        paymentClientMeta: {}, // contain all needed information for the item, usually it passes the item id, entity id, etc
        hasPendingPayment: false,

        forFriends: false,
        friends: [],
        buffer: {},

        tagsDiscoverGoogleEvents: {
            'self': {
                1: 'personal_30', // PAYMENT_ITEM_DISCOVER_PERSONAL_FREE
                2: 'personal_60', // PAYMENT_ITEM_DISCOVER_PERSONAL_PLUS
                3: 'personal_90', // PAYMENT_ITEM_DISCOVER_PERSONAL_PREMIUM

                4: 'team_30', // PAYMENT_ITEM_DISCOVER_TEAM_FREE
                5: 'team_60', // PAYMENT_ITEM_DISCOVER_TEAM_PLUS
                6: 'team_90', // PAYMENT_ITEM_DISCOVER_TEAM_PREMIUM

                7: 'position_30', // PAYMENT_ITEM_DISCOVER_VACANCY_FREE
                8: 'position_60', // PAYMENT_ITEM_DISCOVER_VACANCY_PLUS
                9: 'position_90', // PAYMENT_ITEM_DISCOVER_VACANCY_PREMIUM
            },
            'friends': {
                1: 'friend_personal_30', // PAYMENT_ITEM_DISCOVER_PERSONAL_FREE
                2: 'friend_personal_60', // PAYMENT_ITEM_DISCOVER_PERSONAL_PLUS
                3: 'friend_personal_90', // PAYMENT_ITEM_DISCOVER_PERSONAL_PREMIUM
            },
        },

        saveLocal: function (step, value, validate) {
            if (validate !== false) {
                return this.validateForm(step);
            }

            return true;
        },

        /**
         * Salva conteúdo de um campo na memória do js
         *
         * @param  {string} step  Passo atual
         * @param  {string} key   Name do input
         * @param  {string} value Valor do input
         * @return {bool}         Retorna verdadeiro se salvo com exito
         */
        saveLocalItem: function (step, key, value) {
            // Do not save the CVV from Credit paymentItemCard
            if (key === 'card_cvv') {
                return false;
            }
            if (!this.buffer[step]) { this.buffer[step] = {}; }
            this.buffer[step][key] = value;
            return true;
        },

        alreadyOwnItem: function (items) {
            items.forEach(function(val, i) {
                if (val.entity_id == gcPaymentData.paymentClientMeta.paymentEntity && val.item_id == gcPaymentData.paymentClientMeta.paymentItem.id) {
                    return true;
                }
            });
        },

        /**
         * Carrega dados do formulário salvos no javascript
         *
         * @param  {string} step Passo atual
         * @return {object}      Lista de itens e valores salvos
         */
        loadStepData: function (step) {
            var hasStep = this.buffer.hasOwnProperty(step);
            if (step !== 'confirm' && hasStep) {
                $.each(this.buffer[step], function (name, value) {
                    $('#gcPaymentsModal [name="' + name + '"]').val(value);

                    // Simulate keyUp so card mock iamge update
                    if (step === "card_data" && name === "card_holder_name") {
                        $('#gcPaymentsModal [name="' + name + '"]').trigger('keyup');
                    }
                });
            }
        },

        /**
         * Carrega dados do usuário da base de dados e envia para a próxima etapa
         *
         * @return {object} Dados do usuário
         */
        loadBillingInfo: function () {
            var that = this;
            var item;
            $.getJSON('/payments/billing-info')
                .done(function(data) {
                    if (typeof(data) !== 'undefined' && data.success === true) {
                        if (!gcPaymentData.forFriends) {
                            item = gcPaymentData.paymentClientMeta.paymentItem.id;
                            if (data.isWaitingPayment && Object.keys(data.billet).length > 0 && item == data.billet.billetItem) {
                                gcPayments.goToPendingPaymentBillet(data);
                            } else if (gcPaymentData.alreadyOwnItem(data.card)) {
                                gcPayments.showFatalError(
                                    'Você já pagou por este item',
                                    'Identificamos que você já solicitou este item e efetuou o pagamento do mesmo, aguarde alguns instantes que estará disponível na sua conta. Caso isso não aconteça, entre em contato com nosso suporte.'
                                );
                            }
                        }
                        gcPayments.processing(false);
                        that.buffer = data;
                    }
                });
        },

        /**
         * Load item data that will be paid and all related data
         *
         * @return {object} Dados do usuário
         */
        loadPaymentClientMeta: function (paymentClientMeta) {
            var that = this;
            gcPaymentData.paymentClientMeta = paymentClientMeta;
            $.ajax({
                type: 'POST',
                url: '/payments/payment-item',
                data: {
                    paymentItem: paymentClientMeta.paymentItem
                },
                dataType: 'json'
            })
            .done(function(data) {
                if (data.success) {
                    gcPaymentData.paymentClientMeta.paymentItem = data.paymentItem;

                    // Load previously saved billing info
                    gcPaymentData.loadBillingInfo();
                    // Google Tag
                    gcPaymentRenders.stepTagger('purchase_initiate');
                }
            })
            .fail(function() {
                gcPayments.showFatalError(
                    'Item para Pagamento Inválido!',
                    'Não foi possível carregar o item que você está tentando pagar'
                );
            });
        },

        /**
         * Salva dados de cada etapa no banco
         *
         * @param  {string} step  Etapa à ser salva
         * @param  {string} value Valor da etapa
         * @return {object}       Promisse com os handlers success, error, etc...
         */
        setStepData: function (step, value) {
            switch (step) {
                case 'payment_method':
                    this.paymentType = value;
                    return true;
                    break;
                // Dados do cartão são tratados apenas localmente e validados
                case 'card_data':
                    switch(gcPayments.language) {
                        case 'pt-br':
                        case 'english':
                        return this.pagarMeValidateCardData(step, value);
                    }
                // Outros formulários são validados e salvos no servidor além de local
                default:
                    var form_valid = this.saveLocal(step, $('#form_' + step).serialize());
                    if (form_valid !== true) {
                        return {
                            errors: form_valid
                        };
                    }

                    return $.ajax({
                        type: 'POST',
                        dataType: 'json',
                        data: $('#form_' + step).serialize(),
                        url: '/payments/modal-step/' + encodeURIComponent(step),
                    });
            }
        },

        /**
         * Valida formulário
         */
        validateForm: function(form) {
            var form_el = document.getElementById('form_' + form);
            if (form_el && form_el.classList) {
                form_el.classList.add('has-submited');
                if (!form_el.checkValidity()) {
                    return {
                        name: 'form',
                        message: 'Erro no html5.'
                    };
                }
            } else {
                gcPayments.logError('Formulário para validar inexistente: #form_' + form);
                return false;
            }
            return true;
        },

        /**
         * Salva informacoes de basicas do cartão para o banco de dados (somente nome, documento, email, telefone)
         */
        saveCardDataToDB: function(validation, callback) {
            gcPayments.loader();

            var errors = validation.errors;

            $.ajax({
                method: 'POST',
                data: {
                    card_holder_name: $('#gcPaymentsCardData [name=card_holder_name]').val(),
                    document_number: $('#gcPaymentsCardData [name=document_number]').val(),
                    email: $('#gcPaymentsCardData [name=email]').val(),
                    ddd: $('#gcPaymentsCardData [name=ddd]').val(),
                    number: $('#gcPaymentsCardData [name=number]').val()
                },
                url: '/payments/modal-step/card_data',
                fail: function(e) {
                    var data = e.responseJSON;
                    errors = errors.concat(data.errors);
                },
                complete: function() {
                    if (errors && errors.length > 0) {
                        gcPayments.showFormErrors(errors);
                        gcPayments.loader(false);
                        return false;
                    }
                    callback.call(this);
                }
            });
        },

        /**
         * Pagar.ME Error
         */
        pagarMeError: function (error) {
            gcPayments.logError('Erro ao validar cartão Pagar.me: ' + error);

            return {
                errors: [{
                    name: 'card_number',
                    message: 'Cartão em formato incorreto.'
                }],
                card: {},
                promisse: null
            };
        },

        /**
        * Valida os dados do cartão usando a api JS do Pagar.ME
        */
        pagarMeValidateCardData: function() {
            gcPayments.loader();
            var card = {};
                card.card_holder_name = $('#gcPaymentsCardData [name=card_holder_name]').val();
                card.card_expiration_date = $('#gcPaymentsCardData [name=card_expiration_date]').val();
                card.card_number = $('#gcPaymentsCardData [name=card_number]').val();
                card.card_cvv = $('#gcPaymentsCardData [name=card_cvv]').val();
            var field_errors = [];

            // Pega os erros de validação nos campos do form e a bandeira do cartão
            var cardValidations = {};
            try {
                cardValidations = pagarme.validate({ card: card });
            } catch(err) {
                return this.pagarMeError(err);
            }

            // Então você pode verificar se algum campo não é válido
            if (!cardValidations.card.card_holder_name || card.card_holder_name.length <= 2) {
                field_errors.push({
                    name: 'card_holder_name',
                    message: 'Nome obrigatório.'
                });
            }
            if (!cardValidations.card.card_expiration_date) {
                field_errors.push({
                    name: 'card_expiration_date',
                    message: 'Validade incorreta.'
                });
            }
            if (!cardValidations.card.card_number) {
                field_errors.push({
                    name: 'card_number',
                    message: 'Cartão em formato incorreto.'
                });
            }
            if (!cardValidations.card.card_cvv) {
                field_errors.push({
                    name: 'card_cvv',
                    message: 'CVV incorreto.'
                });
            }

            if (cardValidations.card.brand) {
                this.saveLocalItem('card_data', 'card_brand', cardValidations.card.brand);
            }

            var form_valid = this.validateForm('card_data');
            if (form_valid !== true) {
                field_errors.push(form_valid);
            }

            return {
                errors: field_errors,
                card: card,
                promisse: pagarme.client.connect({ encryption_key: this.pagarMeToken }),
            };
        },

        /**
         * Acessa api e retorna validações, hash, etc do cartão de crédito - Pagar.ME
         *
         * @param  {object} validation Dados da validação
         */
        pagarMeFetchCreditCard: function (validation, goto) {
            gcPayments.loader();

            this.saveCardDataToDB(validation, function() {
                validation.promisse.then(function(client) {
                    if (!client.security) {
                        gcPayments.loader(false);
                        gcPayments.logError('Erro ao recuperar promessa do Pagar.me');
                        return false;
                    }
                    client.security.encrypt(validation.card).then(function(card_hash) {
                        if (card_hash) {
                            gcPayments.loader(false);
                            gcPaymentData.saveLocalItem('card_data', 'card_hash', card_hash);

                            if (!gcPayments.renderNextStep(goto)) {
                                gcPayments.logError('Erro ao renderizar  ' + goto + ' partindo de ' + gcPayments.currentStep);
                            }

                            gcPayments.showStep(goto);
                        } else {
                            gcPayments.loader(false);
                            gcPayments.logError('Não foi possível obter o hash do cartão');
                        }
                    });
                });
            })
            return false;
        },

        /**
         * Busca do cep
         *
         * @param  {string} postcode CEP à ser buscado
         */
        postCodeSearch: function (postcode) {
            $('#subscriptionAddress [name=zipcode]').addClass('zipcode-searching');
            $('#subscriptionAddress [name=street]').attr('disabled', true);
            $('#subscriptionAddress [name=neighborhood]').attr('disabled', true);
            $('#subscriptionAddress [name=city]').attr('disabled', true);
            $('#subscriptionAddress [name=state]').attr('disabled', true);

            var zipGateway;
            var zipGatewayFields;
            var gatewayChoice = (Math.floor((Math.random() * 2) + 1) - 1);

            switch(gatewayChoice) {
                case 0:
                    zipGateway = 'https://viacep.com.br/ws/' + postcode + '/json/';
                    zipGatewayFields = {
                        street: 'logradouro',
                        neighborhood: 'bairro',
                        city: 'localidade',
                        state: 'uf'
                    };
                    break;
                case 1:
                    zipGateway = 'https://api.postmon.com.br/v1/cep/' + postcode;
                    zipGatewayFields = {
                        street: 'logradouro',
                        neighborhood: 'bairro',
                        city: 'cidade',
                        state: 'estado'
                    };
                    break;
            }

            /**
             * Com o CEP captura os dados de endereço pelo postmon
             */
            $.ajax({
                url: zipGateway,
                method: 'GET',
                dataType: 'json',
                timeout: 1500
            })
            .done(function (address) {
                var data = {};

                for (var key in zipGatewayFields) {
                    data[key] = address[zipGatewayFields[key]];
                }

                gcPaymentData.postCodeComplete(data);
            })
            .fail(function (data, status) {
                if (status === 'timeout') {
                    gcPaymentData.postCodeSearch(postcode);
                }
                gcPayments.logError('Impossível recuperar dados do CEP fornecido');
            });
        },

        /**
         * Trata dados do endereço quando à resposta da api
         *
         * @param  {json} data Informações de localização
         */
        postCodeComplete: function (data) {
            if (data.street) {
                $('#gcPaymentsAddress [name=street]').val(data.street);
                // Após sucesso vamos dar focus no número da rua
                $('#gcPaymentsAddress [name=street_number]').focus();
            }
            if (data.neighborhood) {
                $('#gcPaymentsAddress [name=neighborhood]').val(data.neighborhood);
            }
            if (data.city) {
                $('#gcPaymentsAddress [name=city]').val(data.city);
            }
            if (data.state) {
                $('#gcPaymentsAddress [name=state]').val(data.state);
            }

            $('#gcPaymentsAddress [name=zipcode]').removeClass('zipcode-searching');

            // Habilita campos e da trigger de mudança para salvar na memória
            $('#gcPaymentsAddress [name=street]').attr('disabled', false).change();
            $('#gcPaymentsAddress [name=neighborhood]').attr('disabled', false).change();
            $('#gcPaymentsAddress [name=city]').attr('disabled', false).change();
            $('#gcPaymentsAddress [name=state]').attr('disabled', false).change();
        },
    };

    /***
     *     __                  ___      ___     __   ___       __   ___  __   __
     *    |__)  /\  \ /  |\/| |__  |\ |  |     |__) |__  |\ | |  \ |__  |__) /__`
     *    |    /~~\  |   |  | |___ | \|  |     |  \ |___ | \| |__/ |___ |  \ .__/
     *
     */

    /**
     * Renderiza steps, mustache templates, alguns com chamada para load dos dados
     *
     * @type {Object}
     */
    var gcPaymentRenders = {
        stepTaggerPurchaseItem: function (purchase) {
            var purchase = purchase ? 'purchase_' : '';
            return purchase + 'discover_' + gcPaymentData.tagsDiscoverGoogleEvents[gcPaymentData.paymentMethod][gcPaymentData.paymentClientMeta.paymentItem.id];
        },

        /**
         * Google Tag's tracking tags
         * @param {string} step
         * @param {value} value
         */
        stepTagger: function (step, value) {
            var paymentMethod = gcPaymentData.paymentType === 'credit_card' ? 'card_' : 'billet_';

            if (typeof dataLayer === 'undefined') {
            return false;
            }

            switch(step) {
                case 'purchase_initiate':
                    dataLayer.push({ 'event' : gcPaymentRenders.stepTaggerPurchaseItem() });
                    break;
                case 'payment_method':
                    dataLayer.push({ 'event' : paymentMethod + 'init' });
                    break;
                case 'personal_data':
                case 'card_data':
                    dataLayer.push({ 'event' : paymentMethod + 'info' });
                    break;
                case 'address':
                    dataLayer.push({ 'event' : paymentMethod + 'address' });
                    break;
                case 'finish':
                    dataLayer.push({ 'event' : paymentMethod + 'finish' });
                    dataLayer.push({ 'event' : gcPaymentRenders.stepTaggerPurchaseItem(true) });
                    break;
                default:
                    return false;
            }
        },

        /**
        * Renderiza métodos de pagamento
        */
        renderPaymentMethods: function () {
            var methods_rendered = Mustache.render(window[gcPayments.steps.payment_method], {
                canBillet: (gcPayments.language == "pt-br"),
            });
            $('#gcPaymentsPaymentMethod').html(methods_rendered);
            return true;
        },

        /**
        * Renderiza tela de dados pessoal para o boleto
        *
        * @return {bool} Retorna verdadeiro quando a etapa está pronta
        */
        renderPersonalData: function () {
            var data = {};

            var rendered = Mustache.render(window[gcPayments.steps.personal_data], data);
            $('#gcPaymentsPersonalData').html(rendered);

            gcPayments.maskInputs();

            return true;
        },

        /**
        * Renderiza a tela de endereço para boleto e cartão
        *
        * @return {bool} Retorna verdadeiro quando a etapa está pronta
        */
        renderAddress: function () {
            var data = {};

            if (gcPaymentData.paymentType) {
                data.isBillet = (gcPaymentData.paymentType === 'billet');
            }

            var rendered = Mustache.render(window[gcPayments.steps.address], data);
            $('#gcPaymentsAddress').html(rendered);

            gcPayments.maskInputs();

            return true;
        },

        /**
        * Renderiza a tela de dados do cartão de crédito
        *
        * @return {bool} Retorna verdadeiro quando a etapa está pronta
        */
        renderCardData: function () {
            var data = {};
            var render = Mustache.render(window[gcPayments.steps.card_data], data);
            $('#gcPaymentsCardData').html(render);

            gcPayments.maskInputs();

            return true;
        },

        /**
        * Renderiza a tela de resumo do cartão de crédito
        *
        * @return {bool} Retorna verdadeiro quando a etapa está pronta
        */
        renderConfirm: function () {
            var data = {
                buffer: Object.assign({}, gcPaymentData.buffer), // this is a copy of buffer, just to be used by the view
                friends: gcPaymentData.friends,
                paymentItem: gcPaymentData.paymentClientMeta.paymentItem,
            };
            var final_price;
            var render;

            data.buffer.payment = {};

            friends_count = gcPaymentData.friends.length;

            // if there is no friends define `friends_count` as 1 (user itself)
            // This is used to calculate the amount to pay just by the view
            if (friends_count == 0) {
                friends_count = 1;
            }

            final_price = (friends_count * data.paymentItem.amount).toFixed(2);

            data.buffer.card_data.card_snippet = gcPaymentData.buffer.card_data.card_number.substr(0,4);

            data.buffer.payment.id = data.paymentItem.id;
            data.buffer.payment.name = data.paymentItem.name;
            data.buffer.payment.price = final_price;
            data.buffer.payment.currency_symbol = gcPaymentData.paymentClientMeta.paymentItem.currency_symbol;

            render = Mustache.render(window[gcPayments.steps.confirm], data);
            $('#gcPaymentsConfirm').html(render);
            $("#gcPaymentsConfirm friends-list").scrollbar();
            return true;
        },

        /**
        * Renderiza a tela de sucesso com o boleto
        *
        * @return {bool} Retorna verdadeiro quando a etapa está pronta
        */
        renderBillet: function () {
            gcPayments.processing();

            // PAGAMENTO PARA AMIGOS
            if (gcPaymentData.friends.length > 0) {
                gcPayments.generateBilletForFriends();
                return true;
            }

            $.ajax({
                url: '/payments/pay/billet',
                method: 'post',
                data: {
                    metadata: gcPaymentData.paymentClientMeta
                },
                success: function (data) {
                    var render = Mustache.render(window[gcPayments.steps.billet], data);

                    gcPayments.updateOnClose = true;
                    $('#gcPaymentsBillet').html(render);
                    gcPayments.processing(false);
                    gcPaymentRenders.stepTagger('finish');
                },
                error: function (e) {
                    var data = e.responseJSON;
                    gcPayments.showFatalError('Não foi possível gerar o boleto', data.message);
                    return false;
                }
            });

            return true;
        },

        /**
        * Renderiza a tela de erro irrecuperável, sem breadcrumb
        *
        * @return {bool} Retorna verdadeiro quando a etapa está pronta
        */
        renderFatalError: function (data) {
            var render = Mustache.render(window[gcPayments.steps.fatal_error], data);
            $('#gcPaymentsFatalError').html(render);
            return true;
        },

        /**
        * Renderiza a tela de erro rrecuperável, sem breadcrumb
        *
        * @return {bool} Retorna verdadeiro quando a etapa está pronta
        */
        renderRecoverableError: function (data) {
            var render = Mustache.render(window[gcPayments.steps.recoverable_error], data);
            $('#gcPaymentsRecoverableError').html(render);
            return true;
        },

        /**
        * Renderiza a tela de sucesso do cartão de crédito
        *
        * @return {bool} Retorna verdadeiro quando a etapa está pronta
        */
        renderSuccessCard: function () {
            var data = {};

            data.friends = gcPaymentData.friends;
            gcPayments.updateOnClose = true;

            var render = Mustache.render(window[gcPayments.steps.success], data);
            $('#gcPaymentsSuccess').html(render);
            return true;
        },

        /**
        * Renderiza Select de Amigos
        */
        renderFriends: function () {
            var data = {};
            data.total_currency_symbol = gcPaymentData.paymentClientMeta.paymentItem.currency_symbol;
            var rendered = Mustache.render(window[gcPayments.steps.friends_list], data);
            $('#gcPaymentsFriends').html(rendered);

            window.requestAnimationFrame(function () {
                chosenScript(amigosArray);
            });

            return true;
        },

        /**
        * Renderiza tela de dados pessoal para o boleto
        *
        * @return {bool} Retorna verdadeiro quando a etapa está pronta
        */
        renderBreadcrumb: function (data, currentStep) {
            // Dados das etapas
            var stepList = {
                friends_list: {
                    index: 0,
                    step: 'friends_list',
                    name: i18n.sub_step_one_b,
                    isEnabled: false,
                    isActive: false,
                },
                payment_method: {
                    index: 1,
                    step: 'payment_method',
                    name: i18n.sub_step_two,
                    isEnabled: false,
                    isActive: false,
                },
                card_data: {
                    index: 2,
                    step: 'card_data',
                    name: i18n.sub_step_three,
                    isEnabled: false,
                    isActive: false,
                },
                personal_data: {
                    index: 2,
                    step: 'personal_data',
                    name: i18n.sub_step_three_b,
                    isEnabled: false,
                    isActive: false,
                },
                address: {
                    index: 3,
                    step: 'address',
                    name: i18n.sub_step_four,
                    isEnabled: false,
                    isActive: false,
                },
                confirm: {
                    index: 4,
                    step: 'confirm',
                    name: i18n.sub_step_five,
                    isEnabled: false,
                    isActive: false,
                }
            };

            // Remove friends breadcrumb if modal is not for friends
            if (!gcPaymentData.forFriends) {
                delete stepList.friends_list;
            }

            // Caso estejamos utilizando boleto a terceira etapa são os dados pessoais
            // e removemos a confirmação
            if (data.isBillet)  {
                delete stepList.card_data;
                delete stepList.confirm;
            } else {
                delete stepList.personal_data;
            }

            // Define o passo ativo
            var active_step = 0;
            if (stepList[currentStep]) {
                stepList[currentStep].isActive =  true;
                active_step = stepList[currentStep].index;
            }

            // Define os passos habilitados
            data.steps = [];
            $.each(stepList, function(index, step_data) {
                if (step_data.index < active_step) {
                    stepList[index].isEnabled = true;
                }

                data.steps.push(stepList[index]);
            });

            var rendered = Mustache.render(gcPaymentsBreadcrumbTemplate, data);
            $('#gcPaymentsModalBreadcrumb').html(rendered);

            return true;
        },

        /**
        * Atualiza os breadcrumbs
        *
        * @return {bool}
        */
        updateBreadcrumb: function(goto) {
            var data = {
                isBillet: (gcPaymentData.paymentType === 'billet')
            };

            return gcPaymentRenders.renderBreadcrumb(data, goto);
        },
    };


    /***
     *   __                  ___      ___  __
     *  |__)  /\  \ /  |\/| |__  |\ |  |  /__`
     *  |    /~~\  |   |  | |___ | \|  |  .__/
     *
     */

    /**
     * Objeto principal da modal
     *
     * @type {Object}
     */
    var gcPayments = {
        language: 'pt-br',
        container: null,
        currentStep: null,
        validZipCode: null,
        updateOnClose: false,
        steps: {
            friends_list: 'gcPaymentsFriendsListTemplate',
            payment_method: 'gcPaymentsPaymentMethodTemplate',
            personal_data: 'gcPaymentsPersonalDataTemplate',
            address: 'gcPaymentsAddressTemplate',
            card_data: 'gcPaymentsCardDataTemplate',
            confirm: 'gcPaymentsConfirmTemplate',
            billet: 'gcPaymentsBilletTemplate',
            fatal_error: 'gcPaymentsFatalErrorTemplate',
            recoverable_error: 'gcPaymentsRecoverableErrorTemplate',
            success: 'gcPaymentsSuccessTemplate',
        },
        templates: [
            'gcPaymentsBreadcrumbTemplate',

            'gcPaymentsFriendsListTemplate',
            'gcPaymentsPaymentMethodTemplate',
            'gcPaymentsCardDataTemplate',
            'gcPaymentsPersonalDataTemplate',
            'gcPaymentsAddressTemplate',

            'gcPaymentsBilletTemplate',
            'gcPaymentsFatalErrorTemplate',
            'gcPaymentsRecoverableErrorTemplate',
            'gcPaymentsSuccessTemplate',
            'gcPaymentsConfirmTemplate',
        ],

        /**
        * Binds, cache, pré-parse de mustache e inicialização da modal de pagamento
        */
        init: function (paymentClientMeta, paymentMethod, language) {
            var that = this;
            this.language = language;

            gcPaymentData.paymentMethod = paymentMethod;
            if (paymentMethod === "friends") {
                gcPaymentData.forFriends = true;
            }

            /**
             * Bind do clique do botão de mudar de etapa
             */
            $(document).off('click', '#gcPaymentsModal [data-jsaction=gotoStep]')
                        .on('click', '#gcPaymentsModal [data-jsaction=gotoStep]', function (e) {
                that.gotoStep($(this).data('target-step'), $(this).data('value'));
            });

            /**
             * Bind do clique do botão de pagar no cartão
             */
            $(document).off('click', '#gcPaymentsConfirm .pay-subscription')
                        .on('click', '#gcPaymentsConfirm .pay-subscription', function (e) {
                that.pay();
            });

            /**
             * Espaço para mudar de etapa
             */
            $(document).off('keypress', '#gcPaymentsModal [data-jsaction=gotoStep]')
                        .on( 'keypress', '#gcPaymentsModal [data-jsaction=gotoStep]', function (e) {
                if (e.charCode === 0 || e.keyCode === 32) {
                    that.gotoStep($(this).data('target-step'), $(this).data('value'));
                }
            });

            /**
             * Botão de voltar etapas (breadcrumbs passo-a-passo)
             */
            $(document).off('click', '#gcPaymentsModal [data-jsaction=backStep]')
                        .on('click', '#gcPaymentsModal [data-jsaction=backStep]', function (e) {
                that.showStep($(this).data('target-step'));
            });

            /**
             * Botão de fechar modal
             */
            $(document).off('click', '#gcPaymentsModal [data-jsaction=gcPaymentsModalClose]')
                        .on('click', '#gcPaymentsModal [data-jsaction=gcPaymentsModalClose]', function () {
                that.close();

                // Atualiza página
                if (gcPayments.updateOnClose === true) {
                    window.location.reload();
                }
            });

            /**
             * Input de cep para preencher endereço
             */
            $(document).off('change', '#gcPaymentsAddress .zipcode')
                        .on('change', '#gcPaymentsAddress .zipcode', function () {
                var postcode = $(this).val().replace(/\D/g, '');

                if (postcode.length == 8) {
                    gcPaymentData.postCodeSearch(postcode);
                }
            });

            /**
             * Bind do focus no cvv para mostrar o fundo do cartão
             */
            $(document).off('focusin', '#gcPaymentsCardData .card-cvv')
                        .on('focusin', '#gcPaymentsCardData .card-cvv', function () {
                $('#gcPaymentsCardData .gc-payments-modal-card-back').addClass('gc-payments-modal-card-back-active');
            });

            /**
             * Bind da perda de focus no cvv para esconder o fundo do cartão caso ainda
             * não haja dados no campo
             */
            $(document).off('focusout', '#gcPaymentsCardData .card-cvv')
                        .on('focusout', '#gcPaymentsCardData .card-cvv', function () {
                if ($(this).val().length > 0) {
                    return true;
                }
                $('#gcPaymentsCardData .gc-payments-modal-card-back').removeClass('gc-payments-modal-card-back-active');
            });

            /**
             * Bind de mudanças em tempo real nos inputs exibidos no cartão para enviar
             * mudanças para a ilustração do cartão
             */
            $(document).off('keyup', '#gcPaymentsCardData [data-jsaction=bindCardInput]')
                        .on('keyup', '#gcPaymentsCardData [data-jsaction=bindCardInput]', function () {

                var field_value = $(this).val(),
                    card_image_input = $('#gcPaymentsCardData [data-card-image=' + $(this).attr('name') + ']');

                if (field_value.length > 0) {
                    card_image_input.text(field_value);
                } else {
                    card_image_input.text(card_image_input.data('card-placeholder'));
                }
            });

            $(document).off('change', '#gcPaymentsModal input')
                        .on('change', '#gcPaymentsModal input', function () {
                gcPaymentData.saveLocalItem(
                    that.currentStep,
                    $(this).attr('name'),
                    $(this).val()
                );
            });

            /**
             * Bind de focus out dos inputs para exibir a mensagem apenas depois de o
             * usuário ter preenchido algo
             */
            $(document).off('focusout', '#gcPaymentsModal input')
                        .on('focusout', '#gcPaymentsModal input', function () {
                if ($(this).val().length > 0) {
                    $(this).addClass('has-changed');
                }
            });

            /**
             * Previne comportamento padrão do submit dos formulários
             */
            $(document).off('submit', '#gcPaymentsModal form')
                        .on('submit', '#gcPaymentsModal form', function (e) {
                e.preventDefault();
                return false;
            });

            this.container = $('#gcPaymentsModal');

            this.processing();

            mustache_helper.parseMultiple(this.templates);

            gcPaymentRenders.renderPaymentMethods();
            // Here is where you define the item to be paid
            gcPaymentData.loadPaymentClientMeta(paymentClientMeta);
            // Renderiza templates estáticos
            gcPaymentRenders.renderFriends();
        },

        /**
        * Abre modal de pagamento
        */
        open: function () {
            this.container.addClass('gc-payments-modal-active');

            if (gcPaymentData.forFriends) {
                this.showStep('friends_list');
            } else {
                this.showStep('payment_method');
            }

            if (gcPaymentData.hasPendingPayment && !gcPaymentData.forFriends) {
                this.showFatalError(
                    'Item com pagamento pendente',
                    'Identificamos que você já solicitou este item, porém está com pagamento pendente, verifique em seu perfil (Gerenciar Conta -> Compras) ou e-mail as instruções para pagamento. Em caso de dúvidas, favor entrar em contato com nosso suporte pelo site.'
                );
                return false;
            }

            $('body').css('overflow', 'hidden');
        },

        /**
        * Fecha modal de pagamento
        */
        close: function () {
            this.container.removeClass('gc-payments-modal-active');
            $('body').css('overflow', 'auto');
            this.resetModalState();
        },

        resetModalState: function () {
            gcPaymentData.container = null;
            gcPaymentData.currentStep = null;
            gcPaymentData.paymentMethod = null;
            gcPaymentData.paymentType = null;
            gcPaymentData.paymentItem = {};
            gcPaymentData.hasPendingPayment = false;
            gcPaymentData.forFriends = false;
            gcPaymentData.friends = [];
            gcPaymentData.buffer = {};
            gcPaymentData.update_on_close = true;

            // Clear selection for friends list
            window.amigosArray.forEach(function (e) {
                e.selected = false;
            })
        },

        /***
         *                         __                       __       ___    __                 ___ ___       __   __   __
         *    |  | |     /\  |\ | |  \    \  /  /\  |    | |  \  /\   |  | /  \ |\ |     |\/| |__   |  |__| /  \ |  \ /__`
         *    \__/ |    /~~\ | \| |__/     \/  /~~\ |___ | |__/ /~~\  |  | \__/ | \|     |  | |___  |  |  | \__/ |__/ .__/
         *
         */

        /**
        * Exibe ou esconde tela de processamento
        *
        * @param {string} finished Se verdadeiro esconde tela
        */
        processing: function (finished) {
            if (finished === false) {
                this.container.removeClass('gc-payments-modal-process');
                return true;
            }
            this.container.addClass('gc-payments-modal-process');
            return false;
        },

        /**
        * Exibe ou esconde tela de carregamento
        *
        * @param {string} loaded Se for falso remove a tela de carregamento
        */
        loader: function (loaded) {
            if (loaded === false) {
                this.container.removeClass('gc-payments-modal-loading');
                return true;
            }
            this.container.addClass('gc-payments-modal-loading');
            return false;
        },

        /**
         * Inicia e finaliza processamento de cartão
         *
         * @param  {bool} processed Se verdadeiro o processamento já finalizou
         * @return {[type]}            [description]
         */
        isCardPaymentProcessing: function (processing) {
            if (processing) {
                this.processing();
                return true;
            }
            this.processing(false);
            return false;
        },

        /**
         * Insere as máscaras em todos os inputs elegíveis
         */
        maskInputs: function () {
            $('[name=ddd]').mask('000');
            $('[name=number]').mask('000000000');
            $('[name=card_cvv]').mask('0000');
            $('[name=card_expiration_date]').mask('00/00');
            $('[name=card_number]').mask('0000 0000 0000 0000');

            var cpfOptions = {
                onKeyPress: function (cpf, ev, el, op) {
                    var masks = ['000.000.000-000', '00.000.000/0000-00'],
                        mask = (cpf.length > 14) ? masks[1] : masks[0];
                    $('[name=document_number]').mask(mask, cpfOptions);
                }
            };
            // CPF Brasil
            $('[name=document_number]').mask('000.000.000-000', cpfOptions);
            $('[name=zipcode]').mask('00000-000');
        },

        /***
         *     __  ___  ___  __            ___ ___       __   __   __
         *    /__`  |  |__  |__)     |\/| |__   |  |__| /  \ |  \ /__`
         *    .__/  |  |___ |        |  | |___  |  |  | \__/ |__/ .__/
         *
         */

        /**
        * Envia usuário para a tela desejada
        *
        * @param {string} goto Passo da modal pagamento
        * @param {mixed} value Valor da etapa atuall
        * @see {object} gcPayments.steps
        */
        gotoStep: function (goto, value) {
            if (!goto && typeof(goto) !== 'undefined') {
                this.logError('Etapa não encontrada ' + goto);
                return false;
            }

            var step_validation = gcPaymentData.setStepData(this.currentStep, value);

            gcPaymentRenders.stepTagger(this.currentStep);

            // Clear errors
            $('#gcPaymentsModal .gc-payments-modal-error-active').removeClass('gc-payments-modal-error-active');

            // Caso o step_validation seja cartão
            if (this.currentStep === "card_data") {
                if (Object.keys(step_validation.card).length  !== 0) {
                    gcPaymentData.pagarMeFetchCreditCard(step_validation, goto);
                    return;
                }
            }

            // Caso seja pagar para amigos
            if(this.currentStep == 'friends_list') {
                gcPaymentData.friends = [];
                $('.select2-selection__choice').each(function(i, el) {
                    friendData = $(el).find('.userName');
                    gcPaymentData.friends.push({
                        nick: $(friendData).data('user-nick'),
                        avatar: $(friendData).data('user-avatar'),
                        id: $(friendData).data('user-id')
                    });
                });
            }

            var errors = convertJSON(step_validation.errors);

            // Show errors if any
            if (errors && errors.length > 0) {
                gcPayments.showFormErrors(errors);
                return false;
            }

            if (errors.name === 'form') {
                //Caso o step com erros seja o de selecionar amigos
                if (gcPayments.currentStep == 'friends_list') {
                    $('#gcPaymentsFriends .select2').after('<div class="gc-payments-modal-error-message gc-payments-modal-error-active">Nenhum amigo selecionado</div>');
                }
                return false;
            }

            // Caso o step_validation seja uma chamada remota retornando um promisse
            if (typeof step_validation === 'object' && step_validation.done) {
                step_validation.done(function (data) {
                    var errors = convertJSON(data.errors);

                    // Caso haja erros na validação backend
                    if (errors && errors.length > 0) {
                        gcPayments.showFormErrors(errors);
                        return false;
                    }

                    // Esconde mensagem de erro do passo
                    gcPayments.hideStepError();
                    gcPayments.loader(false);

                    if (!gcPayments.renderNextStep(goto)) {
                        gcPayments.logError('Erro ao renderizar  ' + goto + ' partindo de ' + gcPayments.currentStep);
                    }

                    if (goto === 'billet') {
                        gcPayments.showStep(goto, true);
                    } else {
                        gcPayments.showStep(goto);
                    }
                }).fail(function (e) {
                    var data = e.responseJSON;

                    if (data.success === false) {
                        gcPayments.showStepError(data.message);
                        return false;
                    }
                });

                step_validation.error(function () {
                    gcPayments.logError('Erro no servidor ao salvar dados ' + goto);
                });

            // Caso o step_validation seja uma chamda local retornando true
            } else if (step_validation === true) {
                if (!gcPayments.renderNextStep(goto)) {
                    gcPayments.logError('Erro ao renderizar  ' + goto + ' partindo de ' + gcPayments.currentStep);
                }
                gcPayments.showStep(goto);
            } else {
                gcPayments.logError('Erro ao trocar etapa ' + goto);
            }
        },

        /**
         * Exibe etapa no front
         *
         * @param  {string} goto Etapa de destino
         */
        showStep: function (goto, without_data) {
            this.currentStep = goto;

            if (without_data !== true) {
                gcPaymentData.loadStepData(goto);
            }

            this.container.attr('data-current-step', goto);
            gcPaymentRenders.updateBreadcrumb(goto);

            $('#gcPaymentsModal .gc-payments-modal-step-active').removeClass('gc-payments-modal-step-active');
            $('#gcPaymentsModal [gc-payments-step=' + goto + ']').addClass('gc-payments-modal-step-active');

            this.container.scrollTop(0);
        },

        /**
         * Renderiza a próxima tela com os dados apropriados
         *
         * @param {string} goto Tela que desejamos mudar
         * @return {bool}
         */
        renderNextStep: function (goto) {
            var next_step_ready;

            switch (goto) {
                case 'personal_data':
                    next_step_ready = gcPaymentRenders.renderPersonalData();
                    break;
                case 'address':
                    next_step_ready = gcPaymentRenders.renderAddress();
                    break;
                case 'card_data':
                    next_step_ready = gcPaymentRenders.renderCardData();
                    break;
                case 'confirm':
                    next_step_ready = gcPaymentRenders.renderConfirm();
                    break;
                case 'billet':
                    next_step_ready = gcPaymentRenders.renderBillet();
                    break;
                case 'success':
                    next_step_ready = gcPaymentRenders.renderSuccessCard();
                    break;
                case 'fatal_error':
                    next_step_ready = gcPaymentRenders.renderFatalError();
                    break;
                case 'recoverable_error':
                    next_step_ready = gcPaymentRenders.renderRecoverableError();
                    break;
                case 'friends_list':
                case 'payment_method':
                    next_step_ready = true;
                    break;
                default:
                    this.logError('Etapa inexistente ' + goto);
                    break;
            }

            if (!next_step_ready) {
                this.logError('Não foi possível ir para etapa ' + goto);
                return false;
            }

            this.hideStepError();

            return true;
        },

        /**
         * Caso o usuário tenha um pagamento pendente ele não pode comprar o mesmo item
         * @param {Object} data Dados do usuário
         */
        goToPendingPaymentBillet: function (data) {
            if (data.billet) {
                var mustache_data = {
                    billet: {
                        billetUrl: data.billet.billetUrl,
                        billetCode: data.billet.billetCode,
                        billetBarcode: data.billet.billetBarcode,
                        billetAmount: data.billet.billetAmountFormatted,
                    },
                };
                var render = Mustache.render(window[this.steps.billet], mustache_data);
                $('#gcPaymentsBillet').html(render);
                this.showStep('billet');
                this.processing(false);
                return true;
            }

            gcPaymentData.hasPendingPayment = true;

            this.showFatalError(
                'Item com pagamento pendente',
                'Identificamos que você já solicitou este item, porém está com pagamento pendente, verifique em seu perfil (Gerenciar Conta -> Compras) ou e-mail as instruções para pagamento. Em caso de dúvidas, favor entrar em contato com nosso suporte pelo site.'
            );
        },

        /***
         *     ___  __   __   __   __            ___ ___       __   __   __
         *    |__  |__) |__) /  \ |__)     |\/| |__   |  |__| /  \ |  \ /__`
         *    |___ |  \ |  \ \__/ |  \     |  | |___  |  |  | \__/ |__/ .__/
         *
         */

        /**
         * Exibe erro de etapa quando é retornado success = false no json
         *
         * @param {string} message Mensagem de erro
         */
        showStepError: function (message) {
            var message_el = document.getElementById('stepErrorMessage');
            if (typeof(message_el) === 'undefined' || !message_el.classList) {
                return false;
            }
            message_el.innerHTML = message;
            message_el.classList.remove('hidden');
            this.loader(false);
        },

        /**
         * Overlay de erro irrecuperável da modal
         *
         * @param  {string} title Título do erro
         * @param  {string} message Mensagem do erro
         * @return {[type]}
         */
        showFatalError: function (title, message) {
            var data = {
                title: title,
                message: message,
            };
            gcPaymentRenders.renderFatalError(data);
            this.showStep('fatal_error');
            this.processing(false);
            return true;
        },

        /**
         * Overlay de erro rrecuperável da modal
         *
         * @param  {string} title Título do erro
         * @param  {string} message Mensagem do erro
         * @return {[type]}
         */
        showRecoverableError: function (title, message, step) {
            var data = {
                title: title,
                message: message
            };

            if (step) {
                data.step = step;
            }
            gcPaymentRenders.renderRecoverableError(data);
            this.showStep('recoverable_error');
            this.processing(false);
        },

        /**
         * Esconde mensagem de erro do passo
         */
        hideStepError: function () {
            document.getElementById('stepErrorMessage').classList.add('hidden');
        },

        /**
         * Exibe erros nos formulários
         *
         * @param  {Object} errors Sendo no formato {name_do_input: Mensagem de erro}
         */
        showFormErrors: function (errors) {
            $.each(errors, function (key, error) {
                var field = $('#gcPaymentsModal [name="' + error.name + '"]');
                if (field.length > 0) {
                    field
                        .siblings('.gc-payments-modal-error-message')
                        .text(error.message)
                        .addClass('subscription-error-active');
                }
            });
            this.loader(false);
        },

        /**
        * Exibe os erros no console do navegador
        *
        * @param {string} msg Mensagem de erro
        */
        logError: function (msg, data) {
            console.error('[MODAL] ' + msg);
            if (data) {
                console.error(data);
            }
        },

        /***
         *     __                  ___      ___           ___ ___       __   __   __
         *    |__)  /\  \ /  |\/| |__  |\ |  |      |\/| |__   |  |__| /  \ |  \ /__`
         *    |    /~~\  |   |  | |___ | \|  |      |  | |___  |  |  | \__/ |__/ .__/
         *
         */

        generateBilletForFriends: function() {
            var that = this;
            var friends = gcPaymentData.friends;

            $.ajax({
                url: '/payments/pay/billet',
                method: 'post',
                data: {
                    metadata: gcPaymentData.paymentClientMeta,
                    friends: friends
                },
                success: function (data) {
                    var render = Mustache.render(window[that.steps.billet], data);
                    that.update_on_close = true;
                    $('#gcPaymentsBillet').html(render);
                    that.processing(false);
                    gcPaymentRenders.stepTagger('finish');
                },
                error: function (e) {
                    var data = e.responseJSON;
                    that.showFatalError('Não foi possível gerar o boleto', data.message);
                    return false;
                }
            });
        },

        pay: function () {
            var that = this;
            var friends = gcPaymentData.friends;
            var dataForPayment = gcPaymentData.buffer;
            this.isCardPaymentProcessing(true);

            $.ajax({
                url: '/payments/pay/card',
                method: 'post',
                dataType: 'json',
                data: {
                    metadata: gcPaymentData.paymentClientMeta,
                    payment: dataForPayment,
                    friends: friends,
                },
                success: function (data) {
                    gcPaymentRenders.renderSuccessCard();
                    that.showStep('success', true);
                    gcPaymentRenders.stepTagger('finish');
                    that.isCardPaymentProcessing(false);
                },
                error: function (e) {
                    var data = e.responseJSON;
                    // TODO: Verificar casos de erro e ações cabíveis
                    that.isCardPaymentProcessing(false);

                    if (data.step) {
                        that.showRecoverableError('Não foi possível processar o pagamento', data.message, data.step);
                        return false;
                    }

                    that.showFatalError('Não foi possível processar o pagamento', data.message);
                    return false;
                }
            });
        },
    };

    // -----------------------------
    // Abaixo contém apenas triggers e funcões auxiliares para o modal
    // -----------------------------

    /**
     * Chosen for friends list
     */
    var chosenScript = function (dataArray) {
        var selectInputEl = $('#gcPaymentsFriends .select-friends')
        var addUserPic = function (data) {
            if (!data.id) {
                return data.text;
            }

            if(!data.avatar){
                return data.text;
            } else {
                var $data = $(
                '<span class="userName" data-user-avatar="'+ data.avatar + '" data-user-nick="' + data.text + '" data-user-id="' + data.id + '" ><img src="' + data.avatar + '" class="userPic" /> ' + data.text + '</span>'
                );
                return $data;
            }
        };

        selectInputEl.select2({
            tags: true,
            placeholder: i18n.sub_friends_click_to_see_your_friends,
            width: '100%',
            data: dataArray,
            templateResult: this.addUserPic,
            templateSelection: this.addUserPic,
            createTag: function (tag) {

                var term = $.trim(tag.term);
                var isnum = /^\d+$/.test(term);

                if (term === '' || isnum === false) {
                    return null;
                }

                return {
                    id: tag.term,
                    text: tag.term,
                    isNew : true
                };
            },
            insertTag: function (data, tag) {
                data.push(tag);
            },
        })
        .on('select2:select', function(e) {

            // Remove errors
            $('#gcPaymentsFriends .subscription-error-message').removeClass('subscription-error-active');

            var id = e.params.data.id;
            $('#gcPaymentsFriends .select2-selection__choice[title=' + id + ']').addClass('user-searching');

            if (e.params.data.isNew) {
                $.ajax({
                    type: 'post',
                    url: '/players/find/' + id,
                    success: function(msg) {
                        var total = amigosArray.filter(
                            function(item){
                                return (item.id == msg.player.id);
                            }
                        ).length;

                        if (total == 1) {
                            var elementPos = amigosArray.map(function(x) { return x.id; }).indexOf(parseInt(msg.player.id));
                            var objectFound = amigosArray[elementPos];
                            amigosArray[elementPos].selected = true;
                        } else {
                            amigosArray.push({ id: parseInt(msg.player.id), text: msg.player.nick, avatar: msg.player.avatar, selected: true });
                        }

                        selectInputEl.select2('destroy');
                        selectInputEl.off();
                        selectInputEl.find('option').remove();
                        chosenScript(amigosArray);
                    },
                    error: function(erro) {
                        alert('Usuário inválido');
                        selectInputEl.select2('destroy');
                        selectInputEl.off();
                        selectInputEl.find('option').remove();
                        chosenScript(amigosArray);
                    }
                });
            } else {
                for (var o in amigosArray) {
                    if (amigosArray[o].id == id) {
                        amigosArray[o].selected = true;
                    }
                }
            }
        })
        .on('select2:unselect', function(e){
            var idSelected = e.params.data.id;
                for (var o in amigosArray) {
                    if (amigosArray[o].id == idSelected) {
                        amigosArray[o].selected = false;
                    }
                }
        });

        selectInputEl.on('change', function(e) {
            var playersChosen = Array.from( new Set( $(this).val() ) );
            var totalPlayers;

                if (playersChosen !== null) {
                    totalPlayers = playersChosen.length;
                } else {
                    totalPlayers = 0;
                }

            total_currency_symbol = gcPaymentData.paymentClientMeta.paymentItem.currency_symbol;
            total = ((gcPaymentData.paymentClientMeta.paymentItem.amount * totalPlayers) * 1).toFixed(2);

            $('#gcPaymentsFriends .total .total-currency-symbol').html(total_currency_symbol);
            $('#gcPaymentsFriends .total .total-value').html(total);
        });
    };

    /**
     * Check if JSON is valid, if not empty try to convert to JSON format
     *
     * @param  {mixed} data string or json
     * @return {mixed}      return json or false
     */
    var convertJSON = function (data) {
        if (typeof(data) === 'undefined') {
            return false;
        }

        if (typeof(data) === 'object') {
            return data;
        }

        var json_converted = {};
        try {
            json_converted = JSON.parse(data);
            return json_converted;
        } catch (e) {
            gcPayments.logError('Impossível fazer parse json ' . data);
            return false;
        }
    };

    /**
     * Carrega html da modal via ajax e inicializa funções
     *
     * @param  {string} plan   Id do plano escolhido
     * @param  {string} method Método escolhido (upgrade, downgrade, subscription)
     * @param  {object} el Elemento originário da chamada
     */
    var loadModal = function (paymentClientMeta, paymentMethod, language, el) {
        var that = this;

        // If modal is already load bypass ajax loading
        if (gcPayments.container !== null) {
            gcPayments.init(paymentClientMeta, paymentMethod, language);
            gcPayments.open();
            el.attr('disabled', false);
            return true;
        }

        // Load ajax modal
        $.ajax({
            method: 'get',
            data: {},
            url: '/payments/modal',
            success: function (data) {
                $('#gc-payments').html(data);
                gcPayments.init(paymentClientMeta, paymentMethod, language);
                gcPayments.open();
            },
            error: function () {
                gcPayments.showFatalError('Falha ao carregar modal');
            },
            complete: function () {
                el.attr('disabled', false);
            }
        });
    };

    var paymentBtn = function (e) {
        e.preventDefault();

        if ($(this).attr('disabled')) {
            return false;
        }
        $(this).attr('disabled', true);

        var data = $(this).data();
        var el = $(this);

        var clientMeta = {
            paymentItem: data.item,
            paymentEntity: data.entity,
        };
        var paymentMethod = data.method;
        var language = data.language;

        loadModal(
            clientMeta,
            paymentMethod,
            language,
            el
        );
    }

    /**
     * Assign modal to every payment button
     */
    $(document).on('click', '[data-jsaction=paymentBtn]', paymentBtn);
});


//  Pagamentos de cursos
$(function() {
  var paymentCoursesModal = {
    encryptionKey: 'ek_live_srfbBrRo8RPqRVNKDLy6haHdiR8KDh',
    language: 'pt-br',
    container: null,
    elementOrigin: null, // used to know where the modal was initiated
    currentStep: null, // paymentCoursesData.steps
    updateOnClose: false,
    modalType: '', // self, forFriends...
    steps: {
      friendsList: 'paymentCoursesFriendsListTemplate',
      paymentMethod: 'paymentCoursesPaymentMethodTemplate',
      cardData: 'paymentCoursesCardDataTemplate',
      personalData: 'paymentCoursesPersonalDataTemplate',
      address: 'paymentCoursesAddressTemplate',

      reviewCardPayment: 'paymentCoursesReviewCardPaymentTemplate',
      successBillet: 'paymentCoursesSuccessBilletTemplate',
      success: 'paymentCoursesSuccessTemplate',

      fatalError: 'paymentCoursesFatalErrorTemplate',
      recoverableError: 'paymentCoursesRecoverableErrorTemplate',
    },
    templates: [
      'paymentCoursesModalBreadcrumbTemplate',

      'paymentCoursesFriendsListTemplate',
      'paymentCoursesPaymentMethodTemplate',
      'paymentCoursesCardDataTemplate',
      'paymentCoursesPersonalDataTemplate',
      'paymentCoursesAddressTemplate',

      'paymentCoursesReviewCardPaymentTemplate',
      'paymentCoursesSuccessBilletTemplate',
      'paymentCoursesSuccessTemplate',

      'paymentCoursesFatalErrorTemplate',
      'paymentCoursesRecoverableErrorTemplate',
    ],

    init: function() {
      $(document).on('click', '[data-jsaction=paymentCoursesBtn]', function() {
        if ($(this).attr('disabled')) {
          return false;
        }
        $(this).attr('disabled', true);

        var classroom = $(this).data('classroom');
        var modalType = $(this).data('modal-type');
        var language = $(this).data('language');
        var installments = $(this).data('installments');

        paymentCoursesModal.loadModal({
          modalType: modalType,
          classroom: classroom,
          language: language,
          installments: installments,
          elementOrigin: $(this)
        });
      });
      window.document.addEventListener('openPaymentCoursessModal', paymentCoursesModal.openpaymentCoursesModalHandler, false);
    },

    isForFriends: function() {
      return paymentCoursesModal.modalType === 'forFriends';
    },

    isValidInstallment: function(installment) {
      var validInstallments = [1, 2, 3];
      if (validInstallments.includes(parseInt(installment))) {
        return true;
      }
      return false;
    },

    loadModal: function (opt) {
      // enable pay button
      paymentCoursesModal.switchPayButtonEvent(true);

      // Set modal data
      paymentCoursesModal.modalType = opt.modalType;
      paymentCoursesModal.elementOrigin = opt.elementOrigin;
      paymentCoursesModal.language = opt.language;
      paymentCoursesData.paymentMethod = opt.paymentMethod ? opt.paymentMethod : null;
      paymentCoursesData.classroom = opt.classroom ? opt.classroom : null;
      paymentCoursesData.installments = opt.installments;

      $.ajax({
        method: 'get',
        data: {},
        url: '/payments_courses/get-modal',
        success: function (data) {
          $('#gc-payments-course').html(data);

          // Assign and show modal
          paymentCoursesModal.container = $('#paymentCoursesModal');
          paymentCoursesModal.container.addClass('paymentCourses-modal-active');

          // Pre-render static steps
          paymentCoursesRenders.renderFriends();
          paymentCoursesRenders.renderPaymentMethods(paymentCoursesData.installments);
          if (parseInt(paymentCoursesData.installments) > 1) {
            paymentCoursesRenders.renderCardData();
            paymentCoursesData.paymentMethod = 'card';
          }

          paymentCoursesHelpers.mustacheHelper.parseMultiple(paymentCoursesModal.templates);

          paymentCoursesRenders.showProcessing();
          paymentCoursesModal.registerEvents();

          // Load classroom data
          paymentCoursesData.loadClassroomData(paymentCoursesData.classroom)
          .done(function(classroomData) {
            paymentCoursesData.classroomData = classroomData;
            // Load user data
            paymentCoursesData.loadUserData()
            .done(function(data) {
              if (data.success === true) {
                paymentCoursesRenders.showProcessing(false);
                paymentCoursesData.buffer = Object.assign({}, paymentCoursesData.buffer, data);

                // Check for pending payment
                if (data.isWaitingPayment && !paymentCoursesModal.isForFriends()) {
                  paymentCoursesRenders.showPendingPayment();
                  return false;
                }

                if (paymentCoursesData.classroomData.vacanciesAvailable == 0) {
                  paymentCoursesModal.updateOnClose = true;
                  paymentCoursesRenders.showFatalError(
                    'As vagas acabaram',
                    'Infelizmente as vagas já acabaram, tente para a outra turma.'
                  );
                  return false;
                }

                if (data.currentPayment) {
                  if (data.currentPayment.course_classroom_id == paymentCoursesData.classroomData.id) {
                    paymentCoursesModal.updateOnClose = true;
                    paymentCoursesRenders.showFatalError(
                      'Você já está inscrito',
                      'Você já está inscrito nesta turma'
                    );
                    return false;
                  }
                }

                if (paymentCoursesData.hasPendingPayment && !paymentCoursesModal.isForFriends()) {
                  paymentCoursesRenders.showFatalError(
                    'Pagamento pendente',
                    'Identificamos que você possui um pagamento pendente, verifique em seu perfil ou e-mail as instruções para pagamento. Em caso de dúvidas, favor entrar em contato com nosso suporte pelo site.'
                  );
                  return false;
                }

                if (!paymentCoursesModal.isValidInstallment(paymentCoursesData.installments)) {
                  paymentCoursesModal.updateOnClose = true;
                  paymentCoursesRenders.showFatalError(
                    'Número de parcelas inválido'
                  );
                  return false;
                }

                paymentCoursesModal.open();
              }
            }).fail(function(data) {
              paymentCoursesRenders.showFatalError('Falha ao carregar tela de pagamento');
            });
          }).fail(function(data) {
            paymentCoursesRenders.showFatalError('Falha ao carregar dados da turma');
          });
        },
        error: function () {
          paymentCoursesRenders.showFatalError('Falha ao carregar tela de pagamento');
        },
        complete: function () {
          paymentCoursesModal.elementOrigin.attr('disabled', false);
        }
      });
    },

    registerEvents: function () {
      $(document)
      .off('click', '#paymentCoursesModal [data-jsaction=gotoStep]')
      .on('click', '#paymentCoursesModal [data-jsaction=gotoStep]', function (e) {
        paymentCoursesRenders.gotoStep($(this).data('target-step'), $(this).data('target-value'));
      });

      $(document)
      .off('keypress', '#paymentCoursesModal [data-jsaction=gotoStep]')
      .on( 'keypress', '#paymentCoursesModal [data-jsaction=gotoStep]', function (e) {
        if (e.charCode === 0 || e.keyCode === 32) {
          paymentCoursesRenders.gotoStep($(this).data('target-step'));
        }
      });

      $(document)
      .off('click', '#paymentCoursesModal [data-jsaction=backStep]')
      .on('click', '#paymentCoursesModal [data-jsaction=backStep]', function (e) {
        paymentCoursesRenders.showStep($(this).data('target-step'));
      });

      $(document)
      .off('click', '#paymentCoursesModal [data-jsaction=paymentCoursesModalClose]')
      .on('click', '#paymentCoursesModal [data-jsaction=paymentCoursesModalClose]', function () {
        paymentCoursesModal.close();
        if (paymentCoursesModal.updateOnClose === true) {
          window.location.reload();
        }
      });

      $(document)
      .off('keyup', '#paymentCoursesModal #zipcode')
      .on('keyup', '#paymentCoursesModal #zipcode', function () {
        var postcode = $(this).val().replace(/\D/g, '');

        if (postcode.length == 8) {
          paymentCoursesData.postcodeSearch(postcode);
        }
        $('#paymentCoursesAddress [name=zipcode_isvalid]').val('false');
      });

      $(document)
      .off('focusin', '#paymentCoursesModal #paymentCoursesCardCvv')
      .on('focusin', '#paymentCoursesModal #paymentCoursesCardCvv', function () {
        $('#paymentCoursesCardBack').addClass('paymentCourses-card-back-active');
      });


      $(document)
      .off('focusout', '#paymentCoursesModal #paymentCoursesCardCvv')
      .on('focusout', '#paymentCoursesModal #paymentCoursesCardCvv', function () {
        if ($(this).val().length > 0) {
          return true;
        }
        $('#paymentCoursesCardBack').removeClass('paymentCourses-card-back-active');
      });

      $(document)
      .off('keyup', '#paymentCoursesModal [data-jsaction=bindCardInput]')
      .on('keyup', '#paymentCoursesModal [data-jsaction=bindCardInput]', function () {
        var field_value = $(this).val(),
            card_image_input = $('#paymentCoursesCardData [data-card-image=' + $(this).attr('name') + ']');

        if (field_value.length > 0) {
          card_image_input.text(field_value);
        } else {
          card_image_input.text(card_image_input.data('card-placeholder'));
        }
      });

      $(document)
      .off('change', '#paymentCoursesModal input')
      .on('change', '#paymentCoursesModal input', function () {
        paymentCoursesData.saveLocalItem(
          paymentCoursesModal.currentStep,
          $(this).attr('name'),
          $(this).val()
        );
      });

      $(document)
      .off('focusout', '#paymentCoursesModal input')
      .on('focusout', '#paymentCoursesModal input', function () {
        if ($(this).val().length > 0) {
          $(this).addClass('has-changed');
        }
      });

      $(document)
      .off('submit', '#paymentCoursesModal form')
      .on('submit', '#paymentCoursesModal form', function (e) {
        e.preventDefault();
        return false;
      });
    },

    open: function () {
      // Bypass payment method (just for new users, never put it before pendingPayment validation)
      if (paymentCoursesData.paymentMethod !== null) {
        paymentCoursesModal.currentStep = 'paymentMethod';
        if (paymentCoursesData.paymentMethod === 'billet') {
          paymentCoursesRenders.renderPersonalData();
          paymentCoursesRenders.gotoStep('billet', 'billet');
        } else {
          paymentCoursesRenders.renderCardData();
          paymentCoursesRenders.gotoStep('card', 'card');
        }
        return true;
      }

      if (paymentCoursesModal.isForFriends()) {
        paymentCoursesRenders.showStep('friendsList');
      } else {
        paymentCoursesRenders.showStep('paymentMethod');
      }

      $('body').css('overflow', 'hidden');
    },

    openPaymentCoursesModalHandler: function (e) {
      $(this).attr('disabled', true);
      var language = $(this).data('language');

      paymentCoursesModal.loadModal({
        language: language,
        elementOrigin: $(this)
      });
    },

    close: function () {
      $('body').css('overflow', 'auto');
      paymentCoursesModal.container.removeClass('paymentCourses-modal-active');
      paymentCoursesData.friends = [];
    },

    switchPayButtonEvent: function (enable) {
      var enable = enable != 'undefined' ? enable : false;
      if (enable) {
        $(document)
        .off('click', '#paymentCoursesModal #payPaymentCourses')
        .on('click', '#paymentCoursesModal #payPaymentCourses', function (e) {
          paymentCoursesModal.processPaymentCourses();
        });
      } else {
        $(document).off('click', '#paymentCoursesModal #paymentCourses');
      }
    },

    processPaymentCourses: function () {
      paymentCoursesModal.switchPayButtonEvent(false);
      paymentCoursesRenders.showProcessing();

      // Pay for friends
      if (paymentCoursesData.friends.length > 0) {
        this.paymentCoursesForFriends();
        return true;
      }

      // Add installments to buffer
      paymentCoursesData.buffer.installments = paymentCoursesData.installments;

      $.ajax({
        url: '/payments_courses/pay/card',
        method: 'post',
        dataType: 'json',
        data: {
          payment: paymentCoursesData.buffer,
          classroom: paymentCoursesData.classroomData
        },
        success: function (data) {
          window.dataLayer.push({
            event: 'purchase_rush_card_success',
            purchase_value: Number(paymentCoursesData.classroomData.priceRaw)
          })
          paymentCoursesRenders.renderSuccessCard();
          paymentCoursesRenders.showStep('success');
          paymentCoursesRenders.showProcessing(false);
          paymentCoursesRenders.stepTagger('finish');
        },
        error: function (e) {
          var data = e.responseJSON;
          paymentCoursesModal.switchPayButtonEvent(true);
          paymentCoursesRenders.showProcessing(false);

          if (data.step) {
            paymentCoursesRenders.showRecoverableError('Não foi possível processar o pagamento', data.message, data.step);
            return false;
          }

          paymentCoursesRenders.showFatalError('Não foi possível processar o pagamento', data.message);
          return false;
        }
      });
    },

    processGenerateBillet: function () {
      paymentCoursesRenders.showProcessing();

      if (paymentCoursesData.friends.length > 0) {
        paymentCoursesModal.generateBilletForFriends();
        return true;
      }

      $.ajax({
        url: '/payments_courses/pay/billet',
        method: 'post',
        data: {
          classroom: paymentCoursesData.classroomData
        },
        success: function (data) {
          window.dataLayer.push({
            event: 'purchase_rush_boleto_finish',
            purchase_value: data.billet.billetAmount / 100
          })
          var render = Mustache.render(
            paymentCoursesRenders.getTemplate(paymentCoursesModal.steps.successBillet),
            data
          );
          $('#paymentCoursesSuccessBillet').html(render);
          paymentCoursesRenders.showStep('successBillet');

          paymentCoursesRenders.stepTagger('finish');
          paymentCoursesRenders.showProcessing(false);
          paymentCoursesModal.updateOnClose = true;
        },
        error: function (e) {
          var data = e.responseJSON;
          paymentCoursesRenders.showFatalError('Não foi possível gerar o boleto', data.message);
          return false;
        }
      });

      return true;
    },

    generateBilletForFriends: function () {
      var friends = paymentCoursesData.friends;

      $.ajax({
        url: '/payments_courses/pay/billet',
        method: 'post',
        data: {
          classroom: paymentCoursesData.classroomData,
          friends: friends
        },
        success: function (data) {
          window.dataLayer.push({
            event: 'purchase_rush_boleto_finish',
            purchase_value: data.billet.billetAmount / 100
          })
          var render = Mustache.render(
            paymentCoursesRenders.getTemplate(paymentCoursesModal.steps.successBillet),
            data
          );
          $('#paymentCoursesSuccessBillet').html(render);
          paymentCoursesRenders.showStep('successBillet');
          paymentCoursesRenders.showProcessing(false);
          paymentCoursesModal.updateOnClose = true;
        },
        error: function (e) {
          var data = e.responseJSON;
          paymentCoursesRenders.showFatalError('Não foi possível gerar o boleto', data.message);
          return false;
        }
      });
    },

    paymentCoursesForFriends: function (){
      var friends = paymentCoursesData.friends;

      $.ajax({
        url: '/payments_courses/pay/card',
        method: 'post',
        dataType: 'json',
        data: {
          payment: paymentCoursesData.buffer,
          classroom: paymentCoursesData.classroomData,
          friends: friends
        },
        success: function (data) {
          window.dataLayer.push({
            event: 'purchase_rush_card_success',
            purchase_value: Number(paymentCoursesData.classroomData.priceRaw)
          })
          paymentCoursesRenders.renderSuccessCard();
          paymentCoursesRenders.showStep('success');
          paymentCoursesRenders.showProcessing(false);
          paymentCoursesRenders.stepTagger('finish');
        },
        error: function (e) {
          var data = e.responseJSON;

          if (data.step) {
            paymentCoursesRenders.showRecoverableError('Não foi possível processar o pagamento', data.message, data.step);
            return false;
          }

          paymentCoursesRenders.showFatalError('Não foi possível processar o pagamento', data.message);
          return false;
        }
      });

    },
  };

  var paymentCoursesData = {
    installments: null,
    classRoom: null, // Data from html element, just an id
    classRoomData: null, // Data from server, full classroom info
    paymentMethod: false,
    hasPendingPayment: false,
    buffer: {},
    friends: [],

    loadStepData: function (step) {
      if (step !== 'reviewCardPayment' && paymentCoursesData.buffer[step]) {
        $.each(paymentCoursesData.buffer[step], function (name, value) {
          $('#paymentCoursesModal [name="' + name + '"]').val(value);
        });
      }
    },

    loadUserData: function () {
      return $.getJSON('/payments_courses/billing-info/');
    },

    loadClassroomData: function (classroom) {
      return $.getJSON('/payments_courses/classroom-info/' + classroom);
    },

    setPaymentConfig: function (key, value) {
      this[key] = value;
      return true;
    },

    saveLocal: function (step, validateBypass) {
      if (validateBypass !== false) {
        return paymentCoursesData.validateForm(step);
      }

      return true;
    },

    saveLocalItem: function (step, key, value) {
      if (key === 'card_cvv') {
        return false;
      }

      if (!paymentCoursesData.buffer[step]) {
        paymentCoursesData.buffer[step] = {};
      }
      paymentCoursesData.buffer[step][key] = value;

      return true;
    },

    validateStep: function (step, value) {
      switch (step) {
        case 'paymentMethod':
          return paymentCoursesData.setPaymentConfig(step, value);
        case 'cardData':
          switch(paymentCoursesModal.language) {
            case 'pt-br':
            case 'english':
              return paymentCoursesData.pagarMeValidateCardData(step, value);
          }
        default:
          var form_data = $('#form_' + step).serialize();
          var form_valid = paymentCoursesData.saveLocal(step);

          if (form_valid !== true) {
            return { errors: form_valid };
          }

          return $.ajax({
            type: 'POST',
            dataType: 'json',
            data: form_data,
            url: '/payments_courses/modal-step/' + encodeURIComponent(step),
          });
      }
    },

    validateForm: function(step) {
      var form_el = document.getElementById('form_' + step);
      if (form_el && form_el.classList) {
        form_el.classList.add('has-submited');
        if (!paymentCoursesData.validateFormCustom(form_el, step)) {
          var errors = paymentCoursesData.validateFormGetErrors(form_el);
          return {
            name: 'form',
            message: errors,
          }
        }
      } else {
        return false;
      }
      return true;
    },

    validateFormCustom: function (form_el, step) {
      switch (step) {
        case 'personalData':
        case 'cardData':
          var document_number_field = form_el.querySelector('input[name="document_number"]');
          var document_number_field_value = paymentCoursesData.getOnlyNumbers(document_number_field.value);

          if (!paymentCoursesData.validateDocumentNumber(document_number_field_value)) {
            document_number_field.setCustomValidity('CPF inválido');
            return false;
          }

          paymentCoursesData.validateHtml5Clear([ document_number_field ]);
          return paymentCoursesData.validateHtml5(form_el);

        case 'address':
          var zipcode_isvalid = form_el.querySelector('input[name="zipcode_isvalid"]');
          var zipcode = form_el.querySelector('input[name="zipcode"]');

          if (zipcode_isvalid.value === 'false') {
            zipcode.setCustomValidity('CEP inválido');
            return false;
          }

          paymentCoursesData.validateHtml5Clear([ zipcode ]);
          return paymentCoursesData.validateHtml5(form_el);

        default:
          return paymentCoursesData.validateHtml5(form_el);
      }
    },

    validateHtml5: function (form) {
      if (!form.checkValidity()) {
        return false;
      }
      return true;
    },

    validateHtml5Clear: function (fields) {
      fields.forEach(function(el, i) {
        el.setCustomValidity('');
      });
    },

    validateDocumentNumber: function(document_number) {
      if (document_number.length > 11) {
        return paymentCoursesData.validateCnpj(document_number);
      } else {
        return paymentCoursesData.validateCpf(document_number);
      }
    },

    validateCpf: function (strCPF) {
      var Soma;
      var Resto;
      Soma = 0;
      if (strCPF == "00000000000") return false;

      for (i=1; i<=9; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11))  Resto = 0;
      if (Resto != parseInt(strCPF.substring(9, 10)) ) return false;

      Soma = 0;
      for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;

      if ((Resto == 10) || (Resto == 11))  Resto = 0;
      if (Resto != parseInt(strCPF.substring(10, 11) ) ) return false;
      return true;
    },

    validateCnpj: function (strCnpj) {
      if (strCnpj == "00000000000000" ||
          strCnpj == "11111111111111" ||
          strCnpj == "22222222222222" ||
          strCnpj == "33333333333333" ||
          strCnpj == "44444444444444" ||
          strCnpj == "55555555555555" ||
          strCnpj == "66666666666666" ||
          strCnpj == "77777777777777" ||
          strCnpj == "88888888888888" ||
          strCnpj == "99999999999999")
          return false;

      tamanho = strCnpj.length - 2
      numeros = strCnpj.substring(0,tamanho);
      digitos = strCnpj.substring(tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
              pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(0))
          return false;

      tamanho = tamanho + 1;
      numeros = strCnpj.substring(0,tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
              pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
      if (resultado != digitos.charAt(1))
            return false;

      return true;
    },

    validateFormGetErrors: function(form) {
      var invalidFields = [];

      // Find all invalid fields within the form.
      form.querySelectorAll( ":invalid" ).forEach( function(node, index) {
        var messageEl = node.querySelector('.paymentCourses-error-message');

        if (messageEl !== null) {
          invalidFields.push({
            error_element: messageEl,
            element: messageEl.previousSibling.previousSibling,
            message: messageEl.textContent
          });
        }
      });

      return invalidFields;
    },

    getOnlyNumbers: function (str) {
      return str.replace(/[^0-9]/g, '');
    },

    saveBasicCardData: function(validation, callback) {
      paymentCoursesRenders.showLoading();

      var errors = validation.errors;

      $.ajax({
        method: 'POST',
        data: {
          card_holder_name: $('#paymentCoursesCardData [name=card_holder_name]').val(),
          document_number: $('#paymentCoursesCardData [name=document_number]').val(),
          email: $('#paymentCoursesCardData [name=email]').val(),
          ddd: $('#paymentCoursesCardData [name=ddd]').val(),
          number: $('#paymentCoursesCardData [name=number]').val()
        },
        url: '/payments_courses/modal-step/cardData',
        fail: function(e) {
          var data = e.responseJSON;
          errors = errors.concat(data.errors);
        },
        complete: function() {
          if (errors && errors.length > 0) {
            paymentCoursesModal.showFormErrors(errors);
            paymentCoursesRenders.showLoading(false);
            return false;
          }
          callback.call(this);
        }
      });
    },

    pagarMeError: function (error) {
      return {
        errors: [{
          name: 'card_number',
          message: 'Cartão em formato incorreto.'
        }],
        card: {},
        promisse: null
      };
    },

    pagarMeValidateCardData: function() {
      paymentCoursesRenders.showLoading();
      var card = {};
        card.card_holder_name = $('#paymentCoursesModal [name=card_holder_name]').val();
        card.card_expiration_date = $('#paymentCoursesModal [name=card_expiration_date]').val();
        card.card_number = $('#paymentCoursesModal [name=card_number]').val();
        card.card_cvv = $('#paymentCoursesModal [name=card_cvv]').val();
      var field_errors = [];
      var cardValidations = {};

      try {
        cardValidations = pagarme.validate({ card: card });
      } catch(err) {
        return paymentCoursesData.pagarMeError(err);
      }

      if(!cardValidations.card.card_holder_name || card.card_holder_name.length <= 2) {
        field_errors.push({
          name: 'card_holder_name',
          message: 'Nome obrigatório.'
        });
      }
      if(!cardValidations.card.card_expiration_date) {
        field_errors.push({
          name: 'card_expiration_date',
          message: 'Validade incorreta.'
        });
      }
      if(!cardValidations.card.card_number) {
        field_errors.push({
          name: 'card_number',
          message: 'Cartão em formato incorreto.'
        });
      }
      if(!cardValidations.card.card_cvv) {
        field_errors.push({
          name: 'card_cvv',
          message: 'CVV incorreto.'
        });
      }

      if(cardValidations.card.brand) {
        paymentCoursesData.saveLocalItem('cardData', 'card_brand', cardValidations.card.brand);
      }

      var form_valid = paymentCoursesData.validateForm('cardData');
      if (form_valid !== true) {
        field_errors.push(form_valid);
      }

      return {
        errors: field_errors,
        card: card,
        promisse: pagarme.client.connect({ encryption_key: paymentCoursesModal.encryptionKey }),
      };
    },

    pagarMeFetchCreditCard: function (validation, goto) {
      paymentCoursesRenders.showLoading();

      paymentCoursesData.saveBasicCardData(validation, function() {
        validation.promisse.then(function(client) {
          if (!client.security) {
            paymentCoursesRenders.showLoading(false);
            return false;
          }
          client.security.encrypt(validation.card).then(function(card_hash) {
            paymentCoursesRenders.showLoading(false);
            if (card_hash) {
              paymentCoursesData.saveLocalItem('cardData', 'card_hash', card_hash);

              if (!paymentCoursesRenders.renderNextStep(goto)) {
                paymentCoursesRenders.showFatalError('Não foi possível ir para a próxima etapa');
              }

              paymentCoursesRenders.showStep(goto);
              return true;
            } else {
              paymentCoursesRenders.showFatalError('Ocorreu um erro ao validar seu cartão');
              return false;
            }
          });
        });
      })
      return false;
    },

    postcodeSearch: function (postcode, fallback) {
      $('#paymentCoursesAddress [name=zipcode]').addClass('zipcode-searching');
      $('#paymentCoursesAddress [name=street]').attr('disabled', true);
      $('#paymentCoursesAddress [name=neighborhood]').attr('disabled', true);
      $('#paymentCoursesAddress [name=city]').attr('disabled', true);
      $('#paymentCoursesAddress [name=state]').attr('disabled', true);

      var postcode = postcode !== undefined ? postcode : paymentCoursesData.buffer.address.zipcode != null ? paymentCoursesData.buffer.address.zipcode.replace(/-/g, "") : '';
      var fallback = fallback !== undefined ? fallback : false;
      var gatewayChoice = paymentCoursesData.postcodeChooseGateway(postcode, fallback);

      $.ajax({
        url: gatewayChoice.zipGatewayUrl,
        method: 'GET',
        dataType: 'json',
        timeout: 1500
      })
      .done(function (address) {
        if (address.erro) {
          paymentCoursesData.postcodeSearch(postcode, true);
          return false;
        }

        var data = {};
        for (var key in gatewayChoice.zipGatewayFields) {
            data[key] = address[gatewayChoice.zipGatewayFields[key]];
        }

        $('#paymentCoursesAddress [name=zipcode_isvalid]').val('true');
        paymentCoursesData.postcodeComplete(data);
      })
      .fail(function (data, status) {
        if (status === 'error' && gatewayChoice.zipGatewayName !== 'pagarme') {
          paymentCoursesData.postcodeSearch(postcode, true);
        }

        if (status === 'timeout') {
          paymentCoursesData.postcodeSearch(postcode);
        }

        paymentCoursesData.postcodeReset();
        $('#paymentCoursesAddress [name=zipcode_isvalid]').val('false');
      });
    },

    postcodeChooseGateway: function (postcode, fallback) {
      var gatewayChoosen;
      var gatewayRand = (Math.floor((Math.random() * 2) + 1) - 1);
      var gatewayList = [
        {
          zipGatewayName: 'viacep',
          zipGatewayUrl: 'https://viacep.com.br/ws/' + postcode + '/json/',
          zipGatewayFields: {
            street: 'logradouro',
            neighborhood: 'bairro',
            city: 'localidade',
            state: 'uf'
          },
          run: 0,
        },
        {
          zipGatewayName: 'postmon',
          zipGatewayUrl: 'https://api.postmon.com.br/v1/cep/' + postcode,
          zipGatewayFields: {
            street: 'logradouro',
            neighborhood: 'bairro',
            city: 'cidade',
            state: 'estado'
          },
          run: 0,
        }
      ];

      var fallbackGateway = {
        zipGatewayName: 'pagarme',
        zipGatewayUrl: 'https://api.pagar.me/1/zipcodes/' + postcode,
        zipGatewayFields: {
          street: 'street',
          neighborhood: 'neighborhood',
          city: 'city',
          state: 'state'
        },
        run: 0,
      };

      if (fallback === true) {
        gatewayChoosen = fallbackGateway;
        gatewayChoosen.run = fallbackGateway.run + 1;
      } else {
        gatewayChoosen = gatewayList[gatewayRand]
        gatewayChoosen.run = fallbackGateway.run + 1;
      }

      return gatewayChoosen;
    },

    postcodeComplete: function (data) {
      if (data.street) {
        $('#paymentCoursesAddress [name=street]').val(data.street);
        $('#paymentCoursesAddress [name=street_number]').focus();
      }
      if (data.neighborhood) {
        $('#paymentCoursesAddress [name=neighborhood]').val(data.neighborhood);
      }
      if (data.city) {
        $('#paymentCoursesAddress [name=city]').val(data.city);
      }
      if (data.state) {
        $('#paymentCoursesAddress [name=state]').val(data.state);
      }

      $('#paymentCoursesAddress [name=zipcode]').removeClass('zipcode-searching');

      // Habilita campos e da trigger de mudança para salvar na memória
      $('#paymentCoursesAddress [name=street]').attr('disabled', false).change();
      $('#paymentCoursesAddress [name=neighborhood]').attr('disabled', false).change();
      $('#paymentCoursesAddress [name=city]').attr('disabled', false).change();
      $('#paymentCoursesAddress [name=state]').attr('disabled', false).change();
    },

    postcodeReset: function () {
      $('#paymentCoursesAddress [name=street]').val('');
      $('#paymentCoursesAddress [name=neighborhood]').val('');
      $('#paymentCoursesAddress [name=city]').val('');
      $('#paymentCoursesAddress [name=state]').val('');
    },

    getClassroomId: function () {
      return paymentCoursesData.classroomId;
    },
  };

  var paymentCoursesRenders = {
    /**
     * Google Tag's tracking tags
     * @param {string} step
     * @param {value} value
     */
    stepTagger: function (step) {
      var paymentMethod = paymentCoursesData.paymentMethod + '_';

      if (typeof dataLayer === 'undefined') {
        return false;
      }

      // Label according to step
      switch(step) {
        case 'paymentMethod':
          dataLayer.push({ 'event' : paymentMethod + '_course_init' });
          break;
        case 'personalData':
        case 'cardData':
          dataLayer.push({ 'event' : paymentMethod + '_course_info' });
          break;
        case 'address':
          dataLayer.push({ 'event' : paymentMethod + '_course_address' });
          break;
        case 'finish':
          dataLayer.push({ 'event' : paymentMethod + '_course_finish' });
          break;
        default:
          return false;
      }
    },

    getTemplate: function (id) {
      return $('#' + id).html();
    },

    renderNextStep: function (goto) {
      var nextStepReady;

      switch (goto) {
        case 'friendsList':
        case 'paymentMethod':
          nextStepReady = true;
          break;
        case 'personalData':
          nextStepReady = paymentCoursesRenders.renderPersonalData();
          break;
        case 'cardData':
          nextStepReady = paymentCoursesRenders.renderCardData();
          break;
        case 'address':
          nextStepReady = paymentCoursesRenders.renderAddress();
          break;
        case 'reviewCardPayment':
          nextStepReady = paymentCoursesRenders.renderReviewCardPayment();
          break;
        case 'billet':
          nextStepReady = paymentCoursesModal.processGenerateBillet();
          break;
        case 'success':
          nextStepReady = paymentCoursesRenders.renderSuccessCard();
          break;
        case 'fatalError':
          nextStepReady = paymentCoursesRenders.renderFatalError();
          break;
        case 'recoverableError':
          nextStepReady = paymentCoursesRenders.renderRecoverableError();
          break;
        default:
          nextStepReady = false;
      }
      this.hideStepError();

      if (!nextStepReady) {
        paymentCoursesRenders.showFatalError('Não foi possível ir para a próxima etapa');
        return false;
      }

      return true;
    },

    renderFriends: function () {
      var data = {};
      var rendered = Mustache.render(
        paymentCoursesRenders.getTemplate(paymentCoursesModal.steps.friendsList),
        data
      );
      $('#paymentCoursesFriends').html(rendered);

      window.requestAnimationFrame(function () {
        paymentCoursesHelpers.selectFriends(friendsArray);
      });

      return true;
    },

    renderPaymentMethods: function (installments) {
      var data = {
        canBillet: (paymentCoursesModal.language === 'pt-br' && parseInt(installments) === 1),
      };
      var rendered = Mustache.render(
        paymentCoursesRenders.getTemplate(paymentCoursesModal.steps.paymentMethod),
        data
      );
      $('#paymentCoursesPaymentMethod').html(rendered);
      return true;
    },

    renderPersonalData: function () {
      var data = {};

      var rendered = Mustache.render(
        paymentCoursesRenders.getTemplate(paymentCoursesModal.steps.personalData),
        data
      );
      $('#paymentCoursesPersonalData').html(rendered);

      paymentCoursesHelpers.maskInputs();

      return true;
    },

    renderCardData: function () {
      var data = {};
      var render = Mustache.render(
        paymentCoursesRenders.getTemplate(paymentCoursesModal.steps.cardData),
        data
      );
      $('#paymentCoursesCardData').html(render);

      paymentCoursesHelpers.maskInputs();

      return true;
    },

    renderAddress: function () {
      var data = {};

      if (paymentCoursesData.paymentMethod) {
        data.isBillet = (paymentCoursesData.paymentMethod === 'billet');
      }

      var rendered = Mustache.render(
        paymentCoursesRenders.getTemplate(paymentCoursesModal.steps.address),
        data
      );
      $('#paymentCoursesAddress').html(rendered);

      paymentCoursesHelpers.maskInputs();
      paymentCoursesData.postcodeSearch();

      return true;
    },

    renderReviewCardPayment: function () {
      var data = {
          buffer: paymentCoursesData.buffer,
          friends: paymentCoursesData.friends,
          classroom: paymentCoursesData.classroomData,
          payment: {
            installments: paymentCoursesData.installments
          },
      };

      friends_count = paymentCoursesData.friends.length;
      if (friends_count == 0) {
        friends_count = 1;
      }
      var calculatedPrice = (friends_count * data.classroom.priceRaw) / paymentCoursesData.installments;

      data.buffer.cardData.snippet = data.buffer.cardData.card_number.substr(0,4);
      data.classroom.calculatedPrice = calculatedPrice.toLocaleString('pt-BR', { minimumFractionDigits: 2 , style: 'currency', currency: 'BRL' });

      var render = Mustache.render(
        paymentCoursesRenders.getTemplate(paymentCoursesModal.steps.reviewCardPayment),
        data
      );

      $('#paymentCoursesReviewCardPayment').html(render);
      $("#finalFriends").scrollbar();
      return true;
    },

    renderFatalError: function (data) {
      var render = Mustache.render(
        paymentCoursesRenders.getTemplate(paymentCoursesModal.steps.fatalError),
        data
      );
      $('#paymentCoursesFatalError').html(render);
      return true;
    },

    renderRecoverableError: function (data) {
      var render = Mustache.render(
        paymentCoursesRenders.getTemplate(paymentCoursesModal.steps.recoverableError),
        data
      );
      $('#paymentCoursesRecoverableError').html(render);
      return true;
    },

    renderSuccessCard: function () {
      var data = {
        course_name: paymentCoursesData.classroomData.course_name,
        friends: paymentCoursesData.friends,
      };

      paymentCoursesModal.updateOnClose = true;

      var render = Mustache.render(
        paymentCoursesRenders.getTemplate(paymentCoursesModal.steps.success),
        data
      );

      $('#paymentCoursesSuccess').html(render);
      $('.paymentCourses-play-now').click(function(e){
        e.preventDefault();
        $('.play-now').click();
        paymentCoursesModal.close();
      })
      return true;
    },

    renderBreadcrumb: function (data, currentStep) {
      var stepList = {
        friendsList: {
          index: 0,
          step: 'friendsList',
          name: i18n.sub_step_one_b,
          isEnabled: false,
          isActive: false,
        },
        paymentMethod: {
          index: 1,
          step: 'paymentMethod',
          name: i18n.sub_step_two,
          isEnabled: false,
          isActive: false,
        },
        cardData: {
          index: 2,
          step: 'cardData',
          name: i18n.sub_step_three,
          isEnabled: false,
          isActive: false,
        },
        personalData: {
          index: 2,
          step: 'personalData',
          name: i18n.sub_step_three_b,
          isEnabled: false,
          isActive: false,
        },
        address: {
          index: 3,
          step: 'address',
          name: i18n.sub_step_four,
          isEnabled: false,
          isActive: false,
        },
        reviewCardPayment: {
          index: 4,
          step: 'reviewCardPayment',
          name: i18n.sub_step_five,
          isEnabled: false,
          isActive: false,
        }
      };

      if(!paymentCoursesModal.isForFriends()) {
        delete stepList.friendsList;
      }

      if (data.isBillet)  {
        delete stepList.cardData;
        delete stepList.reviewCardPayment;
      } else {
        delete stepList.personalData;
      }

      var activeStep = 0;
      if (stepList[currentStep]) {
        stepList[currentStep].isActive =  true;
        activeStep = stepList[currentStep].index;
      }

      data.steps = [];
      $.each(stepList, function(index, stepData) {
        if (stepData.index < activeStep || (currentStep === 'friendsList' && stepData.index === 0)) {
          stepList[index].isEnabled = true;
        }

        data.steps.push(stepList[index]);
      });

      var rendered = Mustache.render(paymentCoursesModalBreadcrumbTemplate, data);
      $('#paymentCoursesModalBreadcrumb').html(rendered);

      return true;
    },

    updateBreadcrumb: function(goto) {
      var data = {
        isBillet: (paymentCoursesData.paymentMethod === 'billet')
      };

      paymentCoursesRenders.renderBreadcrumb(data, goto);
    },

    gotoStep: function (goto, value) {
      $('#paymentCoursesModal .paymentCourses-error-active').removeClass('paymentCourses-error-active');

      var stepValidation = paymentCoursesData.validateStep(paymentCoursesModal.currentStep, value);

      if (!goto && typeof(goto) !== 'undefined') {
        paymentCoursesRenders.showFatalError('Não foi possível ir para a próxima etapa');
        return false;
      }

      var errors = paymentCoursesHelpers.convertJSON(stepValidation.errors);
      if (errors && errors.length > 0) {
        paymentCoursesRenders.showFormErrors(errors);
        return false;
      }

      if (errors.name === 'form') {
        if (paymentCoursesModal.currentStep == 'friendsList') {
          $('.select2').after('<div class="paymentCourses-error-message paymentCourses-error-active">Nenhum amigo selecionado</div>');
        }

        return false;
      }

      paymentCoursesRenders.stepTagger(paymentCoursesModal.currentStep);

      if (stepValidation.card) {
          paymentCoursesData.pagarMeFetchCreditCard(stepValidation, goto);
          return;
      }

      if(paymentCoursesModal.currentStep === 'friendsList') {
        paymentCoursesData.friends = [];
        $('.select2-selection__choice').each(function(i, el) {
          friendData = $(el).find('.userName');
          paymentCoursesData.friends.push({
            nick: $(friendData).data('user-nick'),
            avatar: $(friendData).data('user-avatar'),
            id: $(friendData).data('user-id')
          });
        });
      }

      if (typeof stepValidation === 'object' && stepValidation.done) {
        paymentCoursesRenders.showLoading();
        stepValidation.done(function (data) {
          var errors = paymentCoursesHelpers.convertJSON(data.errors);

          // Caso haja erros na validação backend
          if (errors && errors.length > 0) {
            paymentCoursesRenders.showFormErrors(errors);
            return false;
          }

          paymentCoursesRenders.hideStepError();
          paymentCoursesRenders.showLoading(false);

          if (!paymentCoursesRenders.renderNextStep(goto)) {
            paymentCoursesRenders.showFatalError('Não foi possível ir para a próxima etapa');
          }
          paymentCoursesRenders.showStep(goto);
        }).fail(function (e) {
          var data = e.responseJSON;
          if (data.success === false) {
            paymentCoursesRenders.showStepError(data.message);
            return false;
          }
        });

        stepValidation.error(function () {
          paymentCoursesRenders.showFatalError('Não foi possivel salvar os dados no servidor');
        });
      } else if (stepValidation === true) {
        if (goto === 'billet') {
          goto = 'personalData';
        } else if (goto === 'card') {
          goto = 'cardData';
        }

        if (!paymentCoursesRenders.renderNextStep(goto)) {
          paymentCoursesRenders.showFatalError('Não foi possível ir para a próxima etapa');
        }

        paymentCoursesRenders.showStep(goto);
      } else {
        paymentCoursesRenders.showFatalError('Não foi possível ir para a próxima etapa');
      }

    },

    showStep: function (goto) {
      paymentCoursesModal.currentStep = goto;
      $('#paymentCoursesModal .paymentCourses-modal-step-active').removeClass('paymentCourses-modal-step-active');

      if (goto === 'personalData' || goto === 'cardData' || goto === 'address') {
        paymentCoursesData.loadStepData(goto);
      }

      paymentCoursesModal.container.attr('data-current-step', goto);
      paymentCoursesRenders.updateBreadcrumb(goto);

      // It prevents a bug that wrongly place the screen during the transition, but, create another bug that just flicker/repeat the breadcrumb animation
      setTimeout(function () {
        $('#paymentCoursesModal [paymentCourses-step=' + goto + ']').addClass('paymentCourses-modal-step-active');
      }, 200);

      paymentCoursesModal.container.scrollTop(0);
    },

    showPendingPayment: function () {
      var billetInfo = paymentCoursesData.buffer.billet;
      if (billetInfo) {
        var data = {
          billet: billetInfo,
        };
        var render = Mustache.render(
          paymentCoursesRenders.getTemplate(paymentCoursesModal.steps.successBillet),
          data
        );

        $('#paymentCoursesSuccessBillet').html(render);
        paymentCoursesRenders.showStep('successBillet');
        paymentCoursesRenders.showProcessing(false);
        return true;
      }

      paymentCoursesData.hasPendingPayment = true;

      paymentCoursesRenders.showFatalError(
        'Assinatura com pagamento pendente',
        'Identificamos que você possui uma assinatura com pagamento pendente, verifique em seu perfil ou e-mail as instruções para pagamento. Em caso de dúvidas, favor entrar em contato com nosso suporte pelo site.'
      );
    },

    showActivepaymentCoursesError: function () {
      paymentCoursesRenders.showFatalError(
        'OPA! VOCÊ JÁ POSSUI UMA ASSINATURA ATIVA :)',
        'Identificamos que você já possui uma assinatura ativa na Gamers Club. Se você não está com a sua medalha de assinante ou precisar de alguma ajuda fale com a nossa equipe.<br><br><button onclick="$crisp.push([\'do\', \'chat:open\'])" class="button">Fale com o suporte</button>'
      );
      return false;
    },

    showStepError: function (message) {
      var message_el = document.getElementById('stepErrorMessage');
      if (typeof(message_el) === 'undefined' || !message_el.classList) {
        return false;
      }

      message_el.innerHTML = message;
      message_el.classList.remove('hidden');
      paymentCoursesRenders.showLoading(false);
    },

    showFormErrors: function (errors) {
      $.each(errors, function (key, error) {
        var field = $('#paymentCoursesModal [name="' + error.name + '"]');
        if (field.length > 0) {
          field
            .siblings('.paymentCourses-error-message')
            .text(error.message)
            .addClass('paymentCourses-error-active');
        }
      });
      paymentCoursesRenders.showLoading(false);
    },

    showFatalError: function (title, message) {
      var data = {
        title: title,
        message: message != 'undefined' ? message : false,
        simple: false
      };

      if (typeof message === 'string') {
        data.simple = true;
      }
      paymentCoursesRenders.renderFatalError(data);
      paymentCoursesRenders.showStep('fatalError');
      paymentCoursesRenders.showProcessing(false);
      return true;
    },

    showRecoverableError: function (title, message, step) {
      var data = {
        title: title,
        message: message,
        step: step != 'undefined' ? step : false,
      };

      paymentCoursesRenders.renderRecoverableError(data);
      paymentCoursesRenders.showStep('recoverableError');
      paymentCoursesRenders.showProcessing(false);
    },

    showLoading: function (loaded) {
      if (loaded === false) {
        paymentCoursesModal.container.removeClass('paymentCourses-modal-loading');
        return true;
      }
      paymentCoursesModal.container.addClass('paymentCourses-modal-loading');
      return false;
    },

    showProcessing: function (finished) {
      if (finished === false) {
        paymentCoursesModal.container.removeClass('paymentCourses-modal-process');
        return true;
      }
      paymentCoursesModal.container.addClass('paymentCourses-modal-process');
      return true;
    },

    hideStepError: function () {
      document.getElementById('stepErrorMessage').classList.add('hidden');
    },
  };

  var paymentCoursesHelpers = {
    maskInputs: function () {
      $('[name=ddd]').mask('000');
      $('[name=number]').mask('000000000');
      $('[name=card_cvv]').mask('0000');
      $('[name=card_expiration_date]').mask('00/00');
      $('[name=card_number]').mask('0000 0000 0000 0000 000');

      var cpfOptions = {
        onKeyPress: function (cpf, ev, el, op) {
          var masks = ['000.000.000-000', '00.000.000/0000-00'],
              mask = (cpf.length > 14) ? masks[1] : masks[0];
          $('[name=document_number]').mask(mask, cpfOptions);
        }
      };
      // CPF Brasil
      $('[name=document_number]').mask('000.000.000-000', cpfOptions);
      $('[name=zipcode]').mask('00000-000');
    },

    mustacheHelper: {
      // Faz o parse do template e envia para o contexto global
      parse: function (parsed) {
        var parsed_item = false;
        if ( (!window[parsed] || typeof window[parsed] === 'object') && (parsed_item = document.getElementById(parsed)) ) {
          window[parsed] = parsed_item.innerHTML;
          Mustache.parse(window[parsed]);
        } else if (!window[parsed]) {
          console.error('Não foi possível renderizar', parsed);
        }
      },
      // Faz o parse de multiples templates e envia para o contexto global
      parseMultiple: function (parsed) {
        var template_quantity = parsed.length,
            parsed_item;
        for (var i = 0; i < template_quantity; i++) {
          if ( (!window[parsed[i]] || typeof window[parsed[i]] === 'object') && (parsed_item = document.getElementById(parsed[i])) ) {
            window[parsed[i]] = parsed_item.innerHTML;
            Mustache.parse(window[parsed[i]]);
          } else if (!window[parsed[i]]) {
            console.error('Não foi possível renderizar', parsed[i]);
          }
        }
      }
    },

    selectFriends: function(dataArray){
      jQuery('#friends-list').select2({
        tags: true,
        placeholder: i18n.sub_friends_click_to_see_your_friends,
        width: '100%',
        data: dataArray,
        templateResult: paymentCoursesHelpers.selectFriendsAddUserPic,
        templateSelection: paymentCoursesHelpers.selectFriendsAddUserPic,
        createTag: function (tag) {

          var term = $.trim(tag.term);
          var isnum = /^\d+$/.test(term);

          if (term === '' || isnum === false) {
            return null;
          }

          return {
              id: tag.term,
              text: tag.term,
              isNew : true
          };
        },
        insertTag: function (data, tag) {
          data.push(tag);
        },
      })
      .on('select2:select', function(e){
          $('.paymentCourses-error-message').removeClass('paymentCourses-error-active');

          var id = e.params.data.id;
          $('.select2-selection__choice[title=' + id + ']').addClass('user-searching');

          if(e.params.data.isNew) {
            $.ajax({
              type: 'post',
              url: '/players/find/' + id,
              success: function(msg) {

                var total = friendsArray.filter(
                    function(item){
                        return (item.id == msg.player.id);
                    }
                ).length;

                if (total == 1) {
                  var elementPos = friendsArray.map(function(x) {return x.id; }).indexOf(parseInt(msg.player.id));
                  friendsArray[elementPos].selected = true;
                } else {
                  friendsArray.push({ id: parseInt(msg.player.id), text: msg.player.nick, avatar: msg.player.avatar, selected: true });
                }

                $('#friends-list').select2('destroy');
                $('#friends-list').off();
                $('#friends-list').find('option').remove();
                paymentCoursesHelpers.selectFriends(friendsArray);
              },
              error: function(erro){
                alert('Usuário inválido');
                $('#friends-list').select2('destroy');
                $('#friends-list').off();
                $('#friends-list').find('option').remove();
                paymentCoursesHelpers.selectFriends(friendsArray);
              }
            });
          } else {
            for (var o in friendsArray) {
              if (friendsArray[o].id == id) {
                friendsArray[o].selected = true;
              }
            }
          }
      })
      .on('select2:unselect', function(e){
        var idSelected = e.params.data.id;
        for (var o in friendsArray) {
          if (friendsArray[o].id == idSelected) {
            friendsArray[o].selected = false;
          }
        }
      });

      $('#friends-list').on('change', function(e) {
        var playersChosen = Array.from(new Set($(this).val()))
        var totalPlayers;

        if(playersChosen !== null) {
          totalPlayers = playersChosen.length;
        } else {
          totalPlayers = 0;
        }

        currencySymbol = paymentCoursesData.classroom.currencySymbol;
        formattedPrice = ((paymentCoursesData.classroom.price * totalPlayers) * 1).toFixed(2);

        $('.amigos-total .valor-moeda').html(currencySymbol);
        $('.amigos-total .valor-total').html(formattedPrice);

      });
    },

    selectFriendsAddUserPic: function(data) {
      if (!data.id) {
        return data.text;
      }

      if(!data.avatar){
        return data.text;
      } else {
        var $data = $(
        '<span class="userName" data-user-avatar="' + data.avatar + '" data-user-nick="' + data.text + '" data-user-id="' + data.id + '" ><img src="' + data.avatar + '" class="userPic" /> ' + data.text + '</span>'
        );
        return $data;
      }
    },

    convertJSON: function (input) {
      if (typeof(input) === 'undefined') {
        return false;
      }

      if (typeof(input) === 'object') {
        return input;
      }

      var json_converted = {};

      try {
        json_converted = JSON.parse(input);
        return json_converted;
      } catch (e) {
        paymentCoursesRenders.showFatalError('Erro geral durante o processamento do pagamento');
        return false;
      }
    },
  };

  paymentCoursesModal.init();
});


//  Funções usadas no React
window.reactFunctions = {};

var addWidget = function (widget) {
  var addWidgetsInterval = setInterval(function () {
    if (window.Widgets) {
      window.Widgets.add(widget);
      clearInterval(addWidgetsInterval);
    }
  }, 1000);
};


var WidgetsFunctions = {
  addWidget: addWidget
};

Object.assign(window.reactFunctions, WidgetsFunctions);

var customEventPrefix = 'gc-custom-event:';

var dispatchCustomEvent = function (eventName, data) {
  var onCustomEvent = new CustomEvent(customEventPrefix + eventName, {
    detail: data
  });

  window.dispatchEvent(onCustomEvent);
};

var createCustomEventListener = function (eventName, callback) {
  var onEventListener = function (event) {
    callback(event.detail || {}, event);
  };

  window.addEventListener(customEventPrefix + eventName, onEventListener);
};

var removeCustomEventListener = function (eventName) {
  window.removeEventListener(customEventPrefix + eventName);
};

var customEventsFunctions = {
  dispatchCustomEvent: dispatchCustomEvent,
  createCustomEventListener: createCustomEventListener,
  removeCustomEventListener: removeCustomEventListener
};

Object.assign(window.reactFunctions, customEventsFunctions);

var PREMIUM_MEDAL_ID = 11;

var createReactModalContainer = function () {
  var modalContainerId = 'GamersClubCSApp-modals';
  var container = document.getElementById(modalContainerId);

  if (!container) {
    var elementContainer = document.createElement('div');

    elementContainer.id = modalContainerId;

    document.body.appendChild(elementContainer);
  }

  return modalContainerId;
};

var openRankedModal = function (rankedId, inQueue) {
  if (!rankedId) return;

  var targetElement = createReactModalContainer();

  window.reactFunctions.addWidget({
    name: 'lobby',
    targetElement: targetElement,
    props: {
      widgets: [{
        id: 'rankedModal',
        props: {
          rankedId: rankedId,
          inQueue: !!inQueue
        }
      }]
    }
  });
};

var openMatchModal = function () {
  var targetElement = createReactModalContainer();

  window.reactFunctions.addWidget({
    name: 'lobby',
    targetElement: targetElement,
    props: {
      widgets: [{
        id: 'matchModal'
      }]
    }
  });
};

var openQuickShopModal = function (obj) {
  window.reactFunctions.addWidget({
    name: 'coins',
    props: {
      openModalProps: {
        name: 'quickShopModal',
        props: obj
      }
    }
  });
};

var openPaywallModal = function (params, callback) {
  window.reactFunctions.addWidget({
    name: 'globals',
    props: {
      widgets: [{
        id: 'paywallModal',
        props: {
          paywallModalParams: params,
          onClose: callback
        }
      }]
    }
  });
};

var openSubscriptionAddressUpdateModal = function (params, callback) {
  var lastUpdateTimestamp = localStorage.getItem('gc:subscriptionUpdateTimestamp');

  if (lastUpdateTimestamp) {
    var lastUpdateDate = new Date(lastUpdateTimestamp);
    var currentDate = new Date();
    var timeDifference = (currentDate - lastUpdateDate) / 1000 / 60;
    if (timeDifference < 20) return;
  }

  window.reactFunctions.addWidget({
    name: 'globals',
    props: {
      widgets: [{
        id: 'subscriptionUpdateAddressModal',
        props: {
          subscriptionAddressUpdateModalParams: params,
          onClose: callback
        }
      }]
    }
  });
};

var openTournamentRegistrationModal = function (tournamentId, medalRestrictionId) {
  if (!window.PLAYERID) {
    window.location.href = '/auth?redirect=/tournaments/cs/' + tournamentId;
    return false;
  }

  var shouldShowPaywall = !window.ISPREMIUM
    && medalRestrictionId
    && Number(medalRestrictionId) === PREMIUM_MEDAL_ID;

  if (shouldShowPaywall) {
    openPaywallModal({
      eventLabel: 'Campeonato',
      requiredPlan: 'premium',
      showFreePass: false,
      title: window.PAYWALL_MODAL_TOURNAMENT_TITLE
    }, function () {
      window.reactFunctions.addWidget({
        name: 'tournaments',
        props: {
          widgets: [{
            id: 'registrationTournamentModal',
            forceOpen: true,
            props: {
              tournamentId: tournamentId
            }
          }]
        }
      });
    });
  } else {
    window.reactFunctions.addWidget({
      name: 'tournaments',
      props: {
        widgets: [{
          id: 'registrationTournamentModal',
          forceOpen: true,
          props: {
            tournamentId: tournamentId
          }
        }]
      }
    });
    return true;
  }

  return false;
};

var openTournamentCheckinModal = function (tournamentId, medalRestrictionId) {
  var shouldShowPaywall = !window.ISPREMIUM
    && medalRestrictionId
    && Number(medalRestrictionId) === PREMIUM_MEDAL_ID;

  if (shouldShowPaywall) {
    openPaywallModal({
      eventLabel: 'Campeonato',
      requiredPlan: 'premium',
      showFreePass: false,
      title: window.PAYWALL_MODAL_TOURNAMENT_TITLE
    });
  } else {
    window.reactFunctions.addWidget({
      name: 'tournaments',
      props: {
        widgets: [{
          id: 'checkinTournamentModal',
          forceOpen: true,
          props: {
            tournamentId: tournamentId
          }
        }]
      }
    });
  }
};

var openInfractionPenaltyModal = function () {
  window.reactFunctions.addWidget({
    name: 'lobby',
    props: {
      widgets: [{
        id: 'infractionModal',
        forceOpen: true
      }]
    }
  });
};

var openPunishmentModal = function (simplifiedView) {
  window.reactFunctions.addWidget({
    name: 'globals',
    props: {
      widgets: [{
        id: 'punishmentModal',
        forceOpen: true,
        props: {
          simplified: !!simplifiedView
        }
      }]
    }
  });
};

var openSystemNotificationModal = function (messageId, message, type) {
  window.reactFunctions.addWidget({
    name: 'globals',
    props: {
      widgets: [{
        id: 'systemNotificationModal',
        forceOpen: true,
        props: {
          messageId: messageId,
          message: message,
          type: type
        }
      }]
    }
  });
};

var openCreateLobbyModal = function () {
  window.reactFunctions.addWidget({
    name: 'lobby',
    hideLoading: true,
    props: {
      widgets: [{
        id: 'createLobbyModal',
        props: {
          isSubscriptionAllowed: !!window.currentUser.features.subscription
        }
      }]
    }
  });
};

var openUnikrnModal = function (slug) {
  window.reactFunctions.addWidget({
    name: 'globals',
    hideLoading: true,
    props: {
      widgets: [{
        id: 'unikrnModal',
        forceOpen: true,
        props: {
          slug: slug
        }
      }]
    }
  });
};

var modalsFunctions = {
  openRankedModal: openRankedModal,
  openMatchModal: openMatchModal,
  openQuickShopModal: openQuickShopModal,
  openTournamentCheckinModal: openTournamentCheckinModal,
  openTournamentRegistrationModal: openTournamentRegistrationModal,
  openInfractionPenaltyModal: openInfractionPenaltyModal,
  openPunishmentModal: openPunishmentModal,
  openCreateLobbyModal: openCreateLobbyModal,
  openSystemNotificationModal: openSystemNotificationModal,
  openUnikrnModal: openUnikrnModal,
  openPaywallModal: openPaywallModal,
  openSubscriptionAddressUpdateModal: openSubscriptionAddressUpdateModal
};

Object.assign(window.reactFunctions, modalsFunctions);

var renderLobbyHeader = function (props) {
  var payload = Object.assign(props || {},
    {
      showCoins: window.showCoins === 1,
      isSubscriptionAllowed: !!window.currentUser.features.subscription
    });

  window.reactFunctions.addWidget({
    name: 'lobby',
    hideLoading: true,
    props: {
      widgets: [{
        id: 'lobbyHeader',
        props: payload
      }]
    }
  });

  window.reactFunctions.createCustomEventListener('onOpenRankedModal', function (data) {
    var ranked = data.rankedId;

    if (ranked) {
      window.common.modal.openContractPlayNow(ranked);
      dataLayer.push({ event: 'cs:lobby:click:ranked_' + ranked });
    }
  });
};

// function setStyle(node, styles) {
//   Object.keys(styles).forEach(function (key) {
//     node.style[key] = styles[key];
//   });
// }

// We change lobbyRoomsPage height to 0 by default in css.
// function showLobbyElements() {
//   var lobbyRoomsPage = document.getElementById('lobby-rooms-page');
//   setStyle(lobbyRoomsPage, {
//     maxHeight: '10000px',
//     overflow: 'hidden'
//   });
// }

// function updateLobbySelectedGame(selectedGame) {
//   window.ComponentLobbyRoomList.setState(function (prevState) {
//     if (!prevState) {
//       return null;
//     }

//     var newFilters = Object.assign(prevState.filters, { game: selectedGame });

//     var newState = Object.assign(prevState, { game: selectedGame, filters: newFilters });

//     return newState;
//   });
// }

// var renderGameSelector = function () {
//   var navbarHeight = document.getElementById('navbar-placeholder').getBoundingClientRect().height || 0;
//   var gcHeaderHeight = document.getElementById('csgo-header-wrapper').getBoundingClientRect().height || 82;
//   var viewportHeight = window.innerHeight;

//   var widgetHeight = viewportHeight - (navbarHeight + gcHeaderHeight);
// var localStorageGamekey = 'gc:selected-game-key';

// if (!window.lobbyOn) {
//   window.localStorage.removeItem(localStorageGamekey);
// } else {
//   var gameData = { data: window.lobbyOnGameSelected };
//   window.localStorage.setItem(localStorageGamekey, JSON.stringify(gameData));

//   updateLobbySelectedGame(window.lobbyOnGameSelected);
// }

// window.reactFunctions.createCustomEventListener('onGameChangeListener', function (event) {
//   updateLobbySelectedGame(event.data.game);
// });

// window.reactFunctions.addWidget({
//   name: 'lobby',
//   hideLoading: false,
//   loadingHeight: widgetHeight,
//   props: {
//     widgets: [{
//       id: 'gameSelector',
//       gameSelectorProps: {
//         isLobbyCS2Disabled: isLobbyCS2Disabled
//       }
//     }]
//   }
// });

// window.reactFunctions.createCustomEventListener(
//   'onGameSelectListener',
//   function () {
//     showLobbyElements();
//   }
// );
// };

var renderIntroJsOnboarding = function (data) {
  window.Widgets.forceRerender({
    name: 'tutorial',
    hideLoading: true,
    props: {
      steps: data.steps,
      showIntroModal: data.showIntroModal,
      onboardingKey: data.key,
      introModalContent: data.introModalContent
    }
  });
};

var generalFunctions = {
  renderLobbyHeader: renderLobbyHeader,
  // renderGameSelector: renderGameSelector,
  renderIntroJsOnboarding: renderIntroJsOnboarding
};

Object.assign(window.reactFunctions, generalFunctions);

var createToasterContainer = function () {
  var containerId = 'GamersClubCSApp-globals-globalToaster';
  var container = document.getElementById(containerId);

  if (!container) {
    var elementContainer = document.createElement('div');

    elementContainer.id = containerId;
    elementContainer.classList.add('GamersClubCSApp');

    return !!document.body.appendChild(elementContainer);
  }

  return true;
};

var showToaster = function (toaster) {
  if (createToasterContainer()) {
    if (!document.getElementById('gctoast-globalToaster')) {
      window.reactFunctions.addWidget({
        name: 'globals',
        props: {
          widgets: [{
            id: 'globalToaster',
            globalToasterProps: toaster
          }]
        }
      });
    }

    setTimeout(function () {
      window.reactFunctions.dispatchCustomEvent('showGlobalToasterMessage', toaster);
    }, 2000);
  }
};

var hideToaster = function () {
  window.reactFunctions.dispatchCustomEvent('hideGlobalToasterMessage');
};

var dispatchToaster = function (toaster) {
  window.reactFunctions.dispatchCustomEvent('showGlobalToasterMessage', toaster);
};

var toasterFunctions = {
  showToaster: showToaster,
  hideToaster: hideToaster,
  dispatchToaster: dispatchToaster
};

Object.assign(window.reactFunctions, toasterFunctions);

var createSnackbarContainer = function () {
  var containerId = 'GamersClubCSApp-globals-globalSnackbar';
  var container = document.getElementById(containerId);

  if (!container) {
    var elementContainer = document.createElement('div');

    elementContainer.id = containerId;
    elementContainer.classList.add('GamersClubCSApp');

    return !!document.body.appendChild(elementContainer);
  }

  return true;
};

var showSnackbar = function (type) {
  if (createSnackbarContainer()) {
    if (!document.getElementById('gcSnackbar-globalSnackbar')) {
      window.reactFunctions.addWidget({
        name: 'globals',
        props: {
          widgets: [{
            id: 'globalSnackbar',
            props: {
              type: type
            }
          }]
        }
      });
    }

    setTimeout(function () {
      window.reactFunctions.dispatchCustomEvent('showGlobalSnackbarMessage');
    }, 2000);
  }
};

var hideSnackbar = function () {
  window.reactFunctions.dispatchCustomEvent('hideGlobalSnackbarMessage');
};

var snackbarFunctions = {
  showSnackbar: showSnackbar,
  hideSnackbar: hideSnackbar
};

Object.assign(window.reactFunctions, snackbarFunctions);


// eslint-disable-next-line no-unused-vars
var chosenScript;
// eslint-disable-next-line no-unused-vars
var randomString = function () {
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < 22; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};

// eslint-disable-next-line no-unused-vars
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

var dialogHTML = '<div class="waiting-dialog"> <div class="content"> <div id="loader-spin"></div> <p>{message}</p> </div> </div>';

// eslint-disable-next-line no-use-before-define
var waitingDialog = waitingDialog || (function ($) {
  'use strict';

  return {

    show: function (message, options) {
      $('.waiting-dialog').remove();
      $('body').append(dialogHTML.replace('{message}', message));
      $('.waiting-dialog').fadeIn('fast');
    },

    hide: function () {
      $('.waiting-dialog').fadeOut('fast');
      setTimeout(function () {
        $('.waiting-dialog').remove();
      }, 500);
    }
  };
}(jQuery));


var noty = function (options) {
  notice(options.text);
};


(function ($) {
  $.ajaxSetup({ async: true });

  var Roots = {
    // All pages
    common: {
      init: function () {
        $("#btn-assinatura-slider").slick({
          vertical: true,
          autoplay: true,
          arrows: false,
          autoplaySpeed: 3500,
          pauseOnFocus: false,
          pauseOnHover: false,
          speed: 700,
        });
        
        $(".alert-dismissible button.close").click(function (e) {
          $(this).parent().hide();
        });
        
        // CALCULA A LARGURA DOS LINKS PARA O BACKGROUND DO SITE
        function calculateBackgroundWidth() {
          var wWidth = $(window).width() - 140;
          var cWidth = 1170;
        
          var bgWidth = (wWidth - cWidth) / 2;
        
          $(".bglink").css("width", bgWidth);
        }
        
        $(document).ready(calculateBackgroundWidth);
        $(window).resize(calculateBackgroundWidth);
        
        /**
         * Botao para fazer share de urls
         */
        var clipboard = new Clipboard(document.querySelectorAll(".btn-copy-url"));
        
        clipboard.on("success", function (e) {
          alert($(e.trigger).data("alert"));
        });
        clipboard.on("error", function (e) {
          alert("Error. Could not copy url.");
        });
        
        /**
         * Mostra os dropdowns do menu
         */
        $(".icon-dropdown, .icon-subdropdown").click(function () {
          var dropdown = "dropdown";
          if ($(this).hasClass("icon-subdropdown")) {
            dropdown = "subdropdown";
          }
        
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(".menu-" + dropdown).removeClass("show");
          } else {
            var dptarget = $(this).data("target");
            $(
              ".menu-" + dropdown + "[data-dropdown=" + dptarget + "] .loader-spin"
            ).show();
            var ajaxUrl = $(this).data("load-url");
            var loadId = $(this).data("load-id");
            var callback = $(this).data("callback");
            if (ajaxUrl && loadId) {
              $(loadId).html("");
              if (callback) {
                loadDropdownDataByCallback(loadId, ajaxUrl);
              } else {
                $(loadId).load(ajaxUrl);
              }
            }
        
            $(".menu-" + dropdown).removeClass("show");
            $(".menu-" + dropdown + "[data-dropdown=" + dptarget + "]").toggleClass(
              "show"
            );
            $(".icon-" + dropdown).removeClass("active");
            $(this).addClass("active");
            $(
              ".menu-" + dropdown + "[data-dropdown=" + dptarget + "] .loader-spin"
            ).hide();
          }
        });
        
        var loadDropdownDataByCallback = function (loadId, ajaxUrl) {
          if (typeof common[callback] !== "undefined") {
            common[callback](loadId, ajaxUrl);
          }
          if (typeof window[callback] !== "undefined") {
            window[callback](loadId, ajaxUrl);
          }
        };
        
        /**
         * Ação para fechar dropdowns do menu
         */
        $(document).on("click", function (event) {
          if (!$(event.target).closest(".interaction-item").length) {
            $(".icon-dropdown").removeClass("active");
            $(".menu-dropdown").removeClass("show");
          }
        
          if (!$(event.target).closest(".pl-stats-actions").length) {
            $(".pl-stats-submenu").hide();
          }
        });
        
        /**
         * Faz submit de forms remotos
         */
        var sendingDataRemoteForm = false;
        $("body").on("submit", "form[data-remote=true]", function (e) {
          e.preventDefault();
          var element = $(this);
        
          clearRemoteFormErrors($(this));
        
          if (sendingDataRemoteForm) {
            alert("Aguarde...");
            return false;
          }
          sendingDataRemoteForm = true;
        
          var self = $(this);
        
          var $actionUrl = $(this).prop("action");
        
          var $formName = $(this).prop("name");
        
          var $method = $(this).prop("method");
        
          var $error_callback = $(this).data("error-callback");
          ($data = $(this).serialize()),
            (serverStatus = $(this).find("button[type=submit]").next(".server-status"));
          button = $(this).find("button[type=submit]");
        
          var customUrl = $(this).find("input[name=customUrl]").val();
          var modalName = $(this).find("input[name=openModal]").val();
        
          var slug = $(this).find("input[name=slug]").val();
        
          displayError = $(this).data("display-error");
        
          if (displayError) {
            $(displayError).hide();
          }
        
          button.find(".initial").css("display", "none");
          button.find(".load").css("display", "block");
        
          $.ajax({
            type: $method,
            url: $actionUrl,
            data: $data,
            dataType: "json",
            success: function (data) {
              self.trigger("submitSuccess");
        
              button.addClass("btn-green");
              button.find(".load").css("display", "none");
              button.find(".success").css("display", "block");
        
              if (data.responseJSON != undefined && data.responseJSON.message) {
                serverStatus.html(data.responseJSON.message);
              }
              if (data.message != undefined) serverStatus.html(data.message);
        
              if (modalName) {
                customUrlShareModal(modalName, customUrl, slug);
              }
        
              if ($formName === "team-form") {
                updateTeamInviteLink(data);
              }
        
              setTimeout(function () {
                button.removeClass("btn-green");
                button.find(".success").css("display", "none");
                button.find(".initial").css("display", "block");
              }, 4000);
            },
        
            error: function (e) {
              var data = e.responseJSON;
        
              if (displayError && data.message) {
                serverStatus.html("");
                $(displayError).html(data.message);
                $(displayError).show();
              } else {
                button.addClass("btn-red");
                button.find(".load").css("display", "none");
                button.find(".error").css("display", "block");
        
                serverStatus.css("color", "red");
        
                if (typeof data === "undefined") {
                  alert("Erro interno, tente novamente mais tarde");
                  return false;
                }
                if (data.message != undefined) alert(data.message);
                if (data.errors) showRemoteFormError(self, data.errors);
                var error_data = {};
                if (data.data) var error_data = data.data;
        
                setTimeout(function () {
                  button.removeClass("btn-red");
                  button.find(".error").css("display", "none");
                  button.find(".initial").css("display", "block");
                }, 4000);
              }
            },
            complete: function (e) {
              setTimeout(function () {
                sendingDataRemoteForm = false;
              }, 2500);
            },
          });
        });
        
        function clearRemoteFormErrors(el) {
          el.find(".form-error-message").text("");
        }
        
        function showRemoteFormError(el, errors) {
          $.each(errors, function (name, message) {
            if ($(".form-error-message." + name).length) {
              $(".form-error-message." + name).text(message);
            } else {
              el.find('[name="' + name + '"]')
                .siblings(".form-error-message")
                .text(message);
            }
          });
        }
        
        // Toggle box
        $(".toggle-container").click(function () {
          var el = $(this).find(".toggle-circle");
          var position = el.data("position");
        
          el.toggleClass("on");
        });
        
        /**
         * Zera as notificacoes do usuario
         */
        window.zerarNotificacoes = function () {
          if (!confirm("Deseja realmente zerar todas as notificações?")) {
            return false;
          }
        
          $.ajax({
            url: "/notificacoes/zerarNotificacoes",
            type: "GET",
            success: function (data) {
              console.log(data);
              $(".tournament-notification").css("display", "none");
            },
            error: function (data) {
              alert(data.responseJSON.message);
            },
          });
        };
        
        /**
         * Desabilita o pace para chamadas ajax.
         */
        window.paceOptions = {
          ajax: false,
          restartOnRequestAfter: false,
        };
        
        /**
         * Scroll personalizado (overflows)
         */
        $(".scroll").each(function (i, el) {
          $disableBodyScroll = false;
        
          if ($(this).hasClass("block-scroll")) {
            $disableBodyScroll = true;
          }
        
          $height = $(el).data("height");
          $(el).scrollbar({
            height: $height,
            disableBodyScroll: $disableBodyScroll,
          });
        });
        
        /**
         * Carrega as imagens com lazy load
         *
         * Exemplo:
         *   <img src="//placehold.it/64x64" data-src="URL DA IMAGEM" class="b-lazy" />
         */
        new Blazy();
        
        /**
         * Configuracoes do Noty
         */
        Noty.overrideDefaults({
          progressBar: true,
          timeout: 5500,
          layout: "topRight",
          closeWith: ["click", "button"],
          animation: {
            open: "animated flipInX",
            close: "animated flipOutX",
          },
        });
        
        // SUBSTITUI ALERTAS POR NOTIFICAÇÕES
        /**
         * Mensagem de info ao usuario
         */
        window.notice = function (msg) {
          new Noty({ type: "info", text: msg }).show();
        };
        
        /**
         * Mensagem de sucesso
         */
        window.success = function (msg) {
          new Noty({ type: "success", text: msg }).show();
        };
        
        /**
         * Mensagem de alerta (e também sobre-escreve funcao alert do browser).
         */
        window.alert = function (msg) {
          new Noty({
            type: "alert",
            text: msg,
          }).show();
        };
        
        /**
         * Mensagem de erro
         */
        window.warning = function (msg) {
          new Noty({
            type: "error",
            text: msg,
          }).show();
        };
        
        /**
         * Comportamentos genericos do perfil
         */
        $(document).on("click", ".showForm", function (e) {
          e.preventDefault();
          $("[data-auto-form]").slideUp("fast");
          formId = $(this).data("form-id");
          $("#" + formId)
            .find(".error")
            .slideUp("fast");
          $("#" + formId)
            .find(".success")
            .slideUp("fast");
        
          if ($("#" + formId).is(":visible")) {
            $("#" + formId).slideUp("fast");
          } else {
            $("#" + formId).slideDown("fast");
          }
          $("#" + $(this).data("focus")).focus();
        });
        
        $(document).on("click", ".hideForm", function (e) {
          e.preventDefault();
          formId = $(this).data("form-id");
          $("#" + formId)
            .find(".error")
            .slideUp("fast");
          $("#" + formId)
            .find(".success")
            .slideUp("fast");
          $("#" + formId).slideUp("fast");
        });
        
        // MARCA MENSAGEM COMO LIDA
        $(".lista-mensagens .mensagem").click(function () {
          $(this).addClass("lida");
        });
        
        $(document).on("submit", "#enviarMensagem", function (e) {
          e.preventDefault();
        
          if (window.enviarMensagemModalTimeout) {
            clearTimeout(window.enviarMensagemModalTimeout);
          }
        
          self = $(this);
          parent = self.parent();
          $actionUrl = $(this).prop("action");
          $method = $(this).prop("method");
          $data = $(this).serialize();
          $clearOnSuccess = $(this).data("form-clear");
        
          parent.removeClass("enviar-mensagem-success");
          parent.addClass("enviar-mensagem-loading");
        
          $(self).find(".server-status").slideUp("fast");
          $(self).find(".server-status").addClass("hidden");
        
          $.ajax({
            type: $method,
            url: $actionUrl,
            data: $data,
            dataType: "json",
            success: function (data) {
              serverStatus = $(self).find(".server-status");
        
              if (typeof data.status === "undefined" || data.status === "success") {
                parent.addClass("enviar-mensagem-success");
                serverStatus.hide();
                window.enviarMensagemModalTimeout = window.setTimeout(function () {
                  $("#modal-enviar-mensagem .close-button").click();
                  $("#modal-enviar-mensagem .enviar-mensagem-success").removeClass(
                    "enviar-mensagem-success"
                  );
                }, 3000);
                if ($clearOnSuccess) {
                  self[0].reset();
                }
              } else {
                serverStatus.text(data.message);
                $(serverStatus).addClass("alert-danger");
                $(serverStatus).slideDown("fast");
              }
        
              if ($(self).data("reload") === true) {
                location.reload(true);
              }
            },
            error: function (data) {
              serverStatus = $(self).find(".server-status");
              serverStatus.text(data.responseJSON.message);
              serverStatus.append(data.responseJSON.errors);
              $(serverStatus).addClass("alert-danger");
              $(serverStatus).slideDown("fast");
            },
            complete: function () {
              parent.removeClass("enviar-mensagem-loading");
            },
          });
        });
        
        setTimeout(function () {
          $(".lazy-link").removeClass("lazy-link");
        }, 500);
        
        // TABS MANUAIS
        $("body").on("click", "li.tab-title a", function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        
          var tabgroup = $(this).closest("ul").attr("tab-group");
        
          var target = $(this).attr("href");
        
          window.location.hash = target;
        
          // Esconde outras tabs
          $(".tabs-content[tab-group=" + tabgroup + "] .content").hide();
        
          // Exibe tab atual
          $(target).show();
        
          // Remove classe ativa das outras tabs
          $("ul[tab-group=" + tabgroup + "]")
            .find("li.tab-title")
            .removeClass("active");
        
          // data-document-title
          documentTitle = $(this).data("document-title");
          if (documentTitle) {
            document.title = documentTitle + " | Gamers Club - Aqui você vive o game.";
          }
        
          // Adiciona classe ativa na tab atual
          $(this).closest("li").addClass("active");
        });
        
        $("#menu li")
          .find("a")
          .hover(
            function () {
              $el = $(this);
              leftPos = $el.position().left;
              newWidth = $el.parent().width();
        
              $magicLine.stop().animate({
                left: leftPos,
                width: newWidth,
              });
            },
            function () {
              $magicLine.stop().animate({
                left: $magicLine.data("origLeft"),
                width: $magicLine.data("origWidth"),
              });
            }
          );
        
        $(".fa-info-circle").on("click", function (event) {
          $(".player-statistics").each(function (index, el) {
            if ($(this).hasClass("show-info-player sou-eu") === false) {
              $(this).removeClass("show-info-player sou-eu");
            } else {
              $(this).removeClass("show-info-player");
            }
          });
        
          // ativa e desativa o tooltip
          if ($(this).siblings(".player-statistics").hasClass("sou-eu")) {
            $(this)
              .siblings(".player-statistics")
              .removeClass("show-info-player sou-eu");
          } else {
            $(this).siblings(".player-statistics").addClass("show-info-player sou-eu");
          }
        });
        
        $("#events").slick({
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          speed: 300,
          dots: true,
          arrows: true,
          // autoplay: true,
          // autoplaySpeed: 3000,
          responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true,
              },
            },
            {
              breakpoint: 750,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
        
        /* ///////MODAL////// */
        $(document).keyup(function (e) {
          if (e.keyCode == 27) {
            $(".close-button").trigger("click");
          }
        });
        $("body").on("click", ".close-button", function (event) {
          var el = $(this);
        
          el.closest(".modal")
            .addClass("fadeOutDown")
            .removeClass("fadeInUp")
            .css({ top: 0 });
        
          setTimeout(function () {
            $(".overlay").fadeOut("fast");
            el.closest(".modal").hide();
          }, 250);
        
          $(".overlay").removeClass("no-opacity-modal ");
          $(".overlay").removeClass("zindex49");
          $(document).unbind("keyup.escclosemodal");
        });
        
        $("div[data-type=modal], a[data-type=modal]").on("click", function (event) {
          var target = $(this).attr("data-modal");
          $(".overlay").fadeIn("fast", function () {
            var distance = $(window).scrollTop();
            $("#" + target).removeClass("fadeOutDown");
            $("#" + target)
              .css({ top: distance })
              .show()
              .addClass("fadeInUp");
            updateTabs();
          });
        
          // Esc to close the modal window and popup menus on header
          $(document).on("keyup.escclosemodal", function (e) {
            if (e.keyCode == 27) {
              $(".close-button").click();
              $(".icon-dropdown").removeClass("active");
              $(".menu-dropdown, .dropdown-menu").removeClass("show");
              $(".pl-stats-submenu").hide();
            }
          });
        });
        
        // Fecha o box de patente quando clica no botão JOGAR
        $(".ranked-cta .btn").click(function () {
          $(".menu-dropdown, .dropdown-menu").removeClass("show");
        });
        
        /* ////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////
        ////////FIM MODAL
        //////////////////////////////////////////////////////////////////
        /////////////////////////////////////////////////////////////// */
        
        $(".show-menu").click(function () {
          var target = $(this).data("target");
          var menuUser = $(target);
          menuUser.find(".menu-notifications-list").scrollbar();
          clearInterval(animMenu);
          if (menuUser.hasClass("fadeInUp")) {
            menuUser.addClass("fadeOutDown").removeClass("fadeInUp").fadeOut(250);
          } else {
            menuUser.show().addClass("fadeInUp").removeClass("fadeOutDown");
            animMenu = setTimeout(function () {
              menuUser.addClass("fadeOutDown").removeClass("fadeInUp").hide();
            }, 1000000);
          }
        });
        
        /* ////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////
        ////////SCRIPT MENU MOBILE
        //////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////. */
        
        $(".icon-menu-mobile").on("click", function (event) {
          $(".mobile-menu").toggleClass("show-mobile-menu");
          $(".icon-menu-mobile i").toggleClass("fa-bars fa-close");
        });
        /* ////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////
        ////////SCRIPT MENU MOBILE
        //////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////. */
        
        /* ////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////
        ////////TABS
        //////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////. */
        
        $(window).resize(function () {
          updateTabs();
          try {
            if (updateTableEvents && typeof updateTableEvents === "function") {
              updateTableEvents();
            }
          } catch ($error) {}
        });
        
        /* ////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////
        ////////TABS
        //////////////////////////////////////////////////////////////////
        ///////////////////////////////////////////////////////////////. */
        
        $(document.body).on("click", ".button_select_tabs", function () {
          var attr = $(this).attr("data-href");
        
          $(".tab-title").each(function () {
            var item = $(this).find("a").attr("href");
        
            if (item == attr) {
              $(this).find("a").click();
            }
          });
        });
        
        $(".select_tabs").on("click", function () {
          clearInterval(animSelectTabs);
        
          if ($(this).find("ul").hasClass("fadeInUp")) {
            $(this).find("ul").addClass("fadeOutDown").removeClass("fadeInUp");
        
            animSelectTabs = setTimeout(function () {
              $(".content_select_tabs").hide();
            }, 1000);
          } else {
            $(this).find("ul").removeClass("fadeOutDown").addClass("fadeInUp").show();
          }
        });
        
        updateTabs();
        
        // Se houver um hash
        if (window.location.hash.length > 0) {
          // Caso seja um hash de uma das tabs
          setTimeout(function () {
            if ($('.tab-title a[href="' + window.location.hash + '"]')) {
              $('.tab-title a[href="' + window.location.hash + '"]').click();
            }
          }, 700);
        }
        
        function updateTabs() {
          $(".tabs-principal").each(function () {
            var _this_principal = $(this);
            var widthTabItens = 0;
            var select_tabs = 0;
            var cont = 0;
            var sizeLine =
              _this_principal.find(".tabs").outerWidth() -
              _this_principal.find(".select_tabs").outerWidth();
            _this_principal.find(".select_tabs ul li").remove();
        
            _this_principal.find(".tabs > .tab-title").each(function () {
              var _this_li = $(this);
              _this_li.removeClass("show-item-tab");
              _this_li.removeClass("hide-item-tab");
              if (_this_li.outerWidth() + widthTabItens <= sizeLine) {
                widthTabItens = _this_li.outerWidth() + widthTabItens;
                _this_li.addClass("show-item-tab");
              } else {
                _this_li.addClass("hide-item-tab");
              }
            });
        
            _this_principal.find(".tabs > li.hide-item-tab").each(function () {
              var _this_hide = $(this);
              var nameItemTab = _this_hide.find("a").attr("data-name");
        
              $(this)
                .siblings("li")
                .find(".content_select_tabs")
                .append(
                  '<li><a data-href="' +
                    _this_hide.find("a").attr("href") +
                    '" class="button_select_tabs">' +
                    nameItemTab +
                    "</a></li>"
                );
        
              select_tabs++;
        
              $(this).siblings("li").find(".count-tabs").text(select_tabs);
            });
        
            if (select_tabs > 0) {
              _this_principal.find(".select_tabs").show();
            } else {
              _this_principal.find(".select_tabs").hide();
            }
          });
        }
        
        if (typeof gcDynamicTooltip !== "undefined") {
          $.debounce_tooltip_leave = gcDynamicTooltip.close;
          $(document).on(
            "mouseenter",
            "[data-jsaction=gcDynamicTooltip]",
            gcDynamicTooltip.open
          );
          $(document).on(
            "mouseleave",
            "[data-jsaction=gcDynamicTooltip]",
            gcDynamicTooltip.close
          );
          $(document).on("mouseleave", "#gc-dynamic-tooltip", gcDynamicTooltip.close);
        }
        
        var gcCommonTooltip = {
          debug: false,
          hiddenRight: function (body_width, element_offset) {
            return body_width < gcDynamicTooltip.width + element_offset.left;
          },
        
          createTooltipEl: function () {
            if (document.getElementById("gc-common-tooltip") === null) {
              var gc_common_tooltip = document.createElement("div");
              gc_common_tooltip.id = "gc-common-tooltip";
              gc_common_tooltip.classList.value = "gc-common-tooltip";
              document.body.appendChild(gc_common_tooltip);
            }
        
            gcCommonTooltip.container = document.getElementById("gc-common-tooltip");
          },
        
          open: function (e) {
            gcCommonTooltip.container.innerHTML =
              e.target.getAttribute("data-title-tooltip");
            var offset = $(e.target).offset();
            position = "left:" + offset.left + "px; top: " + offset.top + "px";
            gcCommonTooltip.container.style = position;
            gcCommonTooltip.container.classList.value += " gc-common-tooltip-active";
          },
        
          close: function (e) {
            gcCommonTooltip.container.classList.value =
              gcCommonTooltip.container.classList.value.replace(
                " gc-common-tooltip-active",
                ""
              );
          },
        
          bind: function (bindOnly) {
            gcCommonTooltip.createTooltipEl();
        
            if (!bindOnly) {
              bindOnly = document;
            }
        
            var titled = bindOnly.querySelectorAll('[data-jsaction="gcCommonTooltip"]');
        
            var titled_count = titled.length;
        
            for (var i = titled_count - 1; i >= 0; i--) {
              var title = titled[i].getAttribute("title");
        
              if (title.length <= 0) {
                continue;
              }
        
              titled[i].setAttribute("title", "");
              titled[i].setAttribute("data-title-tooltip", title);
              titled[i].addEventListener("mouseenter", function (e) {
                gcCommonTooltip.open(e);
              });
        
              titled[i].addEventListener("mouseleave", function (e) {
                gcCommonTooltip.close(e);
              });
            }
          },
        
          bindTo: function (el) {
            gcCommonTooltip.createTooltipEl();
            var title = titled[i].getAttribute("title");
            if (title.length <= 0) {
              return false;
            }
        
            el.setAttribute("title", "");
            el.setAttribute("data-title-tooltip", title);
        
            el.addEventListener("mouseenter", function (e) {
              gcCommonTooltip.open(e);
            });
        
            el.addEventListener("mouseleave", function (e) {
              gcCommonTooltip.close(e);
            });
          },
        };
        
        var openModal = function (target) {
          if (target == "modal-play-now") {
            $(".overlay").addClass("no-opacity-modal");
          }
        
          $(".overlay").fadeIn("fast", function () {
            var subscriptionStatusTopbar = window.document.getElementById(
              "subscription-status-topbar"
            );
            var heightGCHeader = 20;
            if (subscriptionStatusTopbar) {
              heightGCHeader += subscriptionStatusTopbar.offsetHeight;
            }
        
            var distance = $(window).scrollTop() + heightGCHeader;
            $("#" + target).removeClass("fadeOutDown");
            $("#" + target)
              .css({ top: distance })
              .show()
              .addClass("fadeInUp");
          });
        };
        
        var postcodeSearch = {
          container: null,
        
          inputFieldSelectors: [
            "[name=zipcode]",
            "[name=street]",
            "[name=street_number]",
            "[name=complementary]",
            "[name=neighborhood]",
            "[name=city]",
            "[name=state]",
            "[name=country]",
          ],
        
          /**
           * Search zip code to autocomplete address fields
           * @param {string} postcode
           * @param {object} container
           * @param {boolean} fallback
           */
          search: function (postcode, container, fallback) {
            postcodeSearch.container = container;
        
            // Disable fields and set loading on while the request being done
            postcodeSearch.searching();
        
            var fallback = fallback !== undefined ? fallback : false;
            var gatewayChoice = postcodeSearch.postcodeChooseGateway(
              postcode,
              fallback
            );
        
            $.ajax({
              url: gatewayChoice.zipGatewayUrl,
              method: "GET",
              dataType: "json",
              timeout: 1500,
            })
              .done(function (address) {
                if (address.erro) {
                  postcodeSearch.search(postcode, container, true);
                  return false;
                }
        
                var data = {};
                for (var key in gatewayChoice.zipGatewayFields) {
                  data[key] = address[gatewayChoice.zipGatewayFields[key]];
                }
        
                postcodeSearch.done(data);
              })
              .fail(function (data, status) {
                if (status === "error" && gatewayChoice.zipGatewayName !== "pagarme") {
                  postcodeSearch.search(postcode, container, true);
                }
        
                if (status === "timeout") {
                  postcodeSearch.search(postcode, container);
                }
                postcodeSearch.done();
                console.error("Impossível recuperar dados do CEP fornecido");
              });
          },
        
          postcodeChooseGateway: function (postcode, fallback) {
            var gatewayChoosen;
            var gatewayRand = Math.floor(Math.random() * 2 + 1) - 1;
            var gatewayList = [
              {
                zipGatewayName: "viacep",
                zipGatewayUrl: "https://viacep.com.br/ws/" + postcode + "/json/",
                zipGatewayFields: {
                  street: "logradouro",
                  neighborhood: "bairro",
                  city: "localidade",
                  state: "uf",
                },
                run: 0,
              },
              {
                zipGatewayName: "postmon",
                zipGatewayUrl: "https://api.postmon.com.br/v1/cep/" + postcode,
                zipGatewayFields: {
                  street: "logradouro",
                  neighborhood: "bairro",
                  city: "cidade",
                  state: "estado",
                },
                run: 0,
              },
            ];
        
            var fallbackGateway = {
              zipGatewayName: "pagarme",
              zipGatewayUrl: "https://api.pagar.me/1/zipcodes/" + postcode,
              zipGatewayFields: {
                street: "street",
                neighborhood: "neighborhood",
                city: "city",
                state: "state",
              },
              run: 0,
            };
        
            if (fallback === true) {
              gatewayChoosen = fallbackGateway;
              gatewayChoosen.run = fallbackGateway.run + 1;
            } else {
              gatewayChoosen = gatewayList[gatewayRand];
              gatewayChoosen.run = fallbackGateway.run + 1;
            }
        
            return gatewayChoosen;
          },
        
          searching: function (container) {
            postcodeSearch.toggleDisableState(true);
          },
        
          /**
           * Disable/enable 'disabled' attribute off
           * address fields
           * @param {boolean} disable
           */
          toggleDisableState: function (disable) {
            postcodeSearch.inputFieldSelectors.forEach(function (selectorValue) {
              postcodeSearch.container.find(selectorValue).attr("disabled", disable);
            });
          },
        
          /**
           * Set input values
           * @param {string} street
           * @param {string} neighborhood
           * @param {string} city
           * @param {string} state
           * @param {string} street_number
           * @param {string} complementary
           */
          setInputValues: function (
            street,
            neighborhood,
            city,
            state,
            street_number,
            complementary
          ) {
            postcodeSearch.container.find("[name=street]").val(street || "");
            postcodeSearch.container
              .find("[name=neighborhood]")
              .val(neighborhood || "");
            postcodeSearch.container.find("[name=city]").val(city || "");
            postcodeSearch.container.find("[name=state]").val(state || "");
            postcodeSearch.container
              .find("[name=street_number]")
              .val(street_number || "");
            postcodeSearch.container
              .find("[name=complementary]")
              .val(complementary || "");
          },
        
          done: function (data) {
            var containerToFocus = "[name=street]";
        
            postcodeSearch.container.find(containerToFocus).focus();
        
            if (data) {
              // Set all values received
              postcodeSearch.setInputValues(
                data.street,
                data.neighborhood,
                data.city,
                data.state,
                "",
                ""
              );
        
              // Sometimes, the zip code api's can return the neighborhood field
              // empty. Only in this case this input is not disabled, for user
              // complete the info.
              postcodeSearch.container
                .find("[name=neighborhood]")
                .attr("readonly", !!data.neighborhood);
        
              containerToFocus = data.street ? "[name=street_number]" : "[name=street]";
            } else {
              postcodeSearch.setInputValues();
            }
        
            postcodeSearch.toggleDisableState(false);
            postcodeSearch.container.find(containerToFocus).focus();
          },
        };
        
        $(document).on("change", ".postcode-search", function () {
          var postcode = $(this).val().replace(/\D/g, "");
          var container = $($(this).data("container"));
          if (postcode.length == 8) {
            postcodeSearch.search(postcode, container);
          }
        });
        
        // Máscara do formulário de edição do Cadastro
        function maskPaymentData() {
          $("input[name=zipcode]").mask("00000-000");
          $("input[name=ddd]").mask("000");
          $("input[name=number]").mask("000000000");
          $("input[name=card_cvv]").mask("0000");
          $("input[name=card_expiration_date]").mask("00/00");
          $("input[name=card_number]").mask("0000 0000 0000 0000 000");
          var options = {
            onKeyPress: function (cpf, ev, el, op) {
              maskDocumentNumber(cpf, op);
            },
          };
        
          maskDocumentNumber($("input[name=document_number]").val(), options);
        }
        
        function maskDocumentNumber(cpf, op) {
          if (cpf) {
            cpf = cpf.replace(/[\W_]/g, "");
          }
        
          var masks = ["000.000.000-000", "00.000.000/0000-00"];
          var mask = cpf && cpf.length > 11 ? masks[1] : masks[0];
          $("input[name=document_number]").mask(mask, op);
        }
        
        /**
         * Função do botão para fazer check-in do time no campeonato
         *
         * @param {integer} camp_id Id do campeonato
         */
        var fazerCheckin = function FazerCheckin(camp_id) {
          $.ajax({
            type: "post",
            url: "/campeonatos/fazerCheckinCamp/" + camp_id,
            data: { gtmp: "x" },
            success: function (msg) {
              $(".checkin-content").hide();
              $(".checkin-loader-content").show();
              if (msg == "Ok") {
                $(".checkin-loader-content").hide();
                $(".checkin-success-content").show();
              } else {
                $(".checkin-loader-content").hide();
                $(".checkin-error-content").html(msg).show();
              }
            },
            error: function (erro) {
              alert("error, try again.");
            },
          });
        };
        
        var unlinkDiscord = function unlinkDiscord() {
          $.getJSON("/discord/unlink", function (data) {})
            .done(function (data) {
              window.location.reload(true);
            })
            .fail(function (error) {
              alert("Problema ao remover o vínculo, já está desvinculado?");
            });
        };
        
        var openGamersClubExclusivesPayModal = function (medal) {
          medal = parseInt(medal);
        
          var element = null;
        
          element = document.getElementById("openTournamentModalShadow");
          if (element == null) {
            // Create modal element
            var el = document.createElement("div");
            el.id = "openTournamentModalShadow";
            el.dataset.jsaction = "payPlanBtn";
            el.dataset.tournament = medal;
            document.body.appendChild(el);
          }
        
          document.getElementById("openTournamentModalShadow").click();
        };
        var openGamersClubExclusivesModal = function (type) {
          type = parseInt(type);
        
          var element = null;
        
          element = document.getElementById("openTournamentModalShadow");
          if (element == null) {
            // Create modal element
            var el = document.createElement("div");
            el.id = "openTournamentModalShadow";
            el.dataset.jsaction = "payPlanBtn";
            document.body.appendChild(el);
          }
        
          // Get content for this modal (no cache)
          $.ajax({
            url: "/modal/gamersClubExclusives/",
            success: function (content) {
              var opts = {
                modalContainer: "#buyExclusivesMedal",
                modalClass: "simple-modal",
                classes: [],
              };
              var buyExclusivesMedalModal = new SimpleModal(opts);
              buyExclusivesMedalModal.show(content);
        
              document
                .getElementById("buyExclusiveMedalPresent")
                .addEventListener("click", function () {
                  if (typeof dataLayer !== "undefined") {
                    dataLayer.push({
                      event: "comprar_exclusive_goto_escolher_medalha",
                    });
                  }
        
                  document
                    .getElementById("buyExclusiveMedalPresent")
                    .classList.remove("buy-exclusive-medal-content-enabled");
                  document
                    .getElementById("buyExclusiveMedalList")
                    .classList.add("buy-exclusive-medal-content-enabled");
                });
        
              $("#buyExclusiveMedalList .buy-medal-item-wrapper").click(function () {
                if (typeof dataLayer !== "undefined") {
                  dataLayer.push({ event: "comprar_exclusive_escolheu_medalha" });
                }
        
                var tournament_id = $(this).data("medal");
        
                // openTournamentModal(tournament_id);
        
                // Shadow button for opening the payment
                $("#openTournamentModalShadow").data("tournament", tournament_id);
                $("#openTournamentModalShadow").data("jsaction", "payPlanBtn");
                $("#openTournamentModalShadow").click();
        
                // Hide the presentation
                buyExclusivesMedalModal.hide();
              });
            },
          });
        };
        
        if (window.location.hash.match(/comprar-medalha(=\d+)?/)) {
          var medalha_hash = window.location.hash.match(/comprar-medalha(=\d+)?/);
        
          if (typeof medalha_hash !== "undefined" && medalha_hash.length > 0) {
            var medalha_id = medalha_hash[0].match(/\d+/);
        
            if (typeof dataLayer !== "undefined") {
              window.subscriptionPage = "hash_comprar_exclusive_finalizado";
              dataLayer.push({ event: "hash_comprar_exclusive" });
            }
        
            if (medalha_id === null) {
              openGamersClubExclusivesModal();
            } else if (
              typeof medalha_id !== "undefined" &&
              medalha_id.length > 0 &&
              parseInt(medalha_id[0]) > 0
            ) {
              openGamersClubExclusivesPayModal(medalha_id[0]);
            }
          }
        }
        
        /**
         * Friend request - DEPRECATED
         */
        function disableAllFriendActions() {
          $("#gcProfileSidebarActions .gc-friend-actions").removeClass("active");
        }
        var addFriend = function (friendId) {
          disableAllFriendActions();
          $("#gcProfileSidebarActions .js-gc-friend-waiting").addClass("active");
        
          fetch("/api/player/" + friendId + "/gcid")
            .then(function (response) {
              return response.json();
            })
            .then(function (data) {
              var event = new CustomEvent("cf:sendinvite", { detail: data.data.gcID });
        
              window.dispatchEvent(event);
            })
            .catch(function (error) {
              console.error(error);
            });
        };
        
        var undoFriendship = function (friendId, el) {
          disableAllFriendActions();
          $("#gcProfileSidebarActions .js-gc-friend-add").addClass("active");
          FriendsApp.undoFriendship(friendId);
        };
        
        $(document).on("click", '[data-jsaction="openExclusivesBtn"]', function () {
          if (typeof dataLayer !== "undefined") {
            window.subscriptionPage = "btn_camp_comprar_exclusive_finalizado";
            dataLayer.push({ event: "btn_camp_comprar_exclusive" });
          }
          openGamersClubExclusivesModal();
        });
        
        var isLogged = function () {
          return window.PLAYERID > 0;
        };
        
        var loginNotification = function (type) {
          var notyType = !type ? "warning" : type;
          var notyText =
            'Para efetuar esta ação é necessário estar conectado na sua conta Gamers Club.<br /><a href="/auth"><i class="fa fa-arrow-right" aria-hidden="true" style="font-size:12px;margin-right:8px;"></i>Clique aqui para conectar-se</a>';
        
          new Noty({
            type: notyType,
            text: notyText,
          }).show();
        };
        
        /**
         * Opens external modal to informations for Custum URL
         *
         * @param {string} data to defined
         */
        var productRulesModal = function (rule1, rule2, rule3, rule4) {
          if (!rule1 || !rule2 || !rule3 || !rule4) {
            window.location.href = "/loja";
        
            return;
          }
        
          var rules = [rule1, rule2, rule3, rule4];
        
          window.reactFunctions.addWidget({
            name: "coins",
            hideLoading: true,
            props: {
              openModalProps: {
                name: "productRulesModal",
                props: rules,
              },
            },
          });
        };
        /**
         * Opens external modal to buy a product from marketplace
         *
         * @param {string} productSlug slug of the product in marketplace system
         */
        var coinsBuyProduct = function (productSlug) {
          if (!productSlug) {
            window.location.href = "/loja";
        
            return;
          }
        
          window.reactFunctions.addWidget({
            name: "coins",
            hideLoading: true,
            props: {
              openModalProps: {
                name: "purchaseProduct",
                props: {
                  slug: productSlug,
                },
              },
            },
          });
        };
        
        /**
         * Opens external modal to CTA of buy product from marketplace
         *
         * @param {string} category Category of products of a same type of activation passed to CTA
         */
        var coinsCtaProduct = function (category, slug) {
          if (!category) {
            return;
          }
        
          window.reactFunctions.addWidget({
            name: "coins",
            hideLoading: true,
            props: {
              openModalProps: {
                name: "ctaItem",
                props: {
                  category: category,
                  slug: slug,
                },
              },
            },
          });
        };
        
        var openPunishmentModal = function (simplifiedView) {
          window.reactFunctions.openPunishmentModal(!!simplifiedView);
        };
        
        var openInfractionPenaltyModal = function () {
          window.reactFunctions.openInfractionPenaltyModal();
        };
        
        /**
         * Opens external modal informing that the player has won coins
         *
         * @param {object} data data of information content text modal
         */
        var coinsNotifyReward = function (data) {
          var data = data || {};
          var vaultData = data.vault ? data.vault : null;
        
          var message =
            data.message ||
            "Você venceu sua última partida e por isso ganhou moedas para trocar por itens e funcionalidades exclusivas.";
          var coins = {
            type: data.coinType || "soft",
            amount: data.coinAmount || 0,
            isVaultDrop: data.isVaultDrop || false,
            vault: vaultData,
          };
          var win = data.win || null;
          var isChallange1x1 = data.isChallange1x1 || null;
          var showProductRecommendation = data.showProductRecomendation || false;
        
          window.reactFunctions.addWidget({
            name: "coins",
            hideLoading: true,
            props: {
              openModalProps: {
                name: "rewardCoins",
                props: {
                  message: message,
                  coins: coins,
                  win: win,
                  isChallange1x1: isChallange1x1,
                  showProductRecommendation: showProductRecommendation,
                },
              },
            },
          });
        };
        
        var vaultContentsModal = function (playerId, playerNick, vaultSlug) {
          var noVault = vaultSlug === "" || undefined || null;
          if (noVault) {
            return;
          }
        
          window.reactFunctions.addWidget({
            name: "coins",
            hideLoading: true,
            props: {
              openModalProps: {
                name: "vaultContents",
                props: {
                  playerId: playerId,
                  playerNick: playerNick,
                  vaultSlug: vaultSlug,
                },
              },
            },
          });
        };
        
        var openModalTemplateWasd = function (modalInfo) {
          if (!modalInfo) {
            modalInfo = {};
          }
        
          if (!modalInfo.id) {
            modalInfo.id = "modal-v2-id";
          }
        
          var modalHTML =
            '<div id="' + modalInfo.id + '" class="ModalTemplateWasd__Wrapper">';
          modalHTML +=
            '<div class="ModalTemplateWasd__WrapperOverlay overlay" onclick="window.common.closeModalTemplateWasd(\'' +
            modalInfo.id +
            "')\"></div>";
          modalHTML += '<div class="ModalTemplateWasd__Card">';
          modalHTML +=
            '<button class="ModalTemplateWasd__CloseButton" onclick="window.common.closeModalTemplateWasd(\'' +
            modalInfo.id +
            "')\">";
          modalHTML += '<i class="fa fa-times-circle"></i>';
          modalHTML += "</button>";
          modalHTML += '<div class="ModalTemplateWasd__Header">';
          modalHTML += "<h2>" + modalInfo.headerTxt + "</h2>";
          modalHTML += "</div>";
          modalHTML += '<div class="ModalTemplateWasd__Body">';
          modalHTML += "<p>" + modalInfo.bodyTxt + "</p>";
          modalHTML += "</div>";
          modalHTML += "</div>";
          modalHTML += "</div>";
          $("body").append(modalHTML);
          $(".ModalTemplateWasd__WrapperOverlay").css("display", "block");
          $(".ModalTemplateWasd__WrapperOverlay").css("zindex", "10001");
        };
        
        var createReactModalContainer = function () {
          var modalContainerId = "GamersClubCSApp-modals";
          var container = document.getElementById(modalContainerId);
        
          if (!container) {
            var elementContainer = document.createElement("div");
        
            elementContainer.id = modalContainerId;
        
            document.body.appendChild(elementContainer);
          }
        
          return modalContainerId;
        };
        
        var closeModalTemplateWasd = function (modalID) {
          $("#" + modalID).remove();
        };
        
        var customUrlShareModal = function (modalName, customUrl, slug) {
          window.reactFunctions.addWidget({
            name: "coins",
            hideLoading: true,
            props: {
              openModalProps: {
                name: modalName,
                props: {
                  customUrl: customUrl,
                  slug: slug,
                },
              },
            },
          });
        };
        
        var updateTeamInviteLink = function (data) {
          var shareLinkInput = document.getElementById("share-link-input");
        
          if (!shareLinkInput) {
            return;
          }
        
          shareLinkInput.value = data.join_link;
        };
        
        function utf8ToBase64(str) {
          return window.btoa(unescape(encodeURIComponent(str)));
        }
        
        function base64ToUtf8(str) {
          return decodeURIComponent(escape(window.atob(str)));
        }
        
        /**
         * Send custom events to SNS Queue and Google Analytics
         */
        var trackEvents = function (eventAttributes) {
          var playerId =
            window.PLAYERID || (window.currentUser && window.currentUser.id)
              ? window.currentUser.id
              : "";
        
          var gaEventPayload = {
            action: eventAttributes.action,
            label: eventAttributes.label,
            category: eventAttributes.category,
          };
        
          var snsEventPayload = {
            eventAction: eventAttributes.action,
            eventLabel: eventAttributes.label,
            eventName: eventAttributes.category,
            playerId: playerId,
            sentAt: new Date().toISOString(),
          };
        
          sendGAEventWithMetadata(gaEventPayload);
          sendSnsTrackingEvent(snsEventPayload);
        };
        
        window.common = {
          addFriend: addFriend, // deprecated
          undoFriendship: undoFriendship, // deprecated
          sendFriendshipRequest: sendFriendshipRequest,
          removeFriend: removeFriend,
          openGamersClubExclusivesModal: openGamersClubExclusivesModal,
          modal: {
            abrirModal: function (
              target,
              ajaxUrl,
              ajaxTarget,
              cached,
              callback,
              postData,
              isBelowMenu
            ) {
              if (
                target === "modal-play-now" &&
                ExposedGamersClubApp &&
                ExposedGamersClubApp.openPlayModal
              ) {
                ExposedGamersClubApp.openPlayModal();
                return false;
              }
              $(".modal").hide();
              if (cached === false) {
                $("#" + target).html("");
              }
              var isTargetEmpty = !$.trim($("#" + target).html());
              var isRemoteModal = ajaxUrl != undefined && ajaxTarget != undefined;
        
              if (isTargetEmpty && isRemoteModal) {
                if (typeof postData !== "undefined") {
                  this.abrirModalPost(target, ajaxUrl, ajaxTarget, postData);
                } else {
                  this.abrirModalGet(target, ajaxUrl, ajaxTarget, callback);
                }
              } else {
                openModal(target);
              }
        
              if (isBelowMenu) {
                $(".overlay").addClass("zindex49");
              }
            },
            abrirModalPost: function (target, ajaxUrl, ajaxTarget, postData, callback) {
              $.post(ajaxUrl, { postData: postData }, function (data) {
                $(ajaxTarget).html(data);
                openModal(target);
                if (typeof callback === "function") callback();
              });
            },
            abrirModalGet: function (target, ajaxUrl, ajaxTarget, callback) {
              if ($(ajaxTarget).length == 0) {
                console.error('ajaxTarget target "', ajaxTarget, "\" doesn't exist");
              }
        
              $(ajaxTarget).load(ajaxUrl, function (response, status, xhr) {
                if (typeof callback === "function") callback();
                openModal(target);
              });
            },
            openContractPlayNow: function (rankedId) {
              verifyForInstability(function () {
                openRankedModal(rankedId);
              });
            },
          },
          bindToolTipsToContainer: bindToolTipsToContainer,
          bindToolTips: bindToolTips,
          postcodeSearch: postcodeSearch,
          maskPaymentData: maskPaymentData,
          fazerCheckin: fazerCheckin,
          unlinkDiscord: unlinkDiscord,
          mensagens: {
            marcarComoLidas: function () {
              $.ajax({
                type: "post",
                url: "/mensagens",
                data: { marcarLido: 1 },
                success: function (msg) {
                  if (msg == "ok") {
                    $("li.mensagem").addClass("lida");
                  }
                },
                error: function (erro) {
                  alert("Ocorreu um erro, tente novamente.");
                },
              });
            },
          },
          isLogged: isLogged,
          showLoginNotification: loginNotification,
          coinsBuyProduct: coinsBuyProduct,
          productRulesModal: productRulesModal,
          coinsCtaProduct: coinsCtaProduct,
          coinsNotifyReward: coinsNotifyReward,
          openPunishmentModal: openPunishmentModal,
          openInfractionPenaltyModal: openInfractionPenaltyModal,
          openModalTemplateWasd: openModalTemplateWasd,
          closeModalTemplateWasd: closeModalTemplateWasd,
          customUrlShareModal: customUrlShareModal,
          vaultContentsModal: vaultContentsModal,
          getModalHeight: getModalHeight,
          utf8ToBase64: utf8ToBase64,
          base64ToUtf8: base64ToUtf8,
          trackEvents: trackEvents,
        };
        
        /* Create a event listener to open Match Modal */
        window.reactFunctions.createCustomEventListener("openMatchModal", function () {
          window.reactFunctions.openMatchModal();
        });
        
        /* Create a event listener to open Infraction Penalty Modal */
        window.reactFunctions.createCustomEventListener(
          "canNotUseLobbyDueToBan",
          function () {
            openInfractionPenaltyModal();
          }
        );
        
        // Retorna os convites caso não esteja na página de lobby
        /* if (typeof lobby == 'undefined') {
            createLobbyInvite();
        } */
        
        /**
         * Dropdown (Design Agnostic)
         */
        (function ($) {
          $.fn.GC_Dropdown = function () {
            var toggle = this.find(".js-DropdownToggle");
            var window = this.find(".js-DropdownWindow");
        
            var css = {
              active: "is-active",
            };
        
            toggle.click(function () {
              var $this = $(this);
              var $thisDropdown = $($this.data("dropdown"));
        
              if (toggle.hasClass(css.active) && !$this.hasClass(css.active)) {
                toggle.removeClass(css.active);
              }
        
              if (window.hasClass(css.active) && !$thisDropdown.hasClass(css.active)) {
                window.removeClass(css.active);
              }
        
              $this.toggleClass(css.active);
              $thisDropdown.toggleClass(css.active);
            });
        
            $(document).click(function (event) {
              if (!$(event.target).closest(".interaction-item").length) {
                toggle.removeClass(css.active);
                window.removeClass(css.active);
              }
            });
          };
        
          $(".js-Dropdown").GC_Dropdown();
        })(jQuery);
        
        /**
         * Tabs (Design Agnostic)
         */
        (function ($) {
          $.fn.GC_TabNav = function () {
            var tabItem = this.find(".js-TabItem");
            var tabContent = this.find(".js-TabContent");
        
            var css = {
              active: "is-active",
            };
        
            if (!tabItem.hasClass(css.active)) {
              tabItem.first().addClass(css.active);
            }
        
            if (!tabContent.hasClass(css.active)) {
              tabContent.first().addClass(css.active);
            }
        
            tabItem.click(function (event) {
              event.preventDefault();
        
              var $this = $(this);
              var $content = $('[data-content="' + $this.data("tab") + '"]');
        
              if (!$this.hasClass(css.active) && tabItem.hasClass(css.active)) {
                tabItem.removeClass(css.active);
              }
        
              if (!$content.hasClass(css.active) && tabContent.hasClass(css.active)) {
                tabContent.removeClass(css.active);
              }
        
              if (!$this.hasClass(css.active)) {
                $this.addClass(css.active);
              }
        
              if (!$content.hasClass(css.active)) {
                $content.addClass(css.active);
              }
            });
          };
        
          $(".js-TabNav").GC_TabNav();
        })(jQuery);
        
        /**
         * Custom Scrollbar
         */
        (function ($) {
          var el = $("[data-custom-scroll]");
          var height = el.data("custom-scroll-height");
        
          el.mCustomScrollbar({
            setHeight: height || 300,
            scrollInertia: 0,
          });
        })(jQuery);
        
        /**
         * Apply 'top' attribute to modals based on navbars displayed onscreen
         */
        function getModalHeight() {
          var globalNavbarElementHeight = document.getElementById("navbar-placeholder")
            ? document.getElementById("navbar-placeholder").offsetHeight
            : 0;
          var subscriptionStatusBarheight = document.getElementById(
            "subscription-status-topbar"
          )
            ? document.getElementById("subscription-status-topbar").offsetHeight
            : 0;
          var gcNavbarElementHeight = document.querySelector(".MainHeader")
            ? document.querySelector(".MainHeader").offsetHeight
            : 0;
          return (
            gcNavbarElementHeight +
            globalNavbarElementHeight +
            subscriptionStatusBarheight
          );
        }
        
        window.sendProfileRankingSnsTrackingEvent = function (playerId) {
          const eventPayload = {
            eventName: "leaderboard",
            eventAction: "click",
            eventLabel: "Click Leaderboard Position in Profile",
            sentAt: new Date().toISOString(),
            playerId: playerId,
          };
        
          $.ajax({
            url: "/api/track-event/register",
            type: "POST",
            data: JSON.stringify(eventPayload),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
          });
        };
        
        /**
         * Handle friendships
         */
        
        function sendFriendshipRequest(gcId) {
          disableAllFriendActions();
          $("#gcProfileSidebarActions .js-gc-friend-waiting").addClass("active");
        
          $.ajax({
            url: "/api/friendship/invites/" + gcId,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
          });
        };
        
        function removeFriend(gcId) {
          if (!confirm("Deseja realmente desfazer a amizade?")) {
            return false;
          }
        
          disableAllFriendActions();
          $("#gcProfileSidebarActions .js-gc-friend-add").addClass("active");
          
          $.ajax({
            url: "/api/friendship/friends/" + gcId,
            type: "DELETE",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
          });
        };
        
        /**
         * Ações nos filtros dos servidores casuais
         */
        
        //ABRE O SELECT BASEADO NO TARGET DEFINIDO NO data-target
        $('body').on('click','.filtro-select', function(){
          var target = $(this).data("target");
          $(".filtro-select-options[data-filtro=" + target + "]").show();
          $(".overlay-casuais").addClass("show");
        });
        
        //AÇÕES EXECUTADAS QUANDO UMA OPÇÃO É ESCOLHIDA
        $('body').on('click','.filtro-select-option', function(){
          var option = $(this).data("option"); //VALOR DA OPÇÃO
          var origin = $(this).closest(".filtro-select-options").data("filtro"); //INPUT ORIGINAL DE ESCOLHA
        
          $(".filtro-select[data-target=" + origin + "] span").text(option); //ADICIONA O VALOR DA OPÇÃO AO INPUT ORIGINAL DE ESCOLHA
          $(this).closest(".filtro-select-options").hide(); //ESCONDE O SELECT
          $(".overlay-casuais").removeClass("show"); //ESCONDE O OVERLAY
        
          $(".filtro-select-options[data-filtro=" + origin + "] .selected").removeClass("selected"); //REMOVE CLASSES DE OUTRAS OPÇÕES SELECIONADAS
          $(this).addClass("selected"); //ADICIONA CLASSE PARA A OPÇÃO SELECIONADA
        });
        
        //CÓDIGO PARA FECHAR OS SELECTS QUANDO CLICADO FORA
        $(document).mouseup(function(e) {
            var container = $(".filtro-select-options");
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                container.hide();
                $(".overlay-casuais").removeClass("show");
            }
        });
        
        //AÇÕES EXECUTADAS NO INLINE-SELECT
        $('body').on('click','.filtro-inline-select span', function(){
          var value = $(this).data("value");
          $(".filtro-inline-select span").removeClass("selected");
          $(this).addClass("selected");
        
        });
      }
    },
    // Home page
    home: {
      init: function () {
        // $('.panel-live-matches').perfectScrollbar({});
        
        $('#main-slider').slick({
          arrows: true,
          dots: true,
          autoplay: true,
          autoplaySpeed: 5000,
          responsive: [
          {
            breakpoint: 1024,
            settings: {
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              dots: false,
              infinite: true,
              arrows: false
            }
          }
          ],
        });
        
        var sliderVideos = document.getElementsByClassName('sliderVideo');
        
        for (var i = 0; i < sliderVideos.length; i++) {
          sliderVideos[i].play();
        }
        
        $('#featured-matches').slick({
          arrows: true,
          dots: true,
          autoplay: true,
          autoplaySpeed: 400000,
          responsive: [
          {
            breakpoint: 1024,
            settings: {
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              dots: false,
              infinite: true,
              arrows: false
            }
          }
          ],
        });
        
      }
    },
    // gerenciamento
    gerenciamento: {
      init: function () {
        // remocao de amigos
        $('.remover-amigo').on('click', function () {
          self = this;
          amigoId = $(this).data('amigo-id');
        
          if (confirm('Gostaria de desfazer amizade com o jogador?')) {
            $.ajax({
              url: '/api/friendship/friends/' + amigoId,
              type: 'DELETE',
              contentType: 'application/json; charset=utf-8',
              dataType: 'json'
            });
        
            this.closest('tr').remove();
          }
        });
        
      }
    },
    // perfil do time
    profileTeam: {
      init: function () {
        function joinTeamByPassword() {
          common.modal.abrirModal('modal-join-clan');
        }
        
        window.profileTeam = {
          joinTeamByPassword: joinTeamByPassword
        };
        
      }
    },
    // form de edicao de clan
    editarClan: {
      init: function () {
        $('#excluir-clan').on('click', function () {
          if (confirm(REMOVE_TEAM_CONFIRM_TEXT)) {
            var id = $(this).data('id');
        
            $.ajax({
              type: 'post',
              url: '/time/' + id + '/excluirClan',
              success: function (msg) {
                if (msg == 'Ok') {
                  window.location.href = '/account/settings';
                } else {
                  alert(msg);
                }
              },
              error: function (erro) {
                alert('error, try again.');
              }
            });
        
          }
        });
        
      }
    },
    // gerenciar membros do clan
    gerenciarMembros: {
      init: function () {
        $('[data-toggle]').on('click', function(e) {
          e.preventDefault();
          $('[data-type]').addClass('hidden'); // esconde todos
          $('[data-toggle-parent]').removeClass('hidden');
          type = $(this).data('toggle-type'); // busca o tipo
        
          // busca tr pelo type
          memberId = $(this).data('toggle');
          row = $('[data-membro-id=' + memberId + '][data-type='+ type +']');
        
          // toggle
          $(row).toggleClass('hidden');
          if ($(row).is(':visible')) {
            if (type == 'kick') $('input[name=sMotivo]').focus();
            $('[data-toggle-parent=' + memberId + ']').addClass('hidden');
          } else {
            $('[data-toggle-parent=' + memberId + ']').removeClass('hidden');
          }
        });
        
        $('.cancel').on('click', function(e) {
          e.preventDefault();
          $('[data-type]').addClass('hidden'); // esconde todos
          $('[data-toggle-parent]').removeClass('hidden');
        });
        
        $('.gerenciar-membros a.opcao').on('click', function(e) {
          e.preventDefault();
          var posicao = $(this).data('posicao'),
          id = $(this).data('id'),
          playerId = $(this).data('player-id');
        
          if (!confirm(PROMOTE_PLAYER_TEXT)) return false;
        
          $.ajax({
            type: 'post',
            url: '/times/posicoes',
            data: { clanId: id, playerId: playerId, posicao: posicao },
            success: function(data) {
              notice(data.message);
              location.reload(true);
            },
            error: function(data){
              alert(data.message);
            }
          });
        
        });
        
      }
    },
    teamManagement: {
      init: function () {
        var GCV1_ASSETS_URL = 'https://gcv1-assets.gamersclub.com.br/';
        
        $(function () {
          var inviteTeamSelectElement = $('#invite-team');
          var config = {
            placeholder: inviteTeamSelectElement.attr('data-placeholder'),
            width: '100%',
            multiple: true,
            minimumResultsForSearch: -1
          };
        
          if (typeof teamManagement.invitationsAvailable !== 'undefined') {
            config.maximumSelectionLength = teamManagement.invitationsAvailable;
          }
        
          var selectFriends = inviteTeamSelectElement.select2(config);
        
          selectFriends.on('select2:open', function () {
            // Verify if the data was loaded
            if (this.dataset.wasLoaded) {
              return false;
            }
        
        
            $.ajax({
              url: '/api/friends/team-invitation/' + teamManagement.teamId,
              method: 'GET'
            })
              .done(function (data) {
                selectFriends.innerHTML = '';
                // create the option and append to Select2
                data.map(function (item) {
                  var option = new Option(item.PNick, item.PID, false, false);
                  selectFriends.append(option).trigger('change');
                });
                selectFriends.select2('close').select2('open');
                // Set data as loaded
                this.dataset.wasLoaded = true;
              }.bind(this))
              .fail(function (e) {
                this.dataset.wasLoaded = false;
              }.bind(this));
        
            // Set data as loaded
            this.dataset.wasLoaded = true;
          });
        
          $('#TeamInviteFriends').click(function (e) {
            var teamToInvite = $('#invite-team').val();
        
            if (!teamToInvite || teamToInvite.length < 1) {
              return false;
            }
        
            $.ajax({
              url: '/api/friends/team-invitation',
              method: 'post',
              data: { team: teamManagement.teamId, players: teamToInvite },
              success: function () {
                window.location.reload();
              },
              error: function (data) {
                if (data && data.responseJSON && data.responseJSON.message) {
                  window.warning(data.responseJSON.message);
                } else {
                  window.warning('Falha ao convidar');
                }
              }
            });
          });
        
          function toggleTeamPasswordVisibility() {
            var passwordInput = document.getElementById('password');
            var toggleIcon = document.getElementById('visibility-icon');
        
            var showPasswordIconPath = GCV1_ASSETS_URL + 'assets/images/tournament/eye.svg';
            var hidePasswordIconPath = GCV1_ASSETS_URL + 'assets/images/tournament/block-eye.svg';
        
            passwordInput.type = passwordInput.type === 'text' ? 'password' : 'text';
            toggleIcon.src = toggleIcon.src.includes(showPasswordIconPath)
              ? hidePasswordIconPath
              : showPasswordIconPath;
          }
        
          $('#toggle-visibility').click(function () {
            toggleTeamPasswordVisibility();
          });
        
          function copyHiddenInputToClipboard() {
            var shareLinkInput = document.getElementById('share-link-input');
        
            if (!shareLinkInput) {
              return;
            }
        
            navigator.clipboard.writeText(shareLinkInput.value).then(function () {
              $(document).find('.tooltipGC__messageContainer').removeClass('tooltipGC__messageContainer--hidden');
        
              setTimeout(function () {
                $(document).find('.tooltipGC__messageContainer').addClass('tooltipGC__messageContainer--hidden');
              }, 1000);
            }, function (error) {
              console.error('Failed to copy text: ', error);
            });
          }
        
          $('#copy-link-button').click(function () {
            copyHiddenInputToClipboard();
          });
        });
        
        
        window.teamManagement = {
          teamId: null,
          vacancyListTemplate: null,
          vacancyTemplate: null,
          candidatesTemplate: null,
          skillLevelsTemplate: null,
          modalRemoveVacancyTemplate: null,
          modalVacancyCandidateActionTemplate: null,
          roleSelect2Options: null,
          levelMaxRange: 4,
          invitationsAvailable: 0,
        
          initTabs: function () {
            teamManagement.teamId = $('#teamId').val();
            teamManagement.roleSelect2Options = {
              placeholder: 'Selecione uma função',
              width: '100%',
              tags: false,
              multiple: false,
              templateResult: teamManagement.roleTemplateResult,
              templateSelection: teamManagement.roleTemplateSelecion,
              minimumResultsForSearch: -1
            };
        
            teamManagement.initProfileClanTab();
            teamManagement.initMembersTab();
            teamManagement.initVacanciesTab();
          },
        
          initProfileClanTab: function () {
            $('#formProfileClan').on('submit', function () {
              $(document).ajaxComplete(function (event, jqxhr, settings) {
                if (jqxhr.status == 201) {
                  window.location.href = jqxhr.responseJSON.data.redirect_to;
                }
        
                $(event.currentTarget).unbind('ajaxComplete');
              });
            });
        
            var simplemde = new SimpleMDE({
              element: $('.descricao-time')[0],
              toolbar: ['heading-bigger', 'heading-smaller', '|', 'bold', 'italic', 'strikethrough', 'quote', '|', 'unordered-list', 'ordered-list', 'horizontal-rule', '|', 'link', 'image', 'preview'],
              status: false
            });
          },
        
          initMembersTab: function () {
            $(document).on('submit', '.kick-player-form', function (e) {
              e.preventDefault();
              e.stopPropagation();
              var url = $(this).prop('action');
              $.ajax({
                type: 'POST',
                url: url,
                data: $('.kick-player-form').serialize(),
                success: function (data) {
                  $('#modal-kick-player .close-button').trigger('click');
                  var playerId = '#membro-' + $('#kickMembroId').val();
                  $(playerId).fadeOut('slow');
                  notice(data.message);
                },
                error: function (jqxhr, textStatus, error) {
                  var data = jqxhr.responseJSON;
                  alert(data.message);
                }
              });
            });
        
            $(document).on('change', '.staff-role', function (e) {
              var $el = $(this).parent().parent().find('td .gaming-role');
              $el.prop('disabled', false);
              $el.select2('destroy');
              $el.select2(teamManagement.roleSelect2Options);
            });
        
            $('.gaming-role').select2(teamManagement.roleSelect2Options);
          },
        
          // monta span select2
          roleTemplateResult: function (data) {
            if (data.id && data.id != 0) {
              return $('<label><img class="select2-role-icon" src="' + GCV1_ASSETS_URL + 'assets/images/gaming_roles/icon-' + data.text + '.svg" width="30" /><span class="select2-option select2-role-label">' + roles_translation[data.text].label + '</span></label>');
            }
        
            return $('<span class="select2-option select2-role-empty-option">' + data.text + '</span>');
          },
        
          roleTemplateSelecion: function (data) {
            if (data.id && data.id != 0) {
              return $('<span class="select2-option"><img src="' + GCV1_ASSETS_URL + 'assets/images/gaming_roles/icon-' + data.text + '.svg" width="25" />' + roles_translation[data.text].label + '</span>');
            }
        
            var id = $(data.element).parent().prop('id');
            if ($(data.element).parent().prop('disabled') && id != 'primaryRole' && id != 'secondaryRole' && id != 'tertiaryRole') {
              return $('<span class="select2-option"><img src="' + GCV1_ASSETS_URL + 'assets/images/gaming_roles/icon-coach.svg" width="25" />' + roles_translation.coach.label + '</span>');
            }
        
            return $('<span class="select2-option">' + data.text + '</span>');
          },
        
          getVacancies: function () {
            var url = '/time/' + teamManagement.teamId + '/vagas';
        
            $.getJSON(url, function (response) {
              response.hasVacancies = response.data.length > 0;
              $.each(response.data, function (i, row) {
                row.hasCandidates = row.total_enrolled > 0;
                row.uniqueLevel = row.gc_level_min == row.gc_level_max;
                row.uniqueAge = row.age_min == row.age_max;
        
                $.each(row.roles, function (i, role) {
                  role.label = roles_translation[role.role].label;
                });
              });
        
              $('.vacancies-list-container').html(Mustache.render(teamManagement.vacancyListTemplate, response));
            });
          },
        
          getVacancy: function (vacancyId) {
            var url = '/time/' + teamManagement.teamId + '/vagas/' + vacancyId;
        
            $.getJSON(url, function (response) {
              $('#vacancy-form-container').html(Mustache.render(teamManagement.vacancyTemplate, response.data, { teamId: teamManagement.teamId }));
              $.each(response.data.roles, function (key, value) {
                $('.vacancy-role option[value=' + value.role_id + ']').eq(key).attr('selected', true);
              });
              if (response.data.country) {
                $('.vacancy-country option[value=' + response.data.country + ']').attr('selected', true);
              }
              teamManagement.initVacancyForm();
            });
          },
        
          getCandidates: function (vacancyId) {
            $('.row.panel-content.vacancies:not([data-vacancy-id=' + vacancyId + '])').hide();
        
            var url = '/time/' + teamManagement.teamId + '/vagas/' + vacancyId + '/candidatos';
            var result = [];
        
            $.getJSON(url, function (response) {
              for (var key in response.data) {
                $.each(response.data[key], function (i, row) {
                  row['isLevel' + row.level] = true;
                  row.approved = row.status == 2;
                  $.each(row.roles, function (i, role) {
                    role.label = roles_translation[role.role].label;
                  });
                  result.push(row);
                });
              }
              response.data = result;
        
              if (response.data.length > 0) {
                $('.candidate').html(Mustache.render(teamManagement.candidatesTemplate, response, { skillLevelsTemplate: teamManagement.skillLevelsTemplate }));
                $('#vacancy-candidates').attr('data-vacancy-id', vacancyId);
                $('#vacancy-candidates').show();
              } else {
                teamManagement.getVacancies();
                $('#vacancy-candidates').hide();
              }
            });
          },
        
          initVacanciesTab: function () {
            $('#vacancy-form-container').hide();
            $('#vacancy-candidates').hide();
        
            teamManagement.vacanciesTabBinds();
            teamManagement.parseTemplates();
            teamManagement.getVacancies();
        
            $(document).on('change', '#primaryRole, #secondaryRole, #tertiaryRole', function (e) {
              teamManagement.roleChanged(this);
            });
          },
        
          roleChanged: function (el) {
            var arr = $('select[name="roles[]"]').find(':selected');
            $('select[name="roles[]"]').find('option').removeAttr('disabled');
            $.each($('select[name="roles[]"]'), function () {
              var self = this;
              var selectVal = $(this).val();
              $.each(arr, function () {
                if (selectVal !== $(this).val() && $(this).val() != 0) {
                  $(self).find('option[value="' + $(this).val() + '"]').attr('disabled', true);
                } else {
                  $(self).find('option[value="' + $(this).val() + '"]').removeAttr('disabled');
                }
              });
            });
        
            var reInit;
            if (el.id == 'primaryRole') {
              if (el.value && el.value != 0) {
                $('#secondaryRole').prop('disabled', false);
              } else {
                $('#secondaryRole').val(0);
                $('#tertiaryRole').val(0);
                $('#secondaryRole, #tertiaryRole').prop('disabled', true);
              }
              reInit = '#secondaryRole, #tertiaryRole';
            } else if (el.id == 'secondaryRole') {
              if (el.value && el.value != 0) {
                $('#tertiaryRole').prop('disabled', false);
              } else {
                $('#tertiaryRole').val(0);
                $('#tertiaryRole').prop('disabled', true);
              }
              reInit = '#primaryRole, #tertiaryRole';
            } else {
              reInit = '#primaryRole, #secondaryRole';
            }
            $(reInit).select2('destroy');
            $(reInit).select2(teamManagement.roleSelect2Options);
          },
        
          validateRoles: function () {
            if ($('#primaryRole').val() == 0) {
              $('#primaryRole').addClass('invalid');
            } else {
              $('#primaryRole').removeClass('invalid');
            }
        
            if ($('#secondaryRole').val() == 0) {
              $('#secondaryRole').addClass('invalid');
            } else {
              $('#secondaryRole').removeClass('invalid');
            }
        
            if ($('#tertiaryRole').val() == 0) {
              $('#tertiaryRole').addClass('invalid');
            } else {
              $('#tertiaryRole').removeClass('invalid');
            }
          },
        
          vacanciesTabBinds: function () {
            // botao adicionar vaga
            $(document).on('click', '#new-vacancy', function (e) {
              e.preventDefault();
              e.stopPropagation();
        
              var halfRange = teamManagement.levelMaxRange / 2;
              var minLevel = window.PLAYER_LEVEL - halfRange;
        
              if (window.PLAYER_LEVEL <= halfRange) {
                minLevel = 1;
              }
        
              if (minLevel > 16) {
                minLevel = 16;
              }
        
              var maxLevel = minLevel + teamManagement.levelMaxRange;
        
              $('#vacancy-form-container').html(Mustache.render(teamManagement.vacancyTemplate, {
                teamId: teamManagement.teamId,
                id: 0,
                age_min: 13,
                age_max: 60,
                gc_level_min: minLevel,
                gc_level_max: maxLevel,
                observations: ''
              }));
        
              teamManagement.initVacancyForm();
            });
        
            // link candidatos
            $(document).on('click', '.toggle-candidates', function (e) {
              e.preventDefault();
              e.stopPropagation();
              teamManagement.getCandidates($(this).data('vacancy-id'));
            });
        
            // botao remover vaga
            $(document).on('click', '.remove-vacancy', function (e) {
              e.preventDefault();
              e.stopPropagation();
        
              $('#container-modal-remove-vacancy').html(Mustache.render(teamManagement.modalRemoveVacancyTemplate, {
                vacancyId: $(this).data('vacancy-id'),
                teamId: teamManagement.teamId
              }));
              common.modal.abrirModal('modal-vacancy-remove');
            });
        
            // modal remover vaga
            $(document).on('submit', '.remove-vacancy-form', function (e) {
              e.preventDefault();
              e.stopPropagation();
              var url = $(this).prop('action');
              $.ajax({
                type: 'POST',
                url: url,
                success: function (data) {
                  // closes modal
                  $('#modal-vacancy-remove .close-button').trigger('click');
                  // remove vacancy from page
                  $('.row.panel-content.vacancies[data-vacancy-id=' + $('#vacancyId').val() + ']').remove();
                  $('#vacancy-candidates[data-vacancy-id=' + $('#vacancyId').val() + ']').remove();
                  $('.row.panel-content.vacancies:not([data-vacancy-id=' + $('#vacancyId').val() + '])').show();
                  if ($('.row.panel-content.vacancies').size() == 0) {
                    teamManagement.getVacancies();
                  }
        
                  notice(data.message);
                },
                error: function (jqxhr, textStatus, error) {
                  var data = jqxhr.responseJSON;
                  alert(data.message);
                }
              });
            });
        
            // botao atualizar vaga
            $(document).on('click', '.update-vacancy', function (e) {
              e.preventDefault();
              e.stopPropagation();
        
              teamManagement.getVacancy($(this).data('vacancy-id'));
            });
        
            // botao esconder candidatos
            $(document).on('click', '#hide-candidates', function (e) {
              e.preventDefault();
              e.stopPropagation();
        
              $('#vacancy-candidates').hide();
              $('.vacancies-list-container').hide();
              teamManagement.getVacancies();
              $('.vacancies-list-container').show();
            });
        
            // botao voltar (adicionar/atualizar vaga)
            $(document).on('click', '.return-vacancies', function (e) {
              e.preventDefault();
              e.stopPropagation();
              $('#vacancy-form-container').hide();
              teamManagement.getVacancies();
              $('#vacancies-list').show();
            });
        
            // submit adicionar/alterar vaga
            $(document).on('submit', '#vacancy-form', function (e) {
              e.preventDefault();
              e.stopPropagation();
              var url = '/time/' + teamManagement.teamId + '/vagas';
              if ($('#vacancy-form #vacancyId').val() != 0) {
                url += '/' + $('#vacancy-form #vacancyId').val();
              }
        
              teamManagement.validateRoles();
        
              $.ajax({
                type: 'POST',
                url: url,
                data: $('#vacancy-form :not(.invalid)').serialize(),
                success: function (data) {
                  notice(data.message);
                  $('#vacancy-form-container').hide();
                  teamManagement.getVacancies();
                  $('#vacancies-list').show();
                },
                error: function (jqxhr, textStatus, error) {
                  var data = jqxhr.responseJSON;
                  alert(data.message);
                }
              });
            });
        
            // botao acoes vaga
            $(document).on('click', '.btn-candidate-actions', function (e) {
              e.preventDefault();
              e.stopPropagation();
              $('#container-modal-vacancy-candidate').html(Mustache.render(teamManagement.modalVacancyCandidateActionTemplate, {
                teamId: teamManagement.teamId,
                vacancyId: $('#vacancy-candidates').data('vacancy-id'),
                candidateId: $(this).data('candidate-id'),
                nick: $(this).data('candidate-nick'),
                approved: $(this).data('candidate-approved'),
                message: $(this).data('candidate-message')
              }));
              common.modal.abrirModal('modal-vacancy-candidate-action');
            });
        
            // botao aprovar/reprovar vaga
            $(document).on('click', '.btn-candidate-action', function (e) {
              e.preventDefault();
              e.stopPropagation();
              var candidateId = $(this).data('candidate-id');
              var vacancyId = $(this).data('vacancy-id');
              var url = '/time/' + teamManagement.teamId + '/vagas/' + vacancyId + '/candidatos/' + candidateId + '/' + $(this).data('action');
              $.ajax({
                type: 'POST',
                url: url,
                success: function (data) {
                  $('#modal-vacancy-candidate-action .close-button').trigger('click');
                  teamManagement.getCandidates(vacancyId);
                  notice(data.message);
                },
                error: function (jqxhr, textStatus, error) {
                  var data = jqxhr.responseJSON;
                  alert(data.message);
                }
              });
            });
          },
        
          initVacancyForm: function () {
            $('#vacancies-list').hide();
            $('#vacancy-candidates').hide();
            $('#vacancy-form-container').show();
        
            // Add Age Slider
            teamManagement.initSlider('Age', [13, 60], 1);
            // Add GC Level Slider
            teamManagement.initSlider('Level', [1, 21], 1, teamManagement.levelMaxRange);
        
            $('.vacancy-role').select2(teamManagement.roleSelect2Options);
        
            if ($('#primaryRole').val() == 0) {
              $('#secondaryRole, #tertiaryRole').prop('disabled', true);
            } else {
              $('#secondaryRole option[value=' + $('#primaryRole').val() + ']').attr('disabled', true);
              $('#tertiaryRole option[value=' + $('#primaryRole').val() + ']').attr('disabled', true);
            }
        
            if ($('#secondaryRole').val() == 0) {
              $('#tertiaryRole').prop('disabled', true);
            } else {
              $('#primaryRole option[value=' + $('#secondaryRole').val() + ']').attr('disabled', true);
              $('#tertiaryRole option[value=' + $('#secondaryRole').val() + ']').attr('disabled', true);
            }
        
            if ($('#tertiaryRole').val() != 0) {
              $('#primaryRole option[value=' + $('#tertiaryRole').val() + ']').attr('disabled', true);
              $('#secondaryRole option[value=' + $('#tertiaryRole').val() + ']').attr('disabled', true);
            }
          },
        
          initSlider: function (field, values, step, maxRange) {
            var el = $('#sliderRange' + field);
            var minInput = $('#sliderRange' + field + 'MinInput');
            var maxInput = $('#sliderRange' + field + 'MaxInput');
            var labelName = '#label' + field;
        
            el.slider({
              range: true,
              min: values[0],
              max: values[1],
              step: step,
              values: [minInput.val(), maxInput.val()],
              slide: function (e, ui) {
                var maxRange = $(this).slider('option', 'maxRange');
                var leftValue = ui.values[0];
                var rightValue = ui.values[1];
                if (maxRange && (rightValue - leftValue) > maxRange) {
                  if (leftValue != minInput.val()) {
                    rightValue = leftValue + maxRange;
                    maxInput.val(rightValue);
                    $(this).slider('values', 1, rightValue);
                  } else if (rightValue != maxInput.val()) {
                    leftValue = rightValue - maxRange;
                    minInput.val(leftValue);
                    $(this).slider('values', 0, leftValue);
                  }
                }
                teamManagement.sliderRangeUpdateLabel(labelName, leftValue, rightValue);
              },
              change: function (e, ui) {
                minInput.val(ui.values[0]);
                maxInput.val(ui.values[1]);
                teamManagement.sliderRangeUpdateLabel(labelName, minInput.val(), maxInput.val());
              },
              create: function (e, ui) {
                teamManagement.sliderRangeUpdateLabel(labelName, minInput.val(), maxInput.val());
              }
            });
        
            if (maxRange) {
              $(el).slider('option', 'maxRange', maxRange);
            }
          },
        
          sliderRangeUpdateLabel: function (el, start, end) {
            if (el == '#labelAge' && end == 60) {
              end += '+';
            }
        
            if (el == '#labelLevel') {
              $(el + 'Min').removeClass();
              $(el + 'Min').addClass('badge-level badge-level-' + start);
              $(el + 'Max').removeClass();
              $(el + 'Max').addClass('badge-level badge-level-' + end);
            }
        
            $(el + 'Min').text(start);
            $(el + 'Max').text(end);
          },
        
          parseTemplates: function () {
            teamManagement.vacancyListTemplate = $('#vacancyListTemplate').html();
            teamManagement.vacancyTemplate = $('#vacancyTemplate').html();
            teamManagement.candidatesTemplate = $('#vacancyCandidatesTemplate').html();
            teamManagement.skillLevelsTemplate = $('#skillLevelsTemplate').html();
            teamManagement.modalRemoveVacancyTemplate = $('#vacancyRemoveTemplate').html();
            teamManagement.modalVacancyCandidateActionTemplate = $('#vacancyCandidateActionTemplate').html();
            Mustache.parse(teamManagement.vacancyListTemplate);
            Mustache.parse(teamManagement.vacancyTemplate);
            Mustache.parse(teamManagement.candidatesTemplate);
            Mustache.parse(teamManagement.skillLevelsTemplate);
            Mustache.parse(teamManagement.modalRemoveVacancyTemplate);
            Mustache.parse(teamManagement.modalVacancyCandidateActionTemplate);
          },
        
          removeInvitation: function (invitationId) {
            $.ajax({
              url: '/api/friends/team-invitation/delete',
              method: 'post',
              data: { id: invitationId },
              success: function () {
                window.location.reload();
              },
              error: function (data) {
                if (data && data.responseJSON && data.responseJSON.message) {
                  window.warning(data.responseJSON.message);
                } else {
                  window.warning('Falha ao excluir o convite');
                }
              }
            });
          },
        
          removeAllInvitations: function () {
            var teamId = teamManagement.teamId;
        
            notyConfirm({
              text: '<h3>Remover todos os convites</h3><p>Tem certeza que deseja remover todos os convites enviados?</p>',
              actions: [
                {
                  label: 'REMOVER TODOS',
                  class: 'btn btn-danger',
                  callback: function () {
                    $.ajax({
                      url: '/api/friends/team-invitation/deleteAll',
                      method: 'post',
                      data: { id: teamId },
                      success: function () {
                        window.location.reload();
                      },
                      error: function () {
                        warning('Falha ao excluir os convites');
                      }
                    });
                  }
                },
                {
                  label: 'Cancelar',
                  class: 'btn',
                  callback: function () { }
                }
              ]
            });
          },
        
          toggleInvitations: function () {
            if ($('#TeamInvitations .invitation-item:visible').length > 0) {
              $('#TeamInvitations .invitation-without-item').fadeOut();
            } else {
              $('#TeamInvitations .invitation-without-item').fadeIn();
            }
          }
        };
        
        teamManagement.initTabs();
        
      }
    },
    perfilClan: {
      init: function () {
        // upload de capa
        $('#editarCapa').on('click', function() {
            $("#editarCapaFile").click();
            return false;
        });
        
        $('#editarCapaFile').on('change', function() {
          var formData = new FormData($("#editarCapaForm")[0]);
          var id = $(this).data('id');
        
          $.ajax({
            url: '/conta/times/' + id + '/atualizarCapa',
            type: 'POST',
            data: formData,
            success: function (data) {
              success(data);
              setTimeout(function() {
                location.reload(true);
              }, 1000);
            },
            error: function (data) {
              console.error(data);
              alert("Ocorreu um erro ao atualizar capa. Verifique o tamanho e extensão da imagem!");
            },
            cache: false,
            contentType: false,
            processData: false
          });
        
          return false;
        });
        
        // upload de avatar
        $('#editarAvatar').on('click', function() {
            $("#editarAvatarFile").click();
            return false;
        });
        
        $('#editarAvatarFile').on('change', function() {
          var formData = new FormData($("#editarAvatarForm")[0]);
          var id = $(this).data('id');
        
          $.ajax({
            url: '/conta/times/' + id + '/atualizarAvatar',
            type: 'POST',
            data: formData,
            success: function (data) {
              success(data);
              setTimeout(function() {
                location.reload(true);
              }, 1000);
            },
            error: function (data) {
              console.error(data);
              alert("Ocorreu um erro ao atualizar avatar do time. Verifique a imagem e tente novamente.");
            },
            cache: false,
            contentType: false,
            processData: false
          });
        
          return false;
        });
        
        $('#entrarForm').submit(function(e) {
          e.preventDefault();
          var id = $(this).data('id');
          var frm = $(this).serialize();
        
          $.ajax({
            type: 'post',
            url: '/time/' + id + '/entrar',
            data: frm,
            success: function(msg){
              if (msg == "Ok") {
                location.reload(true);
              } else {
                alert(msg);
              }
            },
            error: function(erro){
              console.error(data);
              alert('error, try again.');
            }
          });
        });
        
        $('#select-campeonato').on('change', function() {
          $('#estatisticas').html('<div class="loader-spin" title="Carregando..."></div>');
        
          $('#estatisticas').html();
          var clanId = $(this).data('clan-id');
          var id = $(this).val();
        
          $.ajax({
            url: '/time/estatisticas/' + clanId + '/' + id,
            type: 'GET',
            success: function(response) {
              // console.log(data);
              // response = data
        
              if (!response.ok || response.game != 'csgo')
                return;
        
              var html = '';
              html =  '<tr>' +
                      ' <td><strong>Jogador</strong></td>' +
                      ' <td><span class="bold" title="Kills">K</span></td>' +
                      ' <td><span class="bold" title="Assists">A</span></td>' +
                      ' <td><span class="bold" title="Deaths">D</span></td>' +
                      ' <td><span class="bold" title="Headshots">HS</span></td>' +
                      ' <td><span class="bold" title="Porcentagem de Headshots">HS%</span></td>' +
                      ' <td><span class="bold" title="Kill/Death Ratio">KDR</span></td>' +
                      ' <td><span class="bold" title="Pontos">P</span></td>' +
                      ' <td><span class="bold" title="Bombas Defusadas">BD</span></td>' +
                      ' <td><span class="bold" title="Bombas Plantadas">BP</span></td>' +
                      ' <td><span class="bold" title="Team Kills">TK</span></td>' +
                      ' <td><span class="bold" title="Rounds com 1 Kill">1K</span></td>' +
                      ' <td><span class="bold" title="Rounds com 2 Kills">2K</span></td>' +
                      ' <td><span class="bold" title="Rounds com 3 Kills">3K</span></td>' +
                      ' <td><span class="bold" title="Rounds com 4 Kills">4K</span></td>' +
                      ' <td><span class="bold" title="Rounds com 5 Kills">5K</span></td>' +
                      ' <td><span class="bold" title="First Kill do Round">FK</span></td>' +
                      ' <td><span class="bold" title="Clutches">1vsX</span></td>' +
                    '</tr>';
        
              $.each(response.estatisticas, function (i, item) {
                html += '<tr><td><a class="bold warning-color" href="/player/' + item.pID + '">' + item.pNick + '</a></td><td>' + item.kills + '</td><td>' + item.assist + '</td><td>' + item.death + '</td><td>' + item.hs + '</td><td>' + item.pcHS + '</td><td>' + item.kdr + '</td><td>' + item.pontos + '</td><td>' + item.defuse + '</td><td>' + item.bomb + '</td><td>' + item.tk + '</td><td>' + item.k1 + '</td><td>' + item.k2 + '</td><td>' + item.k3 + '</td><td>' + item.k4 + '</td><td>' + item.k5 + '</td><td>' + item.fk + '</td><td>' + item.clutchs + '</td></tr>';
              });
              $('#estatisticas').html(html);
            }
          });
        });
        
        /**
         * Função para retornar as inscrições pendentes
         */
        function getPendingSubscriptions (id)
        {
          var el = $(id);
        
          $.get('/times/getTeamsPaymentSituation/' + team_id, function (data) {
            el.html(data);
          });
        }
        
        window.clan_api = {
          getPendingSubscriptions: getPendingSubscriptions,
        }
      }
    },
    // perfil do jogador
    perfil: {
      init: function () {
        $('#playerUrlCopy').click(function () {
          var copyUrl = new Clipboard('#playerUrlCopy');
          var self = this;
          copyUrl.on('success', function (e) {
            alert($(self).data('alert'));
          });
        });
        
        
        /**
         * Lógica e estilo para o banner patrocinado (carregado por script de terceiros)
         */
        $(document).ready(function () {
          if (window.ISSUBSCRIBER) { return; }
        
          var counter = 1;
          var advertisingId = 'hstp_31651_pushdown';
        
          // Utilizando set interval pois o ad é carregado dinamicamente através de um script
          var checkExist = setInterval(function () {
            var divAdvertising = document.getElementById(advertisingId);
        
            if (divAdvertising !== null) {
              $('#' + advertisingId)
                .css({
                  position: 'absolute',
                  top: '118px',
                  'z-index': '10',
                  width: 'calc(100% - 70px)'
                });
        
              clearInterval(checkExist);
            }
        
            // Após 20 segundos de execução, caso o script não tenha carregado o ad, cancela a execução.
            if (counter === 40) { clearInterval(checkExist); }
        
            counter++;
          }, 500);
        });
        
        /**
         * Abas de amigos e visitantes
         */
        $('.tabs-amigos li').click(function () {
          var target = $(this).data('target');
        
          $('.tabs-amigos li').removeClass('active');
          $(this).addClass('active');
        
          $('.lista').hide();
          $('.lista[data-tab=' + target + ']').show();
        });
        
        
        /**
         * Resetar TS action
         */
        $('#resetTS').click(function () {
          url = $('#resetTS').data('url');
          $.ajax({
            type: 'post',
            url: url,
            success: function (msg) {
              if (msg == 'Ok') {
                alert('Resetado com Sucesso!');
                location.reload(true);
              } else {
                alert(msg);
              }
            },
            error: function (erro) { alert('error, try again.'); }
          });
        });
        
        $('#formEmail').submit(function (e) {
          e.preventDefault();
        
          $.ajax({
            type: 'post',
            url: $('#formEmail').prop('action'),
            data: $('#formEmail').serialize(),
            success: function (msg) {
              if (msg == 'Ok') {
                location.reload(true);
              } else {
                alert(msg);
              }
            },
            error: function (erro) { alert('error, try again.'); }
          });
        });
        
        /**
         * Geo Ips
         */
        $('.getPlayersByIP').on('click', function (e) {
          e.preventDefault();
          phId = $(this).data('ph-id');
          ip = $(this).data('ip');
        
          $.getJSON('/players/getPlayersByIP/' + ip, function (data) {
            if (!data) return;
            content = '';
            selector = '#ip-' + phId;
        
            $.each(data, function (key, player) {
              var banido = ''; var
                vac = '';
              if (player.banido == 1) banido = '(conta banida)';
              if (player.plVAC == 1) vac = '(conta com VAC)';
        
              content += '<a href="/player/' + player.plID + '">' + player.plNick + '</a>';
              content += banido + ' ' + vac + '<br/>';
            });
        
            $(selector).empty();
            $(selector).append('<p>').append(content).append('</p>');
          });
        });
        
        $('.getIp').on('click', function (e) {
          e.preventDefault();
          phId = $(this).data('ph-id');
          ip = $(this).data('ip');
        
          $.getJSON('/players/getIPCountry/' + ip, function (data) {
            if (!data) return;
            $('#ip-' + phId).html(data.city + ', ' + data.country);
          });
        });
        
        /**
         * Ativar medalhas
         */
        
        var sendingActivateMedalForm = false;
        $('#formAtivarMedalha').submit(function (e) {
          e.preventDefault();
          self = this;
        
          $(self).find('.error').slideUp('fast');
          $(self).find('.success').slideUp('fast');
          var chave = $(self).find('input[name=chave]').val();
        
          if ($.trim(chave) === '') {
            $(self).find('.error').text(INSERT_KEY);
            $(self).find('.error').slideDown('fast');
            $(self).find('input[name=chave]').focus();
            return;
          }
        
          if (sendingActivateMedalForm) {
            return false;
          }
        
          if (!confirm(KEY_MEDAL_WARNING)) {
            return false;
          }
        
          $.ajax({
            type: 'POST',
            url: $(self).prop('action'),
            data: $(self).serialize(),
            beforeSend: function () {
              $('#formAtivarMedalha').attr('disabled', 'disabled');
              sendingActivateMedalForm = true;
            },
            complete: function () {
              $('#formAtivarMedalha').removeAttr('disabled');
              setTimeout(function () { sendingActivateMedalForm = false; }, 2500);
            },
            success: function (msg) {
              if (msg == 'Ok') {
                result = '<strong><a href="javascript:location.reload(true);">' + CLICK_TO_CONTINUE + '</a></strong>';
                $(self).find('.success').html(MEDAL_SUCCESS + ' ' + result);
                $(self).find('.success').slideDown('fast');
              } else {
                $(self).find('.error').html(msg);
                $(self).find('.error').slideDown('fast');
              }
            },
            error: function (erro) { alert('error, try again.'); }
          });
        });
        
        /**
         * Banir player
         */
        $('#formBanir').submit(function (e) {
          e.preventDefault();
          self = this;
          $(self).find('.error').slideUp('fast');
          $(self).find('.success').slideUp('fast');
        
          var data = $(self).serialize();
          var action = $(self).prop('action');
        
          $.post(action, data, function (data, textStatus, xhr) {
            result = ' <strong><a href="javascript:location.reload(true);">Clique aqui para recarregar a página</a></strong>';
            $(self).find('.success').html('O membro foi banido!' + result);
            $(self).find('.success').slideDown('fast');
            $(self).find('.row').slideUp('fast');
        
            setTimeout(function () {
              location.reload(true);
            }, 2000);
          }).fail(function (data) {
            alert(data.responseJSON.message);
          });
        });
        
        /**
         * Healing
         */
        $('#formHealing').submit(function (e) {
          e.preventDefault();
          self = this;
          $(self).find('.error').slideUp('fast');
          $(self).find('.success').slideUp('fast');
        
          var data = $(self).serialize();
          var action = $(self).prop('action');
        
          $.post(action, data, function (data, textStatus, xhr) {
            result = ' <strong><a href="javascript:location.reload(true);">Clique aqui para recarregar a página</a></strong>';
            $(self).find('.success').html('O healing foi adicionado e estará disponível em breve. ' + result);
            $(self).find('.success').slideDown('fast');
            $(self).find('.row').slideUp('fast');
          }).fail(function (data) {
            alert(data.responseJSON.message);
          });
        });
        
        /**
         * Healing
         */
        $('#formResetReputation').submit(function (e) {
          e.preventDefault();
          self = this;
          $(self).find('.error').slideUp('fast');
          $(self).find('.success').slideUp('fast');
        
          var data = $(self).serialize();
          var action = $(self).prop('action');
        
          $.post(action, data, function (data, textStatus, xhr) {
            result = ' <strong><a href="javascript:location.reload(true);">Clique aqui para recarregar a página</a></strong>';
            $(self).find('.success').html('A nova reputação do player estará disponível em alguns minutos.' + result);
            $(self).find('.success').slideDown('fast');
            $(self).find('.row').slideUp('fast');
          }).fail(function (data) {
            alert(data.responseJSON.message);
          });
        });
        
        /**
         * UnBan do player
         */
        $('#unBan').on('click', function (e) {
          e.preventDefault();
          var playerId = $(this).data('id');
          $.post('/admins/players/unban/' + playerId, function (data) {
            alert('O ban foi removido! Recarregando a página...');
            setTimeout(function () {
              location.reload(true);
            }, 2000);
          }).fail(function (data) {
            alert(data.responseJSON.message);
          });
        });
        
        /**
         * Remove um BAN da lobby.
         */
        $('#removeLobbyBan').on('click', function (e) {
          e.preventDefault();
          playerId = $(this).data('player-id');
          banId = $(this).data('ban-id');
          $.post('/players/removerBanLobby', { playerId: playerId, banId: banId }, function (data, textStatus, xhr) {
            if (data.success) {
              alert(data.message);
            } else {
              alert('Erro ao remover ban.');
            }
        
            setTimeout(function () {
              location.reload(true);
            }, 1500);
          });
        });
        
        /**
         * Convites de amizade
         */
        //  $('.conviteAmizade').on('click', function(e) {
        //   e.preventDefault();
        //   id     = $(this).data('id');
        //   status = $(this).data('status');
        
        //   if (status == 1)
        //     resposta = confirm(FRIEND_REQUEST_SEND_CONFIRM);
        //   else
        //     resposta = confirm(UNFRIEND_CONFIRM);
        
        
        //   if (resposta) {
        //     $.ajax({
        //       type: 'post',
        //       url: '/conta/convites/amizades',
        //       data: { cpID: id, cpAcao: status },
        //       success: function(msg) {
        //         if (msg == "Ok") {
        //           location.reload(true);
        //         } else {
        //           alert(FRIEND_ERROR);
        //         }
        //       },
        //       error: function(erro) { alert('error, try again.'); }
        //     });
        //   }
        // });
        
        /**
         * Editar capa e foto
         */
        $('#gcCoverMenubar [data-jsaction="editarCapa"]').on('click', function (e) {
          e.preventDefault();
          $('#editarCapaI').trigger('click');
        });
        
        $('#editarCapaI').change(function () {
          $('#editarCapaForm').submit();
        });
        
        $('#editarCapaForm').submit(function (e) {
          e.preventDefault();
          var data = new FormData(this);
          $.ajax({
            url: '/conta/perfil/atualizarCapa',
            type: 'POST',
            data: data,
            beforeSend: function () {
              alert('Alterando capa, aguarde...');
              $('#perfilCover').addClass('perfil-cover-loading');
            },
            success: function (data) {
              success(data);
              setTimeout(function () {
                location.reload(true);
              }, 1000);
            },
            error: function (data) {
              $('#perfilCover').removeClass('perfil-cover-loading');
              var message = (data.responseJSON) ? data.responseJSON.message : 'Ocorreu um erro ao enviar o avatar. Verifique o tamanho da imagem. Limite 1MB';
              alert(message);
            },
            cache: false,
            contentType: false,
            processData: false
          });
        
          return false;
        });
        
        $('#editarAvatar').on('click', function (e) {
          e.preventDefault();
          $('#editarAvatarI').trigger('click');
        });
        
        $('#editarAvatarI').change(function () {
          $('#editarAvatarForm').submit();
        });
        
        $('#editarAvatarForm').submit(function (e) {
          e.preventDefault();
          var data = new FormData($('#editarAvatarForm')[0]);
          $.ajax({
            url: '/conta/perfil/atualizarAvatarPC',
            type: 'POST',
            data: data,
            beforeSend: function () {
              $('#perfilAvatar').addClass('perfil-avatar-loading');
            },
            success: function (data) {
              success(data);
              setTimeout(function () {
                location.reload(true);
              }, 800);
            },
            error: function (data) {
              $('#perfilAvatar').removeClass('perfil-avatar-loading');
              var message = (data.responseJSON) ? data.responseJSON.message : 'Ocorreu um erro ao enviar o avatar. Verifique o tamanho da imagem. Limite 1MB';
              alert(message);
            },
            cache: false,
            contentType: false,
            processData: false
          });
        
          return false;
        });
        
        function bindClickToAtualizarAvatar() {
          $('#AtualizarAvatarSteam').on('click', atualizarAvatarSteam);
        }
        
        bindClickToAtualizarAvatar();
        
        function atualizarAvatarSteam(e) {
          e.preventDefault();
          $(this).off('click');
          $.ajax({
            type: 'get',
            url: '/conta/perfil/atualizarAvatarSteam',
            success: function (data) {
              success(data);
              setTimeout(function () {
                location.reload(true);
              }, 800);
            },
            error: function (data) {
              alert(ERROR_AVATAR);
              bindClickToAtualizarAvatar();
            }
          });
        }
        
        function bindClickToAlterarMoldura() {
          $('#AlterarMolduraAvatar').on('click', atualizarMolduraAvatar);
        }
        
        bindClickToAlterarMoldura();
        
        function atualizarMolduraAvatar(e) {
          e.preventDefault();
          window.reactFunctions.addWidget({
            name: 'coins',
            hideLoading: true,
            props: {
              openModalProps: {
                name: 'profileCustomizer',
                props: {
                  userId: $(this).data('id'),
                  avatar: $(this).data('avatar')
                }
              }
            }
          });
        }
        
        $(document).on('click', '.download-config', function (e) {
          e.preventDefault();
          e.stopPropagation();
        
          var playerId = $(this).data('id');
          var url = '/players/' + playerId + '/configs/' + $(this).data('config-id');
          $.ajax({
            url: url,
            type: 'GET',
            success: function (response) {
              window.location = response.data.download_link;
            },
            error: function (jqxhr) {
              alert(jqxhr.responseJSON.message);
            }
          });
        });
        
      }
    },
    assinaturas: {
      init: function () {
      }
    },
    lobbynova: {
      init: function () {
        
        // Sidebar do desafio
        var desafios_sidebar  = document.getElementById('sidebar-desafios-salas');
        // Desafios individuais
        var desafios          = desafios_sidebar.querySelectorAll('.sidebar-item');
        // Tooltip de desafio
        var desafio_tooltip   = document.getElementById('sidebar-desafios-team');
        // Slide de partidas recomendadas
        var recomendadaScroll = document.getElementById('lobby-scroll-recomendada');
        
        // Eventos do desafio
        var desafiosEvents = {
          over: function () {
            var team = document.querySelector('.sidebar-desafios-item-team');
            if (team === null) {
              return false;
            }
            // Distância do topo corrigida
            var top = $(this).offset().top - 312;
            // HTML interno da equipe
            var team_content = team.innerHTML;
            // Modificadores para pro, etc..
            var modifiers = team.getAttribute('data-modifiers');
        
            desafio_tooltip.style.top = top + 'px';
            desafio_tooltip.innerHTML = team_content;
            desafiosEvents.showTooltip(modifiers);
          },
          leave: function () {
            console.log('leave');
            desafiosEvents.hideTooltip();
          },
          showTooltip: function (modifiers) {
            desafio_tooltip.classList = desafio_tooltip.classList = modifiers;
            var lineup = desafio_tooltip.querySelector('.sala-lineup-players');
            $(lineup).scrollbar();
            lineup.addEventListener('scroll', function (e) {
              console.log('scroll');
              e.preventDefault();
            });
          },
          hideTooltip: function () {
            desafio_tooltip.classList = desafio_tooltip.classList.value.replace(
              'sidebar-desafios-team-active',
              'sidebar-desafios-team-inactive'
            );
          }
        };
        
        
        // Itera entre os desafios
        for (var i = desafios.length - 1; i >= 0; i--) {
          // Adiciona o evento mouse over no desafio
          desafios[i].addEventListener('mouseenter', desafiosEvents.over);
          // Adiciona o mouse leave do desafio
          desafios[i].addEventListener('mouseleave', desafiosEvents.leave);
        }
        
        // Transport layer
        window.lobbynova = {
          partidasRecomendadas: {
            next: function () {
              lobbynova.partidasRecomendadas.moveScroll(+232);
            },
            prev: function () {
              lobbynova.partidasRecomendadas.moveScroll(-232);
            },
            moveScroll: function (move, margin) {
              // Get card margin
              var card = recomendadaScroll.querySelector('.sala-card');
              var marginRight = window.getComputedStyle(card).marginRight.replace(/\D/g, '');
        
              // Se o movimento for negativo a margin também deve ser
              if (move < 0) {
                marginRight = -marginRight;
              }
        
              // Saldo do movimento
              var movement = recomendadaScroll.scrollLeft + move + Number(marginRight);
        
              if (movement < 0) {
                recomendadaScroll.scrollLeft = 0;
                return false;
              }
              recomendadaScroll.scrollLeft = movement;
            },
            esconder: function () {
              var recomendadas_container = document.getElementById('lobby-recomendadas-container');
        
              if (recomendadas_container.classList.value.indexOf('lobby-recomendadas-disabled') === -1) {
                recomendadas_container.classList.value += ' lobby-recomendadas-disabled';
              } else {
                recomendadas_container.classList.value.replace('lobby-recomendadas-disabled', '');
              }
        
            }
          }
        };
        
        
        $(function () {
          // Event bindings
          document.querySelector('[data-jsaction=recomendadasPrev]').addEventListener(
            'click',
            lobbynova.partidasRecomendadas.prev
          );
        
          document.querySelector('[data-jsaction=recomendadasNext]').addEventListener(
            'click',
            lobbynova.partidasRecomendadas.next
          );
        
          document.querySelector('[data-jsaction=recomendadasEsconder]').addEventListener(
            'click',
            lobbynova.partidasRecomendadas.esconder
          );
          
        });
        
      }
    },
    tournaments: {
      init: function () {
        function downloadDemo(gameid, matchid) {
          if (window.ISSUBSCRIBER) {
            sendGAEvent('Demos-sub', 'click', '[ASSINANTE] Click para baixar demo');
          } else {
            sendGAEvent('Demos-free', 'click', '[FREE] Click para baixar demo da partida');
          }
        
          if (matchid == null) matchid = '';
          $.getJSON('/lobby/demoDownload/' + gameid + '/' + matchid, function (json) {
            if (json.success == false) {
              noty({
                text: json.message
              });
            } else {
              window.location.href = json.demo;
            }
          });
        }
        
        function toggleMoreStatus(currentRow) {
          var nextRow = currentRow.nextElementSibling;
          var actionIcon = currentRow.querySelector('.tableMatch__actionColumn .fas');
        
          if (!nextRow || !actionIcon) return;
        
          if (nextRow.style.display === 'table-row') {
            actionIcon.classList.remove('fa-minus-circle');
            actionIcon.classList.add('fa-plus-circle');
        
            nextRow.style.display = 'none';
          } else {
            actionIcon.classList.remove('fa-plus-circle');
            actionIcon.classList.add('fa-minus-circle');
        
            nextRow.style.display = 'table-row';
          }
        }
        
        window.match = {
          downloadDemo: downloadDemo,
          toggleMoreStatus: toggleMoreStatus
        };
        
        $(function () {
          $.ajaxPrefilter(function (options, originalOptions, jqXHR) { options.async = true; });
        
          $(document).on('click', '.btn-vote .karma-sub-menu li:not(.karma-menu-description), .btn-vote.single-option, .UserFeedbackAnswer__item', function () {
            // adicionar classes e bordas nos cards
            $(this).closest('.karma-card').removeClass('thumbs-up thumbs-down');
            $(this).closest('.karma-card').addClass($(this).data('class'));
            $(this).closest('.karma-card').addClass('selected');
        
            // remove selecao anterior e adiciona nova
            $(this).closest('.karma-card').find('a').removeClass('selected-option');
            $(this).closest('a.btn-vote').addClass('selected-option');
        
            // remove labels de votacao e adiciona nova
            $(this).closest('.karma-card').find('.motivo').text('');
            $(this).closest('.karma-card').find('.motivo').text($(this).data('label'));
        
            // pega o id do player e atribui valor no input
            $id = $(this).closest('.karma-card').data('id');
            $('#player-' + $id).val($(this).data('value'));
        
            // esconde o menu
            $(this).closest('.karma-sub-menu').css('display', 'none');
        
            // verifica se tem valores selecionados
            var totals = $('input.karma-values').filter(function () {
              return $(this).val() != '';
            });
        
            // verifica se tem pesquisa de qualidade marcado
            totals += $('[name=quality]:checked').length;
        
            // exibe botao de "save"
            if (totals.length == 0) {
              $('.karmas-confirmation .btn').removeClass('btn-info');
              $('.karmas-confirmation .btn').addClass('btn-grey');
            } else {
              $('.karmas-confirmation .btn').removeClass('btn-grey');
              $('.karmas-confirmation .btn').addClass('btn-info');
            }
            if (totals.length > 0) {
              $('.karmas-confirmation').addClass('enabled');
              $('.karmas-confirmation span.reports').text(totals.length);
        
              if (totals.length > 1) {
                $('.karmas-confirmation span.plural').show();
              } else {
                $('.karmas-confirmation span.plural').hide();
              }
            } else {
              $('.karmas-confirmation span.plural').show();
            }
          });
        
          $(document).on('click', '.limpar-karma', function (e) {
            e.preventDefault();
            $('input.karma-values').val('');
            $('.karma-description').text('');
            $('.btn-vote').removeClass('selected-option');
            $('.btn-vote').removeClass('selected-option');
            $('.karma-card').removeClass('selected thumbs-down thumbs-up');
            $('.karmas-confirmation span.reports').text(0);
            $('.karmas-confirmation').removeClass('enabled');
          });
        
          $('#submit-karma-votes').on('click', function (e) {
            e.preventDefault();
        
            $('#karma-report').submit();
          });
        
          $('#karma-report').on('submit', function (e) {
            e.preventDefault();
        
            var $form = $(this);
            var url = $form.attr('action');
            var reports = [];
        
            var fields = $('input.karma-values').filter(function () {
              return $(this).val() != '';
            });
        
            for (i = 0; i < fields.length; i++) {
              field = fields[i];
              reports.push({
                player_id: $(field).data('id'),
                karma_type_id: $(field).val(),
                hasAnnotation: !!$(field).data('has-annotation')
              });
            }
        
            // Return user feedback answers
            var answerId = $form.find('.UserFeedbackAnswer input[name=answer_id]:checked').val();
            var questionId = $('#questionId').val();
            var feedback = { questionId: questionId, answerId: answerId };
        
            params = {
              partida_id: $(this).data('partida-id'),
              user_feedback: feedback,
              votos: reports
            };
        
            function postAnnotation(payload) {
              $.ajax({
                type: 'POST',
                url: '/api/players-annotations',
                contentType: 'application/json',
                data: JSON.stringify(payload)
              });
            }
        
            if (params.votos.length) {
              for (i = 0; i < params.votos.length; i++) {
                if (params.votos[i].karma_type_id !== '1' && !params.votos[i].hasAnnotation) {
                  var payload = {
                    annotatedPlayerId: params.votos[i].player_id,
                    rate: 0,
                    text: 'Você avaliou essa pessoa de forma negativa na partida ' + params.partida_id
                  };
                  postAnnotation(payload);
                }
              }
            }
        
            $.ajax({
              type: 'POST',
              url: url,
              contentType: 'application/json',
              data: JSON.stringify(params),
              success: function (data) {
                success(data);
                $('#karma-report').remove();
                $('.add-friends').show();
              },
              error: function () {
                noty({
                  text: 'Erro ao processar requisição. Verifique os dados e tente novamente.'
                });
              }
            });
          });
        });
        
      }
    },
    busca: {
      init: function () {
        // GCV1 - Assets
        var GCV1_ASSETS_URL = 'https://gcv1-assets.gamersclub.com.br/';
        
        //MOSTRA OU ESCONDE OS FILTROS DE JOGADORES DEPENDENDO DO CHECKBOX
        var checkbox_jogadores      = document.getElementById('search-filters-players');
        var checkbox_times          = document.getElementById('search-filters-teams');
        var skillLevel_range        = document.getElementById('current-level-filter');
        var select_medalhas         = document.querySelector('#medalhas');
        var select_patentes         = document.querySelector('#patentes');
        var checkbox_banido         = document.getElementById('search-filters-banned');
        
        //EVENT LISTENERS
        checkbox_jogadores.addEventListener('change', filter, false);
        checkbox_times.addEventListener('change', filter, false);
        checkbox_banido.addEventListener('change', filter, false);
        skillLevel_range.addEventListener('change', filter, false);
        $(select_medalhas).on('change', filter);
        $(select_patentes).on('change', filter);
        
        
        function filter() {
        
            var params;
                skillLevel = $("#skillLevel").text();
                skillLevel1 = $("#skillLevel1").text();
                skillLevel2 = $("#skillLevel2").text();
                f_jogadores = "";
                f_times = "";
                f_skillLevel = "";
                f_medalha = select_medalhas.value;
                f_patente = select_patentes.value;
        
            //MOSTRAR JOGADORES
            if(checkbox_jogadores.checked) {
                $(".search-filters-players").show();
        
                //MOSTRAR JOGADORES BANIDOS
                if(checkbox_banido.checked) {
                    f_jogadores = ".jogador";
                } else {
                    f_jogadores = ".jogador:not(.banido)";
                }
        
            } else {
                //ESCONDER JOGADORES
                $(".search-filters-players").hide();
                f_jogadores = ".mix:not(.jogador)";
            }
        
            //MOSTRAR TIMES
            if(checkbox_times.checked) {
                f_times = ", .time";
            } else {
                //ESCONDER TIMES
                f_times = ".mix:not(.time)" + f_jogadores;
            }
        
            //DEFINIÇÃO PADRÃO PARA EXIBIR
            //TODAS AS MEDALHAS E PATENTES
            if(select_medalhas.value == ".mix") {
                f_medalha = "";
            }
            if(select_patentes.value == ".mix") {
                f_patente = "";
            }
        
            var params;
            var virgula = ", ";
        
            //SKILL LEVEL
            if(skillLevel1 == skillLevel2) {
                f_skillLevel = f_jogadores + ".lvl-" + skillLevel + f_medalha + f_patente + " ";
        
                params = f_skillLevel;
        
            } else {
        
                //CONVERTE VALORES EM INTEGROS
                skillLevel1 = parseInt(skillLevel1);
                skillLevel2 = parseInt(skillLevel2);
        
                for (var i = skillLevel1; i <= skillLevel2; i++) {
                    
                    //SE FOR O ULTIMO RESULTADO,
                    //NAO INCLUI A VIRGULA
                    if(i == skillLevel2) {
                        virgula = "";
                    }
        
                    f_skillLevel += f_jogadores + ".lvl-" + i + f_medalha + f_patente + virgula;
                }
        
                //SE ESTIVER EXIBINDO TIME
                if(checkbox_times.checked) {
                    params = f_skillLevel +
                             f_times;
                } else {
                    params = f_skillLevel;
                }
                
            }
        
            mixer.filter(params);
        }
        
        //SLIDER DE RANGE DO FILTRO DE SKILL LEVEL
        $( "#slider-range" ).slider({
            range: true,
            min: 1,
            max: 21,
            values: [ 1, 21 ],
            create: function(event, ui) {
                //$( "#current-level-filter" ).html("<span id='skillLevel1'>1</span> - <span id='skillLevel2'>20</span>" );
            },
            slide: function( event, ui ) {
                if(ui.values[0] == ui.values[1]) {
                    $( "#current-level-filter" ).html("<span id='skillLevel'>" + ui.values[0] + "</span>");
                } else {
                    $( "#current-level-filter" ).html("<span id='skillLevel1'>" + ui.values[0] + "</span> - <span id='skillLevel2'>" + ui.values[1] + "</span>" );
                }
            },
            stop: function() {
                filter();
            }
        });
        
        //$( "#current-level-filter" ).html("<span id='skillLevel'>" + $( "#slider-range" ).slider( "values", 0 ) + "</span> - <span id='skillLevel2'>" + $( "#slider-range" ).slider( "values", 1 )  + "</span>");
        
        var dataMedalhas = [
            {
                id: '.mix',
                text: 'Todas',
                selected: true,
            },
            {
                id: '.medalha-1',
                text: 'Staff Gamers Club',
                url: GCV1_ASSETS_URL + 'images/medalhas/1.png',
            },
            {
                id: '.medalha-12',
                text: 'Staff Games Academy',
                url: GCV1_ASSETS_URL + 'images/medalhas/12.png',
            },
            {
                id: '.medalha-11',
                text: 'Assinante Premium',
                url: GCV1_ASSETS_URL + 'images/medalhas/11.png',
                value: '.blue'
            },
            {
                id: '.medalha-19',
                text: 'Assinante Plus',
                url: GCV1_ASSETS_URL + 'images/medalhas/19.png',
                value: '.blue'
            },
            {
                id: '.medalha-17',
                text: 'Assinante Argentina',
                url: GCV1_ASSETS_URL + 'images/medalhas/17.png',
                value: '.blue'
            },
        ]
        
        $("#medalhas").select2({
            placeholder: 'Escolha uma medalha',
            width: "100%",
            tags: false,
            multiple: false,
            data: dataMedalhas,
            templateResult: addMedalPicture,
            templateSelection: addMedalPicture,
            containerCssClass: "search-filter-select2",
            minimumResultsForSearch: -1
        });
        
        function addMedalPicture(data) {
            var $data;
            if(!data.url) {
                $data = $(
                '<span class="select2-option">' + data.text + '</span>'
                );
            } else {
                $data = $(
                '<span class="select2-option"><img src="' + data.url + '" width="20" /> ' + data.text + '</span>'
                );
            }
            return $data;
        };
        
        
        var dataPatentes = [
            {
                id: '.mix',
                text: 'Todas',
                selected: true
            },
            {
                id: '.sem-patente',
                text: 'Sem patente',
                url: GCV1_ASSETS_URL + 'assets/images/patentes/patenteless.png'
            },
            {
                id: '.patente-2',
                text: 'Bronze 3',
                url: GCV1_ASSETS_URL + 'assets/images/patentes/bronze_3.png'
            },
            {
                id: '.patente-3',
                text: 'Bronze 2',
                url: GCV1_ASSETS_URL + 'assets/images/patentes/bronze_2.png'
            },
            {
                id: '.patente-4',
                text: 'Bronze 1',
                url: GCV1_ASSETS_URL + 'assets/images/patentes/bronze_1.png'
            },
            {
                id: '.patente-5',
                text: 'Prata 3',
                url: GCV1_ASSETS_URL + 'assets/images/patentes/prata_3.png'
            },
            {
                id: '.patente-6',
                text: 'Prata 2',
                url: GCV1_ASSETS_URL + 'assets/images/patentes/prata_2.png'
            },
            {
                id: '.patente-7',
                text: 'Prata 1',
                url: GCV1_ASSETS_URL + 'assets/images/patentes/prata_1.png'
            },
            {
                id: '.patente-8',
                text: 'Ouro 3',
                url: GCV1_ASSETS_URL + 'assets/images/patentes/ouro_3.png'
            },
            {
                id: '.patente-9',
                text: 'Ouro 2',
                url: GCV1_ASSETS_URL + 'assets/images/patentes/ouro_2.png'
            },
            {
                id: '.patente-10',
                text: 'Ouro 1',
                url: GCV1_ASSETS_URL + 'assets/images/patentes/ouro_1.png'
            },
            {
                id: '.patente-11',
                text: 'Diamante',
                url: GCV1_ASSETS_URL + 'assets/images/patentes/diamante.png'
            },
            {
                id: '.patente-12',
                text: 'Lenda',
                url: GCV1_ASSETS_URL + 'assets/images/patentes/pro.png'
            },
        
        ]
        
        $("#patentes").select2({
            placeholder: 'Escolha uma patente',
            width: "100%",
            tags: false,
            multiple: false,
            data: dataPatentes,
            templateResult: addMedalPicture,
            templateSelection: addMedalPicture,
            containerCssClass: "search-filter-select2",
            minimumResultsForSearch: -1
        });
      }
    },
    premios: {
      init: function () {
        var filterTournamentData = $("#filterTournament").data('select-itens');
        $("#filterTournament").select2({
            placeholder: 'Escolha uma liga',
            width: "100%",
            tags: false,
            multiple: false,
            data: filterTournamentData,
            templateResult: addLigaLogo,
            templateSelection: addLigaLogo,
            minimumResultsForSearch: -1
        });
        $("#filterTournament").on('change', function() {
            var event_data = $(this).val().split('_');
            if (event_data.length > 1) {
                $('#filterEventId').val(event_data[1]);
                $('#filterType').val(event_data[0]);
            } else {
                $('#filterEventId').val(0);
                $('#filterType').val('todos');   
            }
        });
        $("#filterTournament").change();
        
        $("#filterMonth").select2({
            placeholder: 'Escolha um mês',
            width: "100%",
            tags: false,
            multiple: false,
            data: months,
            minimumResultsForSearch: -1
        });
        
        var filterTournamentYear = $("#filterYear").data('select-itens');
        for (var index = 0; index < filterTournamentYear.length; index++) {
            filterTournamentYear[index].selected = yearSelectedOnPrizes(filterTournamentYear[index].id);  
        }
        $("#filterYear").select2({
            placeholder: 'Escolha um ano',
            width: "100%",
            tags: false,
            multiple: false,
            data: filterTournamentYear,
            minimumResultsForSearch: -1
        });
        
        function addLigaLogo(data) {
            var $data;
            if(!data.url) {
                $data = $(
                '<span class="select2-option">' + data.text + '</span>'
                );
            } else {
                $data = $(
                '<span class="select2-option"><img src="' + data.url + '" width="35" /> ' + data.text + '</span>'
                );
            }
            return $data;
        };
        
        
        function yearSelectedOnPrizes (year)
        {
            return (year == yearSelected);
        }
      }
    },
    accountSettings: {
      init: function () {
        subscriptions = {
            cancellationSubscriptionId: 0,
            lastStepCancelation: 4,
        
            /** RECEIPT DETAIL */
            showReceiptDetail: function(type, id) {
                var receiptDetailTemplate;
        
                axios.get('/api/receipts/' + type + '/' + id)
                    .then(function(response) {
                        receiptDetailTemplate = document.getElementById('ReceiptDetailTemplate').innerHTML;
                        Mustache.parse(receiptDetailTemplate);
                        document.getElementById('ReceiptDetail-js').innerHTML = Mustache.render(receiptDetailTemplate, response.data);
                    })
                    .catch(function() {
                        receiptEmptyTemplate = document.getElementById('ReceiptEmptyTemplate').innerHTML;
                        Mustache.parse(receiptEmptyTemplate);
                        document.getElementById('ReceiptDetail-js').innerHTML = Mustache.render(receiptEmptyTemplate, { id: id });
                    })
                    .finally(function() {
                        document.getElementById('HistoryReceipt-js').style.display = 'none';
                        document.getElementById('ReceiptDetail-js').style.display = 'block';
        
                        document.getElementById('receiptAccountSettings').click();
        
                        subscriptions.scrollTopScreen();
                    });
            },
        
            hideReceiptDetail: function() {
                document.getElementById('HistoryReceipt-js').style.display = 'block';
                document.getElementById('ReceiptDetail-js').style.display = 'none';
        
                subscriptions.scrollTopScreen();
            },
        
            /** CANCELLATION PROCESS */
            confirmCancelSubscription: function(_id) {
                subscriptions.cancellationSubscriptionId = _id;
        
                axios.post('/api/subscription/cancel', { id: _id })
                    .then(function() {
                        subscriptions.changeSubscriptionCancellationStep(subscriptions.lastStepCancelation);
                    })
                    .catch(function(error) {
                        window.warning(error.response.data.message);
                    });
            },
        
            changeSubscriptionCancellationStep: function(step) {
                $('.SubscriptionCancellationStep').hide();
                $('.SubscriptionCancellationStep--step' + step).show();
        
                subscriptions.scrollTopScreen();
            },
        
            showSubscriptionCancellation: function() {
                $('.SubscriptionPage').hide();
                $('.SubscriptionCancellationPage').show();
        
                subscriptions.scrollTopScreen();
            },
        
            getSubscriptionId: function(subscriptionId) {
                $.ajax({
                    url: '/api/subscription/manage_url/' + subscriptionId,
                    type: 'GET',
                    success: function(response) {
                        window.open(response.manage_url);
                    },
                    error: function(error) {
                        window.error(error.responseJSON.message);
                    }
                });
            },
        
            cancelPendingBoleto: function(_id) {
                var confirmCancellation = window.confirm('Identificamos que você possui um pagamento pendente, deseja realmente cancelá-lo?');
                if (!confirmCancellation) {
                    return;
                }
        
                axios.post('/api/subscription/cancel', { id: _id })
                    .then(function() {
                        window.success('Boleto cancelado com sucesso!');
        
                        setTimeout(function() {
                            window.location.reload();
                        }, 3000);
                    })
                    .catch(function(error) {
                        window.warning(error.response.data.message);
                    });
            },
        
            hideSubscriptionCancellation: function() {
                $('.SubscriptionPage').show();
                $('.SubscriptionCancellationPage').hide();
        
                subscriptions.changeSubscriptionCancellationStep(1);
            },
        
            /** FORM CANCELLATION */
            renderFormCancellationFeedback: function(subscriptionId) {
                if (subscriptionId) {
                    subscriptions.cancellationSubscriptionId = subscriptionId;
                }
        
                if (!subscriptions.cancellationSubscriptionId) {
                    window.warning('Assinatura não informada');
                    return;
                }
        
                subscriptions.showOffboardingForm(0);
            },
        
            submitFormCancellationFeedback: function(event) {
                event.preventDefault();
        
                var form = event.target;
                var formId = form.dataset.formId;
                var formObject = {};
                var formSerialize = $(form).serializeArray();
        
                formObject.form = formId;
                formObject.subscriptionId = subscriptions.cancellationSubscriptionId;
        
                for (var i = 0; i < formSerialize.length; i += 1) {
                    var object = formSerialize[i];
        
                    var name = object.name;
                    var value = '';
        
                    if (name.endsWith('[]')) {
                        name = name.slice(0, -2);
        
                        prevValue = typeof formObject[name] !== 'undefined' ? formObject[name] : [];
                        value = prevValue.concat([object.value]);
                    } else {
                        value = object.value;
                    }
        
                    formObject[name] = value;
                }
        
                axios.post('/api/player/cancellation', formObject)
                    .then(function() {
                        // If it's the first form, render the next one according to the selection.
                        if (formObject.form === '0') {
                            subscriptions.showOffboardingForm(formObject.option);
                        } else {
                            subscriptions.renderSuccessCancellationFeedback();
                        }
                    })
                    .catch(function(error) {
                        window.warning(error.response.data.message);
                    });
            },
        
            renderSuccessCancellationFeedback: function() {
                $('.OffboardingFormPage').show();
                $('.SubscriptionPage').hide();
                $('.SubscriptionCancellationPage').hide();
        
                // Hide all forms
                $('form[data-form-id]').hide();
        
                // Show feedback success
                $('.OffboardingFeedbackSuccess').show();
        
                subscriptions.scrollTopScreen();
            },
        
            showOffboardingForm: function(formId) {
                $('.OffboardingFormPage').show();
                $('.SubscriptionPage').hide();
                $('.SubscriptionCancellationPage').hide();
        
                // Hide all forms
                $('form[data-form-id]').hide();
        
                // Show only current form
                $('form[data-form-id="' + formId + '"]').show();
        
                subscriptions.scrollTopScreen();
            },
        
            changeMotivationTextState: function(event) {
                var motivationTextInput = event.target.form.getElementsByClassName('js-motivationText');
        
                if (motivationTextInput.length === 1) {
                    motivationTextInput[0].disabled = !event.target.checked;
                }
            },
        
            /** HELPER */
            scrollTopScreen: function() {
                var bodyPage = $('html, body');
                var distanceTop = $('[tab-group="editarPerfil"]').position().top - 110;
                bodyPage.stop().animate({ scrollTop: distanceTop }, 300, 'swing');
            }
        
        };
      }
    },
    discover: {
      init: function () {
        /**
         * Discover
         */
        $('#discoverTabs .big-tabs-tab[data-tab]').click(function() {
            $('#discoverTabs .big-tabs-tab-enabled').removeClass('big-tabs-tab-enabled');
            $(this).addClass('big-tabs-tab-enabled');
        });
        
        var selectWithImage = {
            init: function (element) {
                $(element).select2({
                    width: "100%",
                    templateResult: selectWithImage.format,
                    templateSelection: selectWithImage.format,
                    escapeMarkup: function(m) { return m; }
                });
            },
        
            format: function  (item) {
                var originalOption = item.element;
                var image   = $(originalOption).data('image');
                var id      = $(originalOption).data('id');
        
                if (typeof originalOption != 'object' || originalOption == null || originalOption == undefined) {
                    return false;
                }
        
                var opt = "<span class='select2-with-extra-padding select2-flex-item'>";
                if (image) {
                    opt += "<img class='select2-withimage-image' src='" + image + "'/> ";
                }
                opt +=  "<span class='select2-withimage-text'>" + item.text + "</span></span>";
        
                return opt;
            }
        };
        
      }
    },
    reactFunctions: {
      init: function () {
        //= require index.js
        //= require modals.js
        //= require widgets.js
        //= require custom-events.js
        //= require general.js
        //= require toasters.js
        //= require snackbars.js
      }
    }

  };
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var namespace = Roots;
      funcname = (funcname === undefined) ? 'init' : funcname;
      if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      UTIL.fire('common');

      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
      });
    }
  };

  $(document).ready(UTIL.loadEvents);
}(jQuery)); // Fully reference jQuery after this point.
